import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { warning } from '@commercetools-uikit/utils';
import { useTheme, ClassNames, css } from '@emotion/react';
import { customProperties } from '@commercetools-uikit/design-system';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

function ownKeys$1U(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1U(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1U(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1U(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1U = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1U = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1U[size], "px"),
        height: "".concat(iconSizes$1U[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1U.big, "px"),
        height: "".concat(iconSizes$1U.big, "px")
      };
  }
};

var getSizeStyle$1U = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1U(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1U = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1U(_objectSpread$1U({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1U = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1U(props.color, theme), ";}&,image{", getSizeStyle$1U(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgAngleDown = function SvgAngleDown(props) {
  return jsx("svg", _objectSpread$1U(_objectSpread$1U({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.816 8.115l-.902-.909a.567.567 0 00-.415-.182.567.567 0 00-.414.182l-7.087 7.147L4.91 7.206a.567.567 0 00-.414-.181.567.567 0 00-.415.181l-.902.91a.576.576 0 000 .836l8.403 8.474c.12.12.259.182.415.182.156 0 .294-.061.414-.182l8.404-8.474a.577.577 0 000-.837z",
      fillRule: "evenodd"
    })
  }));
};

SvgAngleDown.displayName = 'SvgAngleDown';

var AngleDownIcon = function AngleDownIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgAngleDown, _objectSpread$1U(_objectSpread$1U({}, props), {}, {
        className: createClass(getIconStyles$1U(props, theme))
      }));
    }
  });
};

AngleDownIcon.displayName = 'AngleDownIcon';
var AngleDownIcon$1 = AngleDownIcon;

function ownKeys$1T(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1T(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1T(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1T(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1T = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1T = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1T[size], "px"),
        height: "".concat(iconSizes$1T[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1T.big, "px"),
        height: "".concat(iconSizes$1T.big, "px")
      };
  }
};

var getSizeStyle$1T = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1T(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1T = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1T(_objectSpread$1T({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1T = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1T(props.color, theme), ";}&,image{", getSizeStyle$1T(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgAngleLeft = function SvgAngleLeft(props) {
  return jsx("svg", _objectSpread$1T(_objectSpread$1T({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.198 21.11l.91-.902a.567.567 0 00.181-.415.567.567 0 00-.182-.414l-7.146-7.087 7.146-7.087a.567.567 0 00.182-.415.567.567 0 00-.182-.414l-.909-.902a.576.576 0 00-.836 0l-8.474 8.403a.568.568 0 00-.182.415c0 .156.06.294.182.414l8.474 8.404a.577.577 0 00.836 0z",
      fillRule: "evenodd"
    })
  }));
};

SvgAngleLeft.displayName = 'SvgAngleLeft';

var AngleLeftIcon = function AngleLeftIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgAngleLeft, _objectSpread$1T(_objectSpread$1T({}, props), {}, {
        className: createClass(getIconStyles$1T(props, theme))
      }));
    }
  });
};

AngleLeftIcon.displayName = 'AngleLeftIcon';
var AngleLeftIcon$1 = AngleLeftIcon;

function ownKeys$1S(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1S(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1S(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1S(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1S = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1S = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1S[size], "px"),
        height: "".concat(iconSizes$1S[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1S.big, "px"),
        height: "".concat(iconSizes$1S.big, "px")
      };
  }
};

var getSizeStyle$1S = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1S(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1S = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1S(_objectSpread$1S({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1S = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1S(props.color, theme), ";}&,image{", getSizeStyle$1S(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFuZ2xlUmlnaHRSZWFjdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0hnRSIsImZpbGUiOiJBbmdsZVJpZ2h0UmVhY3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLy8gVEhJUyBJUyBBTiBBVVRPR0VORVJBVEVEIEZJTEUuIERPIE5PVCBFRElUIFRISVMgRklMRSBESVJFQ1RMWS5cbi8vIFRoaXMgZmlsZSBpcyBjcmVhdGVkIHdpdGggJ3lhcm4gZ2VuZXJhdGUtaWNvbnMnLlxuLy8gT3JpZ2luYWwgU1ZHIGZpbGU6IHNyYy9zdmcvYW5nbGUtcmlnaHQucmVhY3Quc3ZnXG5cbi8qIGVzbGludC1kaXNhYmxlIEB0eXBlc2NyaXB0LWVzbGludC9uby11bnVzZWQtdmFycyAqL1xuaW1wb3J0IHR5cGUgeyBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IHdhcm5pbmcgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC91dGlscyc7XG5pbXBvcnQgeyBjc3MsIENsYXNzTmFtZXMsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5leHBvcnQgdHlwZSBQcm9wcyA9IHtcbiAgY29sb3I/OlxuICAgIHwgJ3NvbGlkJ1xuICAgIHwgJ25ldXRyYWw2MCdcbiAgICB8ICdzdXJmYWNlJ1xuICAgIHwgJ2luZm8nXG4gICAgfCAncHJpbWFyeSdcbiAgICB8ICdwcmltYXJ5NDAnXG4gICAgfCAnd2FybmluZydcbiAgICB8ICdlcnJvcic7XG4gIHNpemU/OiAnc21hbGwnIHwgJ21lZGl1bScgfCAnYmlnJyB8ICdzY2FsZSc7XG59O1xuZXhwb3J0IHR5cGUgU1ZHUHJvcHMgPSBQcm9wcyAmIHtcbiAgY2xhc3NOYW1lOiBzdHJpbmc7XG59O1xuY29uc3QgaWNvblNpemVzID0ge1xuICBzbWFsbDogMTIsXG4gIG1lZGl1bTogMTYsXG4gIGJpZzogMjQsXG59IGFzIGNvbnN0O1xuXG5jb25zdCBnZXRTaXplRGltZW5zaW9ucyA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ3NjYWxlJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICAgIGhlaWdodDogJ2F1dG8nLFxuICAgICAgfTtcblxuICAgIGNhc2UgJ3NtYWxsJzpcbiAgICBjYXNlICdtZWRpdW0nOlxuICAgIGNhc2UgJ2JpZyc6XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogYCR7aWNvblNpemVzW3NpemVdfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgfTtcblxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogYCR7aWNvblNpemVzLmJpZ31weGAsXG4gICAgICAgIGhlaWdodDogYCR7aWNvblNpemVzLmJpZ31weGAsXG4gICAgICB9O1xuICB9XG59O1xuXG5jb25zdCBnZXRTaXplU3R5bGUgPSAoc2l6ZTogUHJvcHNbJ3NpemUnXSkgPT4ge1xuICBjb25zdCBkaW1lbnNpb25zID0gZ2V0U2l6ZURpbWVuc2lvbnMoc2l6ZSk7XG5cbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgJjpub3QoOnJvb3QpIHtcbiAgICAgICAgICB3aWR0aDogJHtkaW1lbnNpb25zLndpZHRofTtcbiAgICAgICAgICBoZWlnaHQ6ICR7ZGltZW5zaW9ucy5oZWlnaHR9O1xuICAgICAgICB9XG4gICAgICBgO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBgXG4gICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICBoZWlnaHQ6ICR7ZGltZW5zaW9ucy5oZWlnaHR9O1xuICAgICAgYDtcbiAgfVxufTtcblxuY29uc3QgZ2V0Q29sb3IgPSAoY29sb3I6IFByb3BzWydjb2xvciddLCB0aGVtZTogVGhlbWUpID0+IHtcbiAgaWYgKCFjb2xvcikgcmV0dXJuICdpbmhlcml0JztcbiAgY29uc3Qgb3ZlcndyaXR0ZW5WYXJzID0geyAuLi52YXJzLCAuLi50aGVtZSB9O1xuICBsZXQgaWNvbkNvbG9yO1xuXG4gIHN3aXRjaCAoY29sb3IpIHtcbiAgICBjYXNlICdzb2xpZCc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JTb2xpZDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnbmV1dHJhbDYwJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvck5ldXRyYWw2MDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnc3VyZmFjZSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JTdXJmYWNlO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdpbmZvJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckluZm87XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ3ByaW1hcnknOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeTQwJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclByaW1hcnk0MDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnd2FybmluZyc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JXYXJuaW5nO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdlcnJvcic6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JFcnJvcjtcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgaWYgKCFpY29uQ29sb3IpIHtcbiAgICB3YXJuaW5nKFxuICAgICAgY29sb3IsXG4gICAgICBgdWkta2l0L0ljb246IHRoZSBzcGVjaWZpZWQgY29sb3IgJyR7Y29sb3J9JyBpcyBub3Qgc3VwcG9ydGVkLmBcbiAgICApO1xuICAgIHJldHVybiAnaW5oZXJpdCc7XG4gIH1cblxuICByZXR1cm4gaWNvbkNvbG9yO1xufTtcblxuZXhwb3J0IGNvbnN0IGdldEljb25TdHlsZXMgPSAocHJvcHM6IFByb3BzLCB0aGVtZTogVGhlbWUpID0+IGNzc2BcbiAgKjpub3QoW2ZpbGw9J25vbmUnXSkge1xuICAgIGZpbGw6ICR7Z2V0Q29sb3IocHJvcHMuY29sb3IsIHRoZW1lKX07XG4gIH1cbiAgJixcbiAgaW1hZ2Uge1xuICAgICR7Z2V0U2l6ZVN0eWxlKHByb3BzLnNpemUpfTtcbiAgfVxuICBmbGV4LXNocmluazogMDtcbmA7XG5cbmNvbnN0IFN2Z0FuZ2xlUmlnaHQgPSAocHJvcHM6IFNWR1Byb3BzKSA9PiAoXG4gIDxzdmdcbiAgICB3aWR0aD17MjR9XG4gICAgaGVpZ2h0PXsyNH1cbiAgICB2aWV3Qm94PVwiMCAwIDI0IDI0XCJcbiAgICB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCJcbiAgICB7Li4ucHJvcHN9XG4gID5cbiAgICA8cGF0aFxuICAgICAgZD1cIk04LjA5MSAzLjE4bC0uOTEuOTAxQS41NjcuNTY3IDAgMDA3IDQuNDk2YzAgLjE1Ni4wNi4yOTUuMTgyLjQxNWw3LjE0NiA3LjA4Ny03LjE0NiA3LjA4NkEuNTY3LjU2NyAwIDAwNyAxOS41YzAgLjE1Ni4wNi4yOTUuMTgyLjQxNWwuOTEuOTAxYS41NzYuNTc2IDAgMDAuODM2IDBsOC40NzMtOC40MDNhLjU2OC41NjggMCAwMC4xODItLjQxNC41NjcuNTY3IDAgMDAtLjE4Mi0uNDE1TDguOTI4IDMuMThhLjU3Ny41NzcgMCAwMC0uODM3IDB6XCJcbiAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5TdmdBbmdsZVJpZ2h0LmRpc3BsYXlOYW1lID0gJ1N2Z0FuZ2xlUmlnaHQnO1xuXG5jb25zdCBBbmdsZVJpZ2h0SWNvbiA9IChwcm9wczogUHJvcHMpID0+IHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICByZXR1cm4gKFxuICAgIDxDbGFzc05hbWVzPlxuICAgICAgeyh7IGNzczogY3JlYXRlQ2xhc3MgfSkgPT4gKFxuICAgICAgICA8U3ZnQW5nbGVSaWdodFxuICAgICAgICAgIHsuLi5wcm9wc31cbiAgICAgICAgICBjbGFzc05hbWU9e2NyZWF0ZUNsYXNzKGdldEljb25TdHlsZXMocHJvcHMsIHRoZW1lKSl9XG4gICAgICAgIC8+XG4gICAgICApfVxuICAgIDwvQ2xhc3NOYW1lcz5cbiAgKTtcbn07XG5cbkFuZ2xlUmlnaHRJY29uLmRpc3BsYXlOYW1lID0gJ0FuZ2xlUmlnaHRJY29uJztcbmV4cG9ydCBkZWZhdWx0IEFuZ2xlUmlnaHRJY29uO1xuIl19 */");
};

var SvgAngleRight = function SvgAngleRight(props) {
  return jsx("svg", _objectSpread$1S(_objectSpread$1S({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M8.091 3.18l-.91.901A.567.567 0 007 4.496c0 .156.06.295.182.415l7.146 7.087-7.146 7.086A.567.567 0 007 19.5c0 .156.06.295.182.415l.91.901a.576.576 0 00.836 0l8.473-8.403a.568.568 0 00.182-.414.567.567 0 00-.182-.415L8.928 3.18a.577.577 0 00-.837 0z",
      fillRule: "evenodd"
    })
  }));
};

SvgAngleRight.displayName = 'SvgAngleRight';

var AngleRightIcon = function AngleRightIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgAngleRight, _objectSpread$1S(_objectSpread$1S({}, props), {}, {
        className: createClass(getIconStyles$1S(props, theme))
      }));
    }
  });
};

AngleRightIcon.displayName = 'AngleRightIcon';
var AngleRightIcon$1 = AngleRightIcon;

function ownKeys$1R(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1R(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1R(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1R(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1R = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1R = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1R[size], "px"),
        height: "".concat(iconSizes$1R[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1R.big, "px"),
        height: "".concat(iconSizes$1R.big, "px")
      };
  }
};

var getSizeStyle$1R = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1R(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1R = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1R(_objectSpread$1R({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1R = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1R(props.color, theme), ";}&,image{", getSizeStyle$1R(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgAngleThinLeft = function SvgAngleThinLeft(props) {
  return jsx("svg", _objectSpread$1R(_objectSpread$1R({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.336 20.888c-.117 0-.195-.038-.273-.15l-8.634-8.25a.353.353 0 010-.525l8.633-8.288c.157-.15.391-.15.547 0a.353.353 0 010 .525L8.25 12.225l8.36 7.988a.353.353 0 010 .525.342.342 0 01-.274.15z",
      fillRule: "evenodd"
    })
  }));
};

SvgAngleThinLeft.displayName = 'SvgAngleThinLeft';

var AngleThinLeftIcon = function AngleThinLeftIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgAngleThinLeft, _objectSpread$1R(_objectSpread$1R({}, props), {}, {
        className: createClass(getIconStyles$1R(props, theme))
      }));
    }
  });
};

AngleThinLeftIcon.displayName = 'AngleThinLeftIcon';
var AngleThinLeftIcon$1 = AngleThinLeftIcon;

function ownKeys$1Q(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1Q(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1Q(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1Q(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1Q = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1Q = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1Q[size], "px"),
        height: "".concat(iconSizes$1Q[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1Q.big, "px"),
        height: "".concat(iconSizes$1Q.big, "px")
      };
  }
};

var getSizeStyle$1Q = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1Q(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1Q = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1Q(_objectSpread$1Q({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1Q = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1Q(props.color, theme), ";}&,image{", getSizeStyle$1Q(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgAngleThinRight = function SvgAngleThinRight(props) {
  return jsx("svg", _objectSpread$1Q(_objectSpread$1Q({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M7.39 3c.118 0 .196.038.274.15l8.633 8.25a.353.353 0 010 .525l-8.633 8.288a.389.389 0 01-.547 0 .353.353 0 010-.525l8.36-8.025-8.36-7.988a.353.353 0 010-.525.342.342 0 01.274-.15z",
      fillRule: "evenodd"
    })
  }));
};

SvgAngleThinRight.displayName = 'SvgAngleThinRight';

var AngleThinRightIcon = function AngleThinRightIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgAngleThinRight, _objectSpread$1Q(_objectSpread$1Q({}, props), {}, {
        className: createClass(getIconStyles$1Q(props, theme))
      }));
    }
  });
};

AngleThinRightIcon.displayName = 'AngleThinRightIcon';
var AngleThinRightIcon$1 = AngleThinRightIcon;

function ownKeys$1P(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1P(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1P(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1P(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1P = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1P = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1P[size], "px"),
        height: "".concat(iconSizes$1P[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1P.big, "px"),
        height: "".concat(iconSizes$1P.big, "px")
      };
  }
};

var getSizeStyle$1P = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1P(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1P = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1P(_objectSpread$1P({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1P = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1P(props.color, theme), ";}&,image{", getSizeStyle$1P(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgAngleUpDown = function SvgAngleUpDown(props) {
  return jsx("svg", _objectSpread$1P(_objectSpread$1P({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fill: "#1A1A1A",
      fillRule: "evenodd",
      children: jsx("path", {
        d: "M23.84 19.142l-.801-.86a.491.491 0 00-.37-.171.49.49 0 00-.368.172l-6.3 6.752-6.302-6.752a.491.491 0 00-.368-.172.49.49 0 00-.37.172l-.8.859a.562.562 0 00-.161.395c0 .149.054.28.16.395l7.471 8.007c.107.115.23.172.37.172a.49.49 0 00.368-.172l7.471-8.007a.562.562 0 00.16-.395.563.563 0 00-.16-.395zM23.84 12.97l-.801.858a.491.491 0 01-.37.172.49.49 0 01-.368-.172l-6.3-6.752-6.302 6.752a.491.491 0 01-.368.172.49.49 0 01-.37-.172l-.8-.86A.562.562 0 018 12.575c0-.15.054-.28.16-.395l7.471-8.007a.491.491 0 01.37-.172.49.49 0 01.368.172l7.471 8.007c.107.114.16.246.16.395 0 .149-.053.28-.16.395z"
      })
    })
  }));
};

SvgAngleUpDown.displayName = 'SvgAngleUpDown';

var AngleUpDownIcon = function AngleUpDownIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgAngleUpDown, _objectSpread$1P(_objectSpread$1P({}, props), {}, {
        className: createClass(getIconStyles$1P(props, theme))
      }));
    }
  });
};

AngleUpDownIcon.displayName = 'AngleUpDownIcon';
var AngleUpDownIcon$1 = AngleUpDownIcon;

function ownKeys$1O(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1O(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1O(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1O(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1O = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1O = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1O[size], "px"),
        height: "".concat(iconSizes$1O[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1O.big, "px"),
        height: "".concat(iconSizes$1O.big, "px")
      };
  }
};

var getSizeStyle$1O = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1O(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1O = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1O(_objectSpread$1O({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1O = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1O(props.color, theme), ";}&,image{", getSizeStyle$1O(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgAngleUp = function SvgAngleUp(props) {
  return jsx("svg", _objectSpread$1O(_objectSpread$1O({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M3.18 16.817l.901.94c.12.125.259.188.415.188a.558.558 0 00.415-.188l7.087-7.39 7.086 7.39c.12.125.259.188.415.188a.559.559 0 00.415-.188l.901-.94a.606.606 0 000-.866l-8.403-8.763A.56.56 0 0011.998 7a.558.558 0 00-.415.188L3.18 15.951a.607.607 0 000 .866z",
      fillRule: "evenodd"
    })
  }));
};

SvgAngleUp.displayName = 'SvgAngleUp';

var AngleUpIcon = function AngleUpIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgAngleUp, _objectSpread$1O(_objectSpread$1O({}, props), {}, {
        className: createClass(getIconStyles$1O(props, theme))
      }));
    }
  });
};

AngleUpIcon.displayName = 'AngleUpIcon';
var AngleUpIcon$1 = AngleUpIcon;

function ownKeys$1N(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1N(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1N(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1N(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1N = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1N = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1N[size], "px"),
        height: "".concat(iconSizes$1N[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1N.big, "px"),
        height: "".concat(iconSizes$1N.big, "px")
      };
  }
};

var getSizeStyle$1N = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1N(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1N = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1N(_objectSpread$1N({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1N = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1N(props.color, theme), ";}&,image{", getSizeStyle$1N(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrowDown = function SvgArrowDown(props) {
  return jsx("svg", _objectSpread$1N(_objectSpread$1N({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M18.259 14.56H13.555V4.432c0-.79-.66-1.431-1.474-1.431-.813 0-1.473.64-1.473 1.431v10.13H5.784L12.08 21l6.178-6.44z",
      fillRule: "evenodd"
    })
  }));
};

SvgArrowDown.displayName = 'SvgArrowDown';

var ArrowDownIcon = function ArrowDownIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrowDown, _objectSpread$1N(_objectSpread$1N({}, props), {}, {
        className: createClass(getIconStyles$1N(props, theme))
      }));
    }
  });
};

ArrowDownIcon.displayName = 'ArrowDownIcon';
var ArrowDownIcon$1 = ArrowDownIcon;

function ownKeys$1M(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1M(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1M(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1M(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1M = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1M = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1M[size], "px"),
        height: "".concat(iconSizes$1M[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1M.big, "px"),
        height: "".concat(iconSizes$1M.big, "px")
      };
  }
};

var getSizeStyle$1M = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1M(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1M = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1M(_objectSpread$1M({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1M = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1M(props.color, theme), ";}&,image{", getSizeStyle$1M(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrowLeft = function SvgArrowLeft(props) {
  return jsx("svg", _objectSpread$1M(_objectSpread$1M({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M9.44 18.475V13.771h10.129c.79 0 1.431-.66 1.431-1.473 0-.814-.64-1.474-1.431-1.474H9.439V6L3 12.298l6.44 6.177z",
      fillRule: "evenodd"
    })
  }));
};

SvgArrowLeft.displayName = 'SvgArrowLeft';

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrowLeft, _objectSpread$1M(_objectSpread$1M({}, props), {}, {
        className: createClass(getIconStyles$1M(props, theme))
      }));
    }
  });
};

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var ArrowLeftIcon$1 = ArrowLeftIcon;

function ownKeys$1L(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1L(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1L(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1L(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1L = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1L = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1L[size], "px"),
        height: "".concat(iconSizes$1L[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1L.big, "px"),
        height: "".concat(iconSizes$1L.big, "px")
      };
  }
};

var getSizeStyle$1L = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1L(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1L = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1L(_objectSpread$1L({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1L = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1L(props.color, theme), ";}&,image{", getSizeStyle$1L(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrowLongDown = function SvgArrowLongDown(props) {
  return jsx("svg", _objectSpread$1L(_objectSpread$1L({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M15.494 17.318H12.875v-13.5a.82.82 0 00-1.64 0v13.5H8.547L12.055 21l3.44-3.682z",
      fillRule: "evenodd"
    })
  }));
};

SvgArrowLongDown.displayName = 'SvgArrowLongDown';

var ArrowLongDownIcon = function ArrowLongDownIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrowLongDown, _objectSpread$1L(_objectSpread$1L({}, props), {}, {
        className: createClass(getIconStyles$1L(props, theme))
      }));
    }
  });
};

ArrowLongDownIcon.displayName = 'ArrowLongDownIcon';
var ArrowLongDownIcon$1 = ArrowLongDownIcon;

function ownKeys$1K(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1K(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1K(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1K(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1K = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1K = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1K[size], "px"),
        height: "".concat(iconSizes$1K[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1K.big, "px"),
        height: "".concat(iconSizes$1K.big, "px")
      };
  }
};

var getSizeStyle$1K = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1K(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1K = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1K(_objectSpread$1K({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1K = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1K(props.color, theme), ";}&,image{", getSizeStyle$1K(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrowRight = function SvgArrowRight(props) {
  return jsx("svg", _objectSpread$1K(_objectSpread$1K({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M14.56 6V10.704H4.432c-.79 0-1.431.66-1.431 1.473 0 .814.64 1.474 1.431 1.474h10.13v4.824L21 12.177 14.56 6z",
      fillRule: "evenodd"
    })
  }));
};

SvgArrowRight.displayName = 'SvgArrowRight';

var ArrowRightIcon = function ArrowRightIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrowRight, _objectSpread$1K(_objectSpread$1K({}, props), {}, {
        className: createClass(getIconStyles$1K(props, theme))
      }));
    }
  });
};

ArrowRightIcon.displayName = 'ArrowRightIcon';
var ArrowRightIcon$1 = ArrowRightIcon;

function ownKeys$1J(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1J(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1J(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1J(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1J = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1J = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1J[size], "px"),
        height: "".concat(iconSizes$1J[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1J.big, "px"),
        height: "".concat(iconSizes$1J.big, "px")
      };
  }
};

var getSizeStyle$1J = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1J(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1J = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1J(_objectSpread$1J({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1J = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1J(props.color, theme), ";}&,image{", getSizeStyle$1J(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrowTriangleDown = function SvgArrowTriangleDown(props) {
  return jsx("svg", _objectSpread$1J(_objectSpread$1J({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12 20L3 5h18",
      fillRule: "evenodd"
    })
  }));
};

SvgArrowTriangleDown.displayName = 'SvgArrowTriangleDown';

var ArrowTriangleDownIcon = function ArrowTriangleDownIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrowTriangleDown, _objectSpread$1J(_objectSpread$1J({}, props), {}, {
        className: createClass(getIconStyles$1J(props, theme))
      }));
    }
  });
};

ArrowTriangleDownIcon.displayName = 'ArrowTriangleDownIcon';
var ArrowTriangleDownIcon$1 = ArrowTriangleDownIcon;

function ownKeys$1I(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1I(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1I(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1I(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1I = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1I = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1I[size], "px"),
        height: "".concat(iconSizes$1I[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1I.big, "px"),
        height: "".concat(iconSizes$1I.big, "px")
      };
  }
};

var getSizeStyle$1I = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1I(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1I = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1I(_objectSpread$1I({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1I = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1I(props.color, theme), ";}&,image{", getSizeStyle$1I(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrowTriangleUp = function SvgArrowTriangleUp(props) {
  return jsx("svg", _objectSpread$1I(_objectSpread$1I({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12 4l9 15H3",
      fillRule: "evenodd"
    })
  }));
};

SvgArrowTriangleUp.displayName = 'SvgArrowTriangleUp';

var ArrowTriangleUpIcon = function ArrowTriangleUpIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrowTriangleUp, _objectSpread$1I(_objectSpread$1I({}, props), {}, {
        className: createClass(getIconStyles$1I(props, theme))
      }));
    }
  });
};

ArrowTriangleUpIcon.displayName = 'ArrowTriangleUpIcon';
var ArrowTriangleUpIcon$1 = ArrowTriangleUpIcon;

function ownKeys$1H(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1H(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1H(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1H(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1H = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1H = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1H[size], "px"),
        height: "".concat(iconSizes$1H[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1H.big, "px"),
        height: "".concat(iconSizes$1H.big, "px")
      };
  }
};

var getSizeStyle$1H = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1H(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1H = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1H(_objectSpread$1H({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1H = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1H(props.color, theme), ";}&,image{", getSizeStyle$1H(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrowUp = function SvgArrowUp(props) {
  return jsx("svg", _objectSpread$1H(_objectSpread$1H({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M5.784 9.44H10.488v10.129c0 .79.66 1.431 1.473 1.431.814 0 1.473-.64 1.473-1.431V9.439h4.825L11.96 3 5.784 9.44z",
      fillRule: "evenodd"
    })
  }));
};

SvgArrowUp.displayName = 'SvgArrowUp';

var ArrowUpIcon = function ArrowUpIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrowUp, _objectSpread$1H(_objectSpread$1H({}, props), {}, {
        className: createClass(getIconStyles$1H(props, theme))
      }));
    }
  });
};

ArrowUpIcon.displayName = 'ArrowUpIcon';
var ArrowUpIcon$1 = ArrowUpIcon;

function ownKeys$1G(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1G(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1G(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1G(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1G = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1G = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1G[size], "px"),
        height: "".concat(iconSizes$1G[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1G.big, "px"),
        height: "".concat(iconSizes$1G.big, "px")
      };
  }
};

var getSizeStyle$1G = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1G(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1G = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1G(_objectSpread$1G({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1G = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1G(props.color, theme), ";}&,image{", getSizeStyle$1G(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgArrows = function SvgArrows(props) {
  return jsx("svg", _objectSpread$1G(_objectSpread$1G({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M21 12l-3.375-3.375v2.25h-4.5v-4.5h2.25L12 3 8.625 6.375h2.25v4.5h-4.5v-2.25L3 12l3.375 3.375v-2.25h4.5v4.5h-2.25L12 21l3.375-3.375h-2.25v-4.5h4.5v2.25",
      fillRule: "evenodd"
    })
  }));
};

SvgArrows.displayName = 'SvgArrows';

var ArrowsIcon = function ArrowsIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgArrows, _objectSpread$1G(_objectSpread$1G({}, props), {}, {
        className: createClass(getIconStyles$1G(props, theme))
      }));
    }
  });
};

ArrowsIcon.displayName = 'ArrowsIcon';
var ArrowsIcon$1 = ArrowsIcon;

function ownKeys$1F(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1F(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1F(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1F(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1F = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1F = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1F[size], "px"),
        height: "".concat(iconSizes$1F[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1F.big, "px"),
        height: "".concat(iconSizes$1F.big, "px")
      };
  }
};

var getSizeStyle$1F = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1F(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1F = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1F(_objectSpread$1F({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1F = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1F(props.color, theme), ";}&,image{", getSizeStyle$1F(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgBack = function SvgBack(props) {
  return jsx("svg", _objectSpread$1F(_objectSpread$1F({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M19.862 10.922H7.25l5.82-5.906-1.478-1.454-8.269 8.392 8.27 8.437 1.478-1.5-5.821-5.86h12.612",
      fillRule: "evenodd"
    })
  }));
};

SvgBack.displayName = 'SvgBack';

var BackIcon = function BackIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgBack, _objectSpread$1F(_objectSpread$1F({}, props), {}, {
        className: createClass(getIconStyles$1F(props, theme))
      }));
    }
  });
};

BackIcon.displayName = 'BackIcon';
var BackIcon$1 = BackIcon;

function ownKeys$1E(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1E(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1E(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1E(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1E = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1E = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1E[size], "px"),
        height: "".concat(iconSizes$1E[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1E.big, "px"),
        height: "".concat(iconSizes$1E.big, "px")
      };
  }
};

var getSizeStyle$1E = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1E(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1E = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1E(_objectSpread$1E({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1E = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1E(props.color, theme), ";}&,image{", getSizeStyle$1E(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgBidirectionalArrow = function SvgBidirectionalArrow(props) {
  return jsx("svg", _objectSpread$1E(_objectSpread$1E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      fillRule: "evenodd",
      d: "M12 10.05h-1V8.41h1v1.64zm-2 0H9V8.41h1v1.64zm-2 0H7V8.41h1v1.64zm-2 1.983l-1-.935V7.325l1-.952v5.66zm-2-1.869L3 9.23l1-.952v1.886zm13.318.517L21 14.121l-3.682 3.506v-2.686h-5.5a.82.82 0 010-1.64h5.5v-2.62z"
    })
  }));
};

SvgBidirectionalArrow.displayName = 'SvgBidirectionalArrow';

var BidirectionalArrowIcon = function BidirectionalArrowIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgBidirectionalArrow, _objectSpread$1E(_objectSpread$1E({}, props), {}, {
        className: createClass(getIconStyles$1E(props, theme))
      }));
    }
  });
};

BidirectionalArrowIcon.displayName = 'BidirectionalArrowIcon';
var BidirectionalArrowIcon$1 = BidirectionalArrowIcon;

function ownKeys$1D(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1D(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1D(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1D(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1D = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1D = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1D[size], "px"),
        height: "".concat(iconSizes$1D[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1D.big, "px"),
        height: "".concat(iconSizes$1D.big, "px")
      };
  }
};

var getSizeStyle$1D = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1D(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1D = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1D(_objectSpread$1D({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1D = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1D(props.color, theme), ";}&,image{", getSizeStyle$1D(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgBinFilled = function SvgBinFilled(props) {
  return jsx("svg", _objectSpread$1D(_objectSpread$1D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      d: "M8.39 4.815v-1.8h7.2v1.8h4.5v2.7H3.89v-2.7h4.5zm9 2.7h.9l-.788 11.82a1.797 1.797 0 01-1.794 1.68H8.272a1.8 1.8 0 01-1.794-1.68L5.69 7.515H17.39zm-4.95 9v-7.2h-.9v7.2h.9zm-2.25 0v-7.2h-.9v7.2h.9zm4.5 0v-7.2h-.9v7.2h.9z",
      fillRule: "evenodd"
    })
  }));
};

SvgBinFilled.displayName = 'SvgBinFilled';

var BinFilledIcon = function BinFilledIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgBinFilled, _objectSpread$1D(_objectSpread$1D({}, props), {}, {
        className: createClass(getIconStyles$1D(props, theme))
      }));
    }
  });
};

BinFilledIcon.displayName = 'BinFilledIcon';
var BinFilledIcon$1 = BinFilledIcon;

function ownKeys$1C(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1C(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1C(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1C(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1C = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1C = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1C[size], "px"),
        height: "".concat(iconSizes$1C[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1C.big, "px"),
        height: "".concat(iconSizes$1C.big, "px")
      };
  }
};

var getSizeStyle$1C = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1C(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1C = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1C(_objectSpread$1C({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1C = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1C(props.color, theme), ";}&,image{", getSizeStyle$1C(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgBinLinear = function SvgBinLinear(props) {
  return jsx("svg", _objectSpread$1C(_objectSpread$1C({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.2 6.919V7.5H4V4.8h4.5V3h7.2v1.8h4.5v2.119zm-.9-.319v-.9H4.9v.9h14.4zM9.4 4.8h5.4v-.9H9.4v.9zm8.1 2.7h.9l-.788 11.82A1.797 1.797 0 0115.818 21H8.382a1.8 1.8 0 01-1.794-1.68L5.8 7.5h.9l.81 11.346A1.35 1.35 0 008.857 20.1h6.486a1.35 1.35 0 001.347-1.254L17.5 7.5zm-4.95 9h-.9V9.3h.9v7.2zm-2.25 0h-.9V9.3h.9v7.2zm4.5 0h-.9V9.3h.9v7.2z",
      fillRule: "evenodd"
    })
  }));
};

SvgBinLinear.displayName = 'SvgBinLinear';

var BinLinearIcon = function BinLinearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgBinLinear, _objectSpread$1C(_objectSpread$1C({}, props), {}, {
        className: createClass(getIconStyles$1C(props, theme))
      }));
    }
  });
};

BinLinearIcon.displayName = 'BinLinearIcon';
var BinLinearIcon$1 = BinLinearIcon;

function ownKeys$1B(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1B(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1B(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1B(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1B = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1B = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1B[size], "px"),
        height: "".concat(iconSizes$1B[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1B.big, "px"),
        height: "".concat(iconSizes$1B.big, "px")
      };
  }
};

var getSizeStyle$1B = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1B(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1B = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1B(_objectSpread$1B({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1B = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1B(props.color, theme), ";}&,image{", getSizeStyle$1B(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgBox = function SvgBox(props) {
  return jsx("svg", _objectSpread$1B(_objectSpread$1B({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.06 16.601L12.27 21v-8.797l.867-.49 6.924-3.909v8.797zM12.03 3l3.13 1.767-7.79 4.399-3.13-1.768L12.03 3zm4.29 2.422l3.501 1.976-4.892 2.763-2.899 1.636-2.914-1.645-.588-.332 7.792-4.398zM8.28 12.57v-2.35l3.51 1.983V21L4 16.601V7.804l3.148 1.777v2.416l1.132.573z",
      fillRule: "evenodd"
    })
  }));
};

SvgBox.displayName = 'SvgBox';

var BoxIcon = function BoxIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgBox, _objectSpread$1B(_objectSpread$1B({}, props), {}, {
        className: createClass(getIconStyles$1B(props, theme))
      }));
    }
  });
};

BoxIcon.displayName = 'BoxIcon';
var BoxIcon$1 = BoxIcon;

function ownKeys$1A(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1A(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1A(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1A(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1A = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1A = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1A[size], "px"),
        height: "".concat(iconSizes$1A[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1A.big, "px"),
        height: "".concat(iconSizes$1A.big, "px")
      };
  }
};

var getSizeStyle$1A = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1A(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1A = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1A(_objectSpread$1A({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1A = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1A(props.color, theme), ";}&,image{", getSizeStyle$1A(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgBrain = function SvgBrain(props) {
  return jsx("svg", _objectSpread$1A(_objectSpread$1A({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M14.298 3L12.15 4.074 10.003 3 5.1 5.675v2.322L3 9.332v5.786L5.1 16.263v2.099l4.904 2.675 2.147-1.075 2.148 1.075 4.904-2.675v-2.323l2.099-1.335V8.918l-2.1-1.144v-2.1L14.299 3zm-1.202 15.823V5.213l1.172-.586L17.76 6.53V8.63l2.099 1.145v4.137l-2.099 1.336v2.257l-3.492 1.905-1.172-.587zM9.315 8.013l-.546.545v7.274l.3.3c.12-.088.26-.151.422-.151a.721.721 0 110 1.442c-.333 0-.6-.23-.684-.534l-.759-.759v-3.394H6.495a.71.71 0 01-.61.36.72.72 0 110-1.442.71.71 0 01.61.36h1.553V8.26l.757-.756c-.015-.058-.036-.114-.036-.176a.72.72 0 11.722.721c-.063 0-.119-.02-.176-.035zM6.54 17.505v-2.098l-2.1-1.145v-4.138l2.1-1.335V6.531l3.491-1.904 1.174.587v13.61l-1.174.586-3.49-1.905zm10.993-6.212a.71.71 0 01.61-.36.721.721 0 110 1.442.71.71 0 01-.61-.36H15.98v3.754l-.757.757c.015.058.036.114.036.176a.721.721 0 11-.721-.721c.062 0 .117.02.175.035l.546-.545V8.197l-.3-.3a.707.707 0 01-.421.151.72.72 0 110-1.442c.331 0 .599.228.683.533l.759.76v3.394h1.553z",
      fillRule: "evenodd"
    })
  }));
};

SvgBrain.displayName = 'SvgBrain';

var BrainIcon = function BrainIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgBrain, _objectSpread$1A(_objectSpread$1A({}, props), {}, {
        className: createClass(getIconStyles$1A(props, theme))
      }));
    }
  });
};

BrainIcon.displayName = 'BrainIcon';
var BrainIcon$1 = BrainIcon;

function ownKeys$1z(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1z(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1z(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1z(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1z = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1z = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1z[size], "px"),
        height: "".concat(iconSizes$1z[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1z.big, "px"),
        height: "".concat(iconSizes$1z.big, "px")
      };
  }
};

var getSizeStyle$1z = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1z(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1z = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1z(_objectSpread$1z({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1z = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1z(props.color, theme), ";}&,image{", getSizeStyle$1z(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCalendar = function SvgCalendar(props) {
  return jsx("svg", _objectSpread$1z(_objectSpread$1z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      fillRule: "evenodd",
      d: "M21 6.5V19a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h1V3h3v1h6V3h3v1h1a2 2 0 012 2v.5zM4 7v12a1 1 0 001 1h14a1 1 0 001-1V7H4zm1 2h4v4H5V9zm5 0h4v4h-4V9zm5 0h4v4h-4V9zM5 14h4v4H5v-4zm5 0h4v4h-4v-4zm5 0h4v4h-4v-4z"
    })
  }));
};

SvgCalendar.displayName = 'SvgCalendar';

var CalendarIcon = function CalendarIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCalendar, _objectSpread$1z(_objectSpread$1z({}, props), {}, {
        className: createClass(getIconStyles$1z(props, theme))
      }));
    }
  });
};

CalendarIcon.displayName = 'CalendarIcon';
var CalendarIcon$1 = CalendarIcon;

function ownKeys$1y(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1y(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1y(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1y(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1y = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1y = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1y[size], "px"),
        height: "".concat(iconSizes$1y[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1y.big, "px"),
        height: "".concat(iconSizes$1y.big, "px")
      };
  }
};

var getSizeStyle$1y = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1y(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1y = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1y(_objectSpread$1y({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1y = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1y(props.color, theme), ";}&,image{", getSizeStyle$1y(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCamera = function SvgCamera(props) {
  return jsx("svg", _objectSpread$1y(_objectSpread$1y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M19.444 17.149v-7.87a.602.602 0 00-.594-.608h-4.164l-.782-2.13H10.06l-.782 2.13H5.113a.6.6 0 00-.592.609v7.869a.6.6 0 00.592.608H18.85a.602.602 0 00.594-.608m1.185-7.87v7.87c0 1.006-.798 1.824-1.779 1.824H5.113c-.98 0-1.777-.818-1.777-1.824v-7.87c0-1.006.797-1.826 1.777-1.826h3.345l.782-2.128h5.483l.783 2.128h3.344c.98 0 1.78.82 1.78 1.827zm-5.154 1.642c-.719-1.277-2.057-2.07-3.492-2.07-1.437 0-2.776.793-3.494 2.07a4.245 4.245 0 000 4.14c.718 1.278 2.057 2.07 3.494 2.07 1.435 0 2.773-.792 3.492-2.07a4.245 4.245 0 000-4.14zm-.935 3.587a2.94 2.94 0 01-2.56 1.517 2.942 2.942 0 01-2.558-1.517 3.11 3.11 0 010-3.034 2.943 2.943 0 012.56-1.517c1.056 0 2.031.58 2.558 1.517.529.939.529 2.096 0 3.034z",
      fillRule: "evenodd"
    })
  }));
};

SvgCamera.displayName = 'SvgCamera';

var CameraIcon = function CameraIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCamera, _objectSpread$1y(_objectSpread$1y({}, props), {}, {
        className: createClass(getIconStyles$1y(props, theme))
      }));
    }
  });
};

CameraIcon.displayName = 'CameraIcon';
var CameraIcon$1 = CameraIcon;

function ownKeys$1x(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1x(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1x(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1x(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1x = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1x = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1x[size], "px"),
        height: "".concat(iconSizes$1x[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1x.big, "px"),
        height: "".concat(iconSizes$1x.big, "px")
      };
  }
};

var getSizeStyle$1x = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1x(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1x = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1x(_objectSpread$1x({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1x = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1x(props.color, theme), ";}&,image{", getSizeStyle$1x(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCaretDown = function SvgCaretDown(props) {
  return jsx("svg", _objectSpread$1x(_objectSpread$1x({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.666 7.405a1.052 1.052 0 00-.791-.353H4.125c-.305 0-.568.117-.791.353A1.18 1.18 0 003 8.243c0 .323.111.602.334.838l7.875 8.34c.223.236.486.354.791.354.305 0 .568-.118.791-.354l7.875-8.34A1.18 1.18 0 0021 8.243c0-.322-.112-.602-.334-.838z",
      fillRule: "evenodd"
    })
  }));
};

SvgCaretDown.displayName = 'SvgCaretDown';

var CaretDownIcon = function CaretDownIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCaretDown, _objectSpread$1x(_objectSpread$1x({}, props), {}, {
        className: createClass(getIconStyles$1x(props, theme))
      }));
    }
  });
};

CaretDownIcon.displayName = 'CaretDownIcon';
var CaretDownIcon$1 = CaretDownIcon;

function ownKeys$1w(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1w(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1w(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1w(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1w = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1w = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1w[size], "px"),
        height: "".concat(iconSizes$1w[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1w.big, "px"),
        height: "".concat(iconSizes$1w.big, "px")
      };
  }
};

var getSizeStyle$1w = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1w(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1w = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1w(_objectSpread$1w({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1w = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1w(props.color, theme), ";}&,image{", getSizeStyle$1w(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCaretUp = function SvgCaretUp(props) {
  return jsx("svg", _objectSpread$1w(_objectSpread$1w({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M3.334 17.37c.223.235.486.353.791.353h15.75c.305 0 .568-.118.791-.354a1.18 1.18 0 00.334-.838 1.18 1.18 0 00-.334-.837l-7.875-8.34A1.053 1.053 0 0012 7c-.305 0-.568.118-.791.354l-7.875 8.34A1.18 1.18 0 003 16.53c0 .323.112.602.334.838z",
      fillRule: "evenodd"
    })
  }));
};

SvgCaretUp.displayName = 'SvgCaretUp';

var CaretUpIcon = function CaretUpIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCaretUp, _objectSpread$1w(_objectSpread$1w({}, props), {}, {
        className: createClass(getIconStyles$1w(props, theme))
      }));
    }
  });
};

CaretUpIcon.displayName = 'CaretUpIcon';
var CaretUpIcon$1 = CaretUpIcon;

function ownKeys$1v(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1v(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1v(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1v(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1v = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1v = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1v[size], "px"),
        height: "".concat(iconSizes$1v[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1v.big, "px"),
        height: "".concat(iconSizes$1v.big, "px")
      };
  }
};

var getSizeStyle$1v = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1v(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1v = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1v(_objectSpread$1v({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1v = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1v(props.color, theme), ";}&,image{", getSizeStyle$1v(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCart = function SvgCart(props) {
  return jsx("svg", _objectSpread$1v(_objectSpread$1v({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.491 18.583a1.298 1.298 0 011.124-.658c.463 0 .893.252 1.124.658.232.406.232.91 0 1.316a1.298 1.298 0 01-1.124.659c-.462 0-.893-.252-1.124-.658a1.337 1.337 0 010-1.317zm-5.032 0c.231.406.231.91 0 1.316a1.299 1.299 0 01-1.124.659c-.462 0-.893-.252-1.124-.658a1.337 1.337 0 010-1.317 1.298 1.298 0 011.124-.658c.462 0 .893.252 1.124.658zm-1.555-5.481L6.778 4.808l-2.32-.598a.615.615 0 01.303-1.19l2.932.755 1.036 2.749h10.353c.76 0 1.358.625 1.353 1.451l-.877 4.035c-.027.742-.623 1.334-1.334 1.334l-3.626.212-3.55.207-.057.044a7.94 7.94 0 00-.787.672c-.04.038-.04.038-.078.077-.513.52-.654.829-.631.953.054.292.516.557 1.097.567.339.005 1.94.005 4.403 0a3917.64 3917.64 0 004.474-.01c.338 0 .61.285.61.624.001.338-.27.62-.608.62a4176.62 4176.62 0 01-6.208.01c-1.783 0-2.45-.001-2.691-.005-1.16-.02-2.104-.658-2.275-1.579-.16-.86.536-1.77 1.607-2.634z",
      fillRule: "evenodd"
    })
  }));
};

SvgCart.displayName = 'SvgCart';

var CartIcon = function CartIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCart, _objectSpread$1v(_objectSpread$1v({}, props), {}, {
        className: createClass(getIconStyles$1v(props, theme))
      }));
    }
  });
};

CartIcon.displayName = 'CartIcon';
var CartIcon$1 = CartIcon;

function ownKeys$1u(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1u(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1u(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1u(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1u = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1u = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1u[size], "px"),
        height: "".concat(iconSizes$1u[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1u.big, "px"),
        height: "".concat(iconSizes$1u.big, "px")
      };
  }
};

var getSizeStyle$1u = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1u(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1u = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1u(_objectSpread$1u({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1u = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1u(props.color, theme), ";}&,image{", getSizeStyle$1u(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgChainBroken = function SvgChainBroken(props) {
  return jsx("svg", _objectSpread$1u(_objectSpread$1u({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M9.892 16.62l2.297-2.297 1.332 1.332-2.297 2.298a3.385 3.385 0 01-2.4.992c-.87 0-1.74-.33-2.401-.992l-.573-.573a3.373 3.373 0 01-.995-2.401c0-.907.354-1.76.995-2.4l2.297-2.298 1.332 1.333-2.297 2.297a1.501 1.501 0 00-.442 1.068c0 .403.158.783.442 1.068l.573.573a1.513 1.513 0 002.137 0zm1.653-7.072l-1.332-1.333 2.297-2.297a3.373 3.373 0 012.4-.994c.907 0 1.76.353 2.401.994l.573.573c.641.641.995 1.494.995 2.4 0 .908-.354 1.76-.995 2.402l-2.297 2.297-1.332-1.333 2.297-2.297c.284-.285.442-.665.442-1.068 0-.404-.158-.783-.442-1.068l-.573-.573a1.5 1.5 0 00-1.068-.442c-.404 0-.783.157-1.069.442l-2.297 2.297zM8.72 7.829l-.604.603-2.574-2.574.603-.604L8.719 7.83zm.71-1.229V3h.771v3.6h-.771zM3 10.2v-.771h3.6v.771H3zm12.392 5.465l.604-.603 2.574 2.574-.603.604-2.575-2.575zm-1.85 5.078v-3.857h.772v3.857h-.771zm3.6-6.686v-.771h3.6v.771h-3.6z",
      fillRule: "evenodd"
    })
  }));
};

SvgChainBroken.displayName = 'SvgChainBroken';

var ChainBrokenIcon = function ChainBrokenIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgChainBroken, _objectSpread$1u(_objectSpread$1u({}, props), {}, {
        className: createClass(getIconStyles$1u(props, theme))
      }));
    }
  });
};

ChainBrokenIcon.displayName = 'ChainBrokenIcon';
var ChainBrokenIcon$1 = ChainBrokenIcon;

function ownKeys$1t(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1t(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1t(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1t(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1t = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1t = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1t[size], "px"),
        height: "".concat(iconSizes$1t[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1t.big, "px"),
        height: "".concat(iconSizes$1t.big, "px")
      };
  }
};

var getSizeStyle$1t = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1t(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1t = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1t(_objectSpread$1t({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1t = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1t(props.color, theme), ";}&,image{", getSizeStyle$1t(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgChain = function SvgChain(props) {
  return jsx("svg", _objectSpread$1t(_objectSpread$1t({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M9.421 17.912l2.93-2.928 1.698 1.699-2.929 2.929a4.316 4.316 0 01-3.06 1.266 4.314 4.314 0 01-3.062-1.266l-.73-.73A4.301 4.301 0 013 15.82a4.3 4.3 0 011.268-3.06l2.929-2.93 1.699 1.7-2.929 2.929a1.914 1.914 0 00-.564 1.361c0 .515.2.999.564 1.362l.73.73c.751.752 1.973.751 2.724 0zm9.46-13.644l.73.73A4.3 4.3 0 0120.88 8.06a4.3 4.3 0 01-1.268 3.061l-2.929 2.93-1.699-1.7 2.929-2.929c.363-.364.564-.847.564-1.362 0-.514-.2-.998-.564-1.361l-.73-.73a1.913 1.913 0 00-1.363-.565c-.514 0-.998.2-1.361.564l-2.93 2.93-1.698-1.7 2.929-2.929A4.3 4.3 0 0115.82 3c1.157 0 2.244.45 3.062 1.268zm-10.549 11.2c-.47-.468-.47-1.23 0-1.699l5.438-5.437a1.201 1.201 0 111.699 1.7l-5.438 5.437a1.198 1.198 0 01-1.699 0z",
      fillRule: "evenodd"
    })
  }));
};

SvgChain.displayName = 'SvgChain';

var ChainIcon = function ChainIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgChain, _objectSpread$1t(_objectSpread$1t({}, props), {}, {
        className: createClass(getIconStyles$1t(props, theme))
      }));
    }
  });
};

ChainIcon.displayName = 'ChainIcon';
var ChainIcon$1 = ChainIcon;

function ownKeys$1s(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1s(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1s(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1s(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1s = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1s = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1s[size], "px"),
        height: "".concat(iconSizes$1s[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1s.big, "px"),
        height: "".concat(iconSizes$1s.big, "px")
      };
  }
};

var getSizeStyle$1s = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1s(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1s = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1s(_objectSpread$1s({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1s = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1s(props.color, theme), ";}&,image{", getSizeStyle$1s(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCheckActive = function SvgCheckActive(props) {
  return jsx("svg", _objectSpread$1s(_objectSpread$1s({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12.014 21a8.986 8.986 0 110-17.972 8.986 8.986 0 010 17.972zm3.9-12.572a.394.394 0 00-.556 0l-4.922 4.922a.394.394 0 01-.555 0L8.67 12.138a.394.394 0 00-.555 0l-.743.744a.394.394 0 000 .555l2.51 2.51a.394.394 0 00.555 0l6.22-6.22a.394.394 0 000-.556l-.743-.743z",
      fillRule: "evenodd"
    })
  }));
};

SvgCheckActive.displayName = 'SvgCheckActive';

var CheckActiveIcon = function CheckActiveIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCheckActive, _objectSpread$1s(_objectSpread$1s({}, props), {}, {
        className: createClass(getIconStyles$1s(props, theme))
      }));
    }
  });
};

CheckActiveIcon.displayName = 'CheckActiveIcon';
var CheckActiveIcon$1 = CheckActiveIcon;

function ownKeys$1r(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1r(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1r(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1r(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1r = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1r = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1r[size], "px"),
        height: "".concat(iconSizes$1r[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1r.big, "px"),
        height: "".concat(iconSizes$1r.big, "px")
      };
  }
};

var getSizeStyle$1r = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1r(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1r = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1r(_objectSpread$1r({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1r = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1r(props.color, theme), ";}&,image{", getSizeStyle$1r(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCheckBold = function SvgCheckBold(props) {
  return jsx("svg", _objectSpread$1r(_objectSpread$1r({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M19.377 4.716a.745.745 0 00-1.05 0l-9.311 9.312a.745.745 0 01-1.05 0l-2.293-2.293a.745.745 0 00-1.05 0l-1.407 1.407a.745.745 0 000 1.05l4.75 4.749a.745.745 0 001.05 0L20.783 7.173a.745.745 0 000-1.05l-1.406-1.407z",
      fillRule: "evenodd"
    })
  }));
};

SvgCheckBold.displayName = 'SvgCheckBold';

var CheckBoldIcon = function CheckBoldIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCheckBold, _objectSpread$1r(_objectSpread$1r({}, props), {}, {
        className: createClass(getIconStyles$1r(props, theme))
      }));
    }
  });
};

CheckBoldIcon.displayName = 'CheckBoldIcon';
var CheckBoldIcon$1 = CheckBoldIcon;

function ownKeys$1q(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1q(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1q(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1q(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1q = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1q = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1q[size], "px"),
        height: "".concat(iconSizes$1q[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1q.big, "px"),
        height: "".concat(iconSizes$1q.big, "px")
      };
  }
};

var getSizeStyle$1q = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1q(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1q = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1q(_objectSpread$1q({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1q = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1q(props.color, theme), ";}&,image{", getSizeStyle$1q(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCheckInactive = function SvgCheckInactive(props) {
  return jsx("svg", _objectSpread$1q(_objectSpread$1q({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12 21a9 9 0 110-18 9 9 0 010 18zm-6-9.495v.99c0 .291.224.505.5.505h11c.271 0 .5-.226.5-.505v-.99a.495.495 0 00-.5-.505h-11c-.271 0-.5.226-.5.505z",
      fillRule: "evenodd"
    })
  }));
};

SvgCheckInactive.displayName = 'SvgCheckInactive';

var CheckInactiveIcon = function CheckInactiveIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCheckInactive, _objectSpread$1q(_objectSpread$1q({}, props), {}, {
        className: createClass(getIconStyles$1q(props, theme))
      }));
    }
  });
};

CheckInactiveIcon.displayName = 'CheckInactiveIcon';
var CheckInactiveIcon$1 = CheckInactiveIcon;

function ownKeys$1p(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1p(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1p(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1p(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1p = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1p = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1p[size], "px"),
        height: "".concat(iconSizes$1p[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1p.big, "px"),
        height: "".concat(iconSizes$1p.big, "px")
      };
  }
};

var getSizeStyle$1p = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1p(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1p = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1p(_objectSpread$1p({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1p = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1p(props.color, theme), ";}&,image{", getSizeStyle$1p(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCheckThin = function SvgCheckThin(props) {
  return jsx("svg", _objectSpread$1p(_objectSpread$1p({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.28 4.363l1.471 1.262L9.053 20.524 2.238 12.64l1.523-1.337 5.292 6.172"
    })
  }));
};

SvgCheckThin.displayName = 'SvgCheckThin';

var CheckThinIcon = function CheckThinIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCheckThin, _objectSpread$1p(_objectSpread$1p({}, props), {}, {
        className: createClass(getIconStyles$1p(props, theme))
      }));
    }
  });
};

CheckThinIcon.displayName = 'CheckThinIcon';
var CheckThinIcon$1 = CheckThinIcon;

function ownKeys$1o(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1o(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1o(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1o(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1o = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1o = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1o[size], "px"),
        height: "".concat(iconSizes$1o[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1o.big, "px"),
        height: "".concat(iconSizes$1o.big, "px")
      };
  }
};

var getSizeStyle$1o = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1o(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1o = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1o(_objectSpread$1o({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1o = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1o(props.color, theme), ";}&,image{", getSizeStyle$1o(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCircle = function SvgCircle(props) {
  return jsx("svg", _objectSpread$1o(_objectSpread$1o({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12.5 17.5a5 5 0 100-10 5 5 0 000 10zm0 2.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15z",
      fillRule: "nonzero"
    })
  }));
};

SvgCircle.displayName = 'SvgCircle';

var CircleIcon = function CircleIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCircle, _objectSpread$1o(_objectSpread$1o({}, props), {}, {
        className: createClass(getIconStyles$1o(props, theme))
      }));
    }
  });
};

CircleIcon.displayName = 'CircleIcon';
var CircleIcon$1 = CircleIcon;

function ownKeys$1n(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1n(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1n(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1n(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1n = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1n = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1n[size], "px"),
        height: "".concat(iconSizes$1n[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1n.big, "px"),
        height: "".concat(iconSizes$1n.big, "px")
      };
  }
};

var getSizeStyle$1n = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1n(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1n = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1n(_objectSpread$1n({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1n = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1n(props.color, theme), ";}&,image{", getSizeStyle$1n(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgClipboard = function SvgClipboard(props) {
  return jsx("svg", _objectSpread$1n(_objectSpread$1n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fillRule: "evenodd",
      children: jsx("path", {
        d: "M14.504 4.407h1.233c.912 0 1.66.76 1.66 1.689v3.823a.25.25 0 01-.25.25h-.963a.25.25 0 01-.25-.25v-3.11a.736.736 0 00-.74-.753h-.713v.753c0 .306-.465.376-.766.376H7.797a.567.567 0 01-.555-.565v-.564h-.925a.736.736 0 00-.74.753v11.66c0 .423.324.752.74.752h8.877c.416 0 .74-.329.74-.752v-2.378c0-.117.095-.212.212-.212h1.001a.25.25 0 01.25.25v3.053c0 .928-.748 1.688-1.66 1.688H5.775c-.913 0-1.66-.76-1.66-1.688V6.096c0-.928.747-1.689 1.66-1.689h1.474v-.612c0-.131.112-.24.25-.24h1.099V3.17c0-.132.112-.24.25-.24h4.057c.138 0 .25.108.25.24v.386h1.1c.136 0 .249.108.249.24m5.105 8.542c.197 0 .358.114.358.255v.626c0 .141-.16.255-.358.255h-7.412l2.487 2.455a.24.24 0 01.078.176.241.241 0 01-.078.177l-.39.384a.248.248 0 01-.357 0l-3.625-3.578a.24.24 0 01-.078-.176c0-.067.026-.126.078-.177l3.625-3.577a.248.248 0 01.358 0l.389.384a.24.24 0 01.078.176.241.241 0 01-.078.177l-2.476 2.443h7.4z",
        fillRule: "nonzero"
      })
    })
  }));
};

SvgClipboard.displayName = 'SvgClipboard';

var ClipboardIcon = function ClipboardIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgClipboard, _objectSpread$1n(_objectSpread$1n({}, props), {}, {
        className: createClass(getIconStyles$1n(props, theme))
      }));
    }
  });
};

ClipboardIcon.displayName = 'ClipboardIcon';
var ClipboardIcon$1 = ClipboardIcon;

function ownKeys$1m(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1m(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1m(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1m(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1m = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1m = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1m[size], "px"),
        height: "".concat(iconSizes$1m[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1m.big, "px"),
        height: "".concat(iconSizes$1m.big, "px")
      };
  }
};

var getSizeStyle$1m = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1m(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1m = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1m(_objectSpread$1m({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1m = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1m(props.color, theme), ";}&,image{", getSizeStyle$1m(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgClockWithArrow = function SvgClockWithArrow(props) {
  return jsx("svg", _objectSpread$1m(_objectSpread$1m({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M21.198 23.465l1.175 2.403a11.676 11.676 0 01-4.209 1.11l-.4.022-.102-2.667a8.962 8.962 0 003.536-.868zm-8.517-.398c.907.54 1.9.916 2.952 1.114l.245.043.245.036-.362 2.644a11.738 11.738 0 01-4.081-1.326l-.399-.227 1.4-2.284zm-3.06-3.04a8.885 8.885 0 001.552 1.91l.264.235-1.777 2.012a11.567 11.567 0 01-2.146-2.444l-.217-.346 2.323-1.367zm8.45-11.84c4.136.285 7.203 3.824 6.914 7.904-.289 4.08-3.877 7.156-8.014 6.87-4.136-.284-7.255-3.823-6.966-7.903.018-.247.024-.418.065-.648.01-.058.02-.07.028-.1a.482.482 0 01.034-.09c.014-.028.03-.05.051-.086.112-.182.51-.702 1.194-1.56l-.726-.05c1.257-2.743 4.198-4.56 7.42-4.337zm-1.077 2.188a.771.771 0 00-.763.67l-.007.104v5.857c0 .392.29.716.665.768l.105.007h4.968c.425 0 .77-.347.77-.775a.773.773 0 00-.665-.767l-.105-.007h-4.199v-5.083a.773.773 0 00-.665-.767l-.104-.007zm4.253-2.812l-.115-.055.101.049-.227-.105a9.037 9.037 0 00-.247-.105l-.251-.099a8.542 8.542 0 00-1.492-.423l-.002.005-.019-.004a9.095 9.095 0 00-3.22-.028l-.078.015-.354.072c-.37.084-.721.19-1.076.319l-.357.135c-.132.052-.262.106-.391.162a8.948 8.948 0 00-2.631 1.847l.016-.017a8.823 8.823 0 00-1.301 1.703l-.074.125-.166.303c-.162.31-.305.628-.429.954l-.117.33 1.862-.001-3.396 5.397-3.303-5.395h2.021a11.316 11.316 0 011.17-2.889 11.348 11.348 0 011.777-2.372 11.455 11.455 0 01.987-.9l.341-.267a12.11 12.11 0 012.603-1.456c.615-.252 1.25-.45 1.914-.591a11.759 11.759 0 013.633-.219c.357.028.71.08 1.057.146l.019.006.024.003c.663.13 1.311.317 1.94.559a11.446 11.446 0 013.712 2.24l.292.273c.477.466.913.967 1.303 1.503a11.306 11.306 0 011.846 3.888l.092.385-.009.002a11.476 11.476 0 01.27 2.071l.008.318-.001.317a11.93 11.93 0 01-.21 1.898c-.064.331-.143.66-.237.985l-.033.116-.055.178a10.8 10.8 0 01-.246.698c-.243.616-.538 1.21-.884 1.776a11.361 11.361 0 01-2.893 3.209l-.323.236-1.574-2.171a8.898 8.898 0 001.717-1.581 8.97 8.97 0 001.454-2.488l.063-.17.018-.056.085-.248a8.857 8.857 0 00.411-2.654l-.002-.181v-.061l-.003-.025-.02-.346a8.842 8.842 0 00-.516-2.362l-.065-.17-.068-.168c-.042-.109-.075-.215-.124-.32a8.712 8.712 0 00-.158-.327l-.01.004a8.744 8.744 0 00-1.983-2.58l-.278-.238a8.454 8.454 0 00-1.413-.958l-.283-.146a2.904 2.904 0 00-.1-.05l.05.025-.059-.029.007.003z",
      fill: "#FFF",
      fillRule: "evenodd"
    })
  }));
};

SvgClockWithArrow.displayName = 'SvgClockWithArrow';

var ClockWithArrowIcon = function ClockWithArrowIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgClockWithArrow, _objectSpread$1m(_objectSpread$1m({}, props), {}, {
        className: createClass(getIconStyles$1m(props, theme))
      }));
    }
  });
};

ClockWithArrowIcon.displayName = 'ClockWithArrowIcon';
var ClockWithArrowIcon$1 = ClockWithArrowIcon;

function ownKeys$1l(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1l(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1l(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1l(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1l = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1l = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1l[size], "px"),
        height: "".concat(iconSizes$1l[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1l.big, "px"),
        height: "".concat(iconSizes$1l.big, "px")
      };
  }
};

var getSizeStyle$1l = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1l(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1l = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1l(_objectSpread$1l({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1l = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1l(props.color, theme), ";}&,image{", getSizeStyle$1l(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgClock = function SvgClock(props) {
  return jsx("svg", _objectSpread$1l(_objectSpread$1l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      fillRule: "evenodd",
      d: "M13.732 13A2 2 0 1111 10.268V7a1 1 0 012 0v3.268c.304.175.557.428.732.732H15a1 1 0 010 2h-1.268zM12 21a9 9 0 110-18 9 9 0 010 18zm0-2a7 7 0 100-14 7 7 0 000 14z"
    })
  }));
};

SvgClock.displayName = 'SvgClock';

var ClockIcon = function ClockIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgClock, _objectSpread$1l(_objectSpread$1l({}, props), {}, {
        className: createClass(getIconStyles$1l(props, theme))
      }));
    }
  });
};

ClockIcon.displayName = 'ClockIcon';
var ClockIcon$1 = ClockIcon;

function ownKeys$1k(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1k(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1k(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1k(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1k = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1k = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1k[size], "px"),
        height: "".concat(iconSizes$1k[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1k.big, "px"),
        height: "".concat(iconSizes$1k.big, "px")
      };
  }
};

var getSizeStyle$1k = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1k(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1k = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1k(_objectSpread$1k({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1k = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1k(props.color, theme), ";}&,image{", getSizeStyle$1k(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCloseBold = function SvgCloseBold(props) {
  return jsx("svg", _objectSpread$1k(_objectSpread$1k({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M14.574 12.044l2.571-2.572c.71-.71.712-1.86.004-2.567a1.816 1.816 0 00-2.568.003L12.01 9.48 9.446 6.916a1.816 1.816 0 00-2.568.003c-.71.71-.712 1.86-.004 2.568l2.564 2.564-2.571 2.571c-.71.71-.712 1.86-.004 2.568a1.816 1.816 0 002.568-.004l2.571-2.571 2.565 2.564a1.816 1.816 0 002.567-.003c.71-.71.712-1.86.004-2.568l-2.564-2.564z",
      fillRule: "nonzero"
    })
  }));
};

SvgCloseBold.displayName = 'SvgCloseBold';

var CloseBoldIcon = function CloseBoldIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCloseBold, _objectSpread$1k(_objectSpread$1k({}, props), {}, {
        className: createClass(getIconStyles$1k(props, theme))
      }));
    }
  });
};

CloseBoldIcon.displayName = 'CloseBoldIcon';
var CloseBoldIcon$1 = CloseBoldIcon;

function ownKeys$1j(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1j(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1j(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1j(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1j = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1j = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1j[size], "px"),
        height: "".concat(iconSizes$1j[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1j.big, "px"),
        height: "".concat(iconSizes$1j.big, "px")
      };
  }
};

var getSizeStyle$1j = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1j(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1j = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1j(_objectSpread$1j({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1j = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1j(props.color, theme), ";}&,image{", getSizeStyle$1j(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgClose = function SvgClose(props) {
  return jsx("svg", _objectSpread$1j(_objectSpread$1j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M11.031 11.616l-7.75 7.46a.442.442 0 000 .647.429.429 0 00.329.139c.14 0 .234-.047.375-.14l7.722-7.455 7.746 7.456a.429.429 0 00.328.139.512.512 0 00.328-.14c.235-.184.235-.461 0-.646l-7.738-7.45 7.739-7.471c.235-.185.235-.462 0-.647a.458.458 0 00-.657 0l-7.758 7.468-7.758-7.468a.458.458 0 00-.656 0 .442.442 0 000 .647l7.75 7.46z",
      fillRule: "evenodd"
    })
  }));
};

SvgClose.displayName = 'SvgClose';

var CloseIcon = function CloseIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgClose, _objectSpread$1j(_objectSpread$1j({}, props), {}, {
        className: createClass(getIconStyles$1j(props, theme))
      }));
    }
  });
};

CloseIcon.displayName = 'CloseIcon';
var CloseIcon$1 = CloseIcon;

function ownKeys$1i(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1i(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1i(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1i(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1i = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1i = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1i[size], "px"),
        height: "".concat(iconSizes$1i[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1i.big, "px"),
        height: "".concat(iconSizes$1i.big, "px")
      };
  }
};

var getSizeStyle$1i = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1i(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1i = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1i(_objectSpread$1i({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1i = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1i(props.color, theme), ";}&,image{", getSizeStyle$1i(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCodeView = function SvgCodeView(props) {
  return jsx("svg", _objectSpread$1i(_objectSpread$1i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M8.381 17.89a.317.317 0 01-.237.11.316.316 0 01-.237-.11l-4.804-5.137a.36.36 0 010-.507L7.907 7.11A.316.316 0 018.144 7c.09 0 .169.037.237.11l.516.551A.36.36 0 019 7.915a.36.36 0 01-.103.253L4.845 12.5l4.052 4.332a.36.36 0 01.103.253.36.36 0 01-.103.254l-.516.551zM15.62 7.11a.317.317 0 01.237-.11c.089 0 .168.036.237.11l4.804 5.137a.36.36 0 010 .507l-4.804 5.136a.316.316 0 01-.237.11.316.316 0 01-.237-.11l-.516-.551a.36.36 0 01-.103-.254.36.36 0 01.103-.253l4.052-4.332-4.052-4.332A.36.36 0 0115 7.915a.36.36 0 01.103-.254l.516-.551zm-1.83 2.343l-2.767 6.704-1.456-.072 2.767-6.705 1.456.073z",
      fillRule: "evenodd"
    })
  }));
};

SvgCodeView.displayName = 'SvgCodeView';

var CodeViewIcon = function CodeViewIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCodeView, _objectSpread$1i(_objectSpread$1i({}, props), {}, {
        className: createClass(getIconStyles$1i(props, theme))
      }));
    }
  });
};

CodeViewIcon.displayName = 'CodeViewIcon';
var CodeViewIcon$1 = CodeViewIcon;

function ownKeys$1h(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1h(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1h(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1h(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1h = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1h = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1h[size], "px"),
        height: "".concat(iconSizes$1h[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1h.big, "px"),
        height: "".concat(iconSizes$1h.big, "px")
      };
  }
};

var getSizeStyle$1h = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1h(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1h = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1h(_objectSpread$1h({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1h = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1h(props.color, theme), ";}&,image{", getSizeStyle$1h(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCoins = function SvgCoins(props) {
  return jsx("svg", _objectSpread$1h(_objectSpread$1h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M21 5.61v2.333c0 .052-.004.108-.012.167.008.055.012.111.012.167v2.334c0 .04-.002.081-.007.124.003.033.007.065.007.098v2.334c0 .04-.002.081-.007.125.003.032.007.065.007.097v2.334c0 .378-.178.937-1.027 1.46-.873.538-2.235.923-3.923 1.076v.132c0 .377-.167.936-1.016 1.46C13.865 20.57 11.817 21 9.536 21c-2.28 0-4.34-.43-5.509-1.15C3.178 19.327 3 18.768 3 18.39v-2.333c0-.033.004-.065.007-.098A1.214 1.214 0 013 15.834v-2.222c0-.056.004-.112.012-.167A1.219 1.219 0 013 13.278v-2.334c0-.377.178-.936 1.027-1.46.89-.547 2.296-.927 3.923-1.077V5.61c0-.377.176-.936 1.025-1.46C10.143 3.43 12.2 3 14.48 3c2.28 0 4.334.43 5.503 1.15C20.833 4.673 21 5.232 21 5.61zm-1.503 10.818c.383-.236.603-.493.603-.705v-1.18c0 .028-.083.056-.127.084-.873.537-2.235.923-3.923 1.076v.131c0 .04-.002.082-.007.125.003.033.007.065.007.098v1.309c1.462-.144 2.701-.479 3.447-.938zm-4.94 2.668c.384-.236.593-.494.593-.705v-1.18c0 .028-.072.056-.116.083-1.169.72-3.217 1.15-5.498 1.15-2.28 0-4.34-.43-5.509-1.15a3.633 3.633 0 01-.127-.083v1.18c0 .211.217.469.6.705 1.017.626 2.943 1.015 5.03 1.015 2.089 0 4.011-.39 5.028-1.015zM8.85 6.986v1.363c.226-.008.453-.014.685-.014 2.28 0 4.339.43 5.507 1.15.085.052.16.105.232.158 1.784-.085 3.355-.454 4.234-.995.383-.236.592-.493.592-.705v-.957c0 .028-.072.055-.116.083-1.169.72-3.217 1.15-5.498 1.15-2.28 0-4.34-.43-5.509-1.15a3.684 3.684 0 01-.127-.083zm10.647 4.33c.383-.237.603-.494.603-.705V9.32c0 .028-.077.055-.122.083-.901.555-2.33.939-4.006 1.084.066.169.078.324.078.457v1.31c1.462-.145 2.701-.48 3.447-.938zM3.9 12.32v.957c0 .212.217.469.6.705 1.017.626 2.943 1.015 5.03 1.015 2.089 0 4.011-.389 5.028-1.015.383-.236.592-.493.592-.705v-.957c0 .027-.072.055-.116.083-1.169.72-3.217 1.15-5.498 1.15-2.28 0-4.34-.43-5.509-1.15a3.633 3.633 0 01-.127-.083zm0 3.513c0 .212.217.47.6.705 1.017.627 2.943 1.016 5.03 1.016 2.089 0 4.011-.39 5.028-1.016.383-.236.592-.493.592-.705v-1.18c0 .029-.072.056-.116.084-1.169.72-3.217 1.15-5.498 1.15-2.28 0-4.34-.43-5.509-1.15a3.633 3.633 0 01-.127-.083v1.18zm15.597-1.962c.383-.236.603-.493.603-.705v-1.18c0 .028-.083.056-.127.083-.873.538-2.235.923-3.923 1.076v.132c0 .052-.004.108-.012.167.008.055.012.111.012.167v1.197c1.462-.144 2.701-.478 3.447-.937z",
      fillRule: "evenodd"
    })
  }));
};

SvgCoins.displayName = 'SvgCoins';

var CoinsIcon = function CoinsIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCoins, _objectSpread$1h(_objectSpread$1h({}, props), {}, {
        className: createClass(getIconStyles$1h(props, theme))
      }));
    }
  });
};

CoinsIcon.displayName = 'CoinsIcon';
var CoinsIcon$1 = CoinsIcon;

function ownKeys$1g(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1g(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1g(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1g(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1g = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1g = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1g[size], "px"),
        height: "".concat(iconSizes$1g[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1g.big, "px"),
        height: "".concat(iconSizes$1g.big, "px")
      };
  }
};

var getSizeStyle$1g = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1g(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1g = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1g(_objectSpread$1g({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1g = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1g(props.color, theme), ";}&,image{", getSizeStyle$1g(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgColumns = function SvgColumns(props) {
  return jsx("svg", _objectSpread$1g(_objectSpread$1g({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M19.2 17.6h-2.7v-1.8h2.7v1.8zm-6.3-1.8h2.7v1.8h-2.7v-1.8zm-3.6 0H12v1.8H9.3v-1.8zM12 9.5H9.3V6.8H12v2.7zm3.6 0h-2.7V6.8h2.7v2.7zm3.6 0h-2.7V6.8h2.7v2.7zm-2.7 3.6h2.7v1.8h-2.7v-1.8zm-3.6 0h2.7v1.8h-2.7v-1.8zm-3.6 0H12v1.8H9.3v-1.8zm2.7-.9H9.3v-1.8H12v1.8zm3.6 0h-2.7v-1.8h2.7v1.8zm3.6 0h-2.7v-1.8h2.7v1.8zm.113-7.2H3.9a.9.9 0 00-.9.9v12.6a.9.9 0 00.9.9H20.1a.9.9 0 00.9-.9V5.9a.9.9 0 00-.9-.9h-.788z",
      fillRule: "evenodd"
    })
  }));
};

SvgColumns.displayName = 'SvgColumns';

var ColumnsIcon = function ColumnsIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgColumns, _objectSpread$1g(_objectSpread$1g({}, props), {}, {
        className: createClass(getIconStyles$1g(props, theme))
      }));
    }
  });
};

ColumnsIcon.displayName = 'ColumnsIcon';
var ColumnsIcon$1 = ColumnsIcon;

function ownKeys$1f(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1f(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1f(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1f(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1f = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1f = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1f[size], "px"),
        height: "".concat(iconSizes$1f[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1f.big, "px"),
        height: "".concat(iconSizes$1f.big, "px")
      };
  }
};

var getSizeStyle$1f = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1f(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1f = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1f(_objectSpread$1f({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1f = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1f(props.color, theme), ";}&,image{", getSizeStyle$1f(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgConnectedSquare = function SvgConnectedSquare(props) {
  return jsx("svg", _objectSpread$1f(_objectSpread$1f({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      d: "M7.8 4.6h6.5c.1 0 .2.2.2.4v1c0 .2-.1.4-.2.4H7.7c-.4.9-1.2 1.5-2.2 1.5C4.1 7.9 3 6.8 3 5.5S4.1 3 5.5 3c1 0 1.9.7 2.3 1.6zM4.6 16.3V9.8c0-.1.2-.2.4-.2h1c.2 0 .4.1.4.2v6.5c.9.4 1.4 1.2 1.4 2.2 0 1.4-1.1 2.5-2.5 2.5S3 19.9 3 18.6c0-1.1.7-2 1.6-2.3zm11.6 3H9.8c-.1 0-.2-.2-.2-.4v-1c0-.2.1-.4.2-.4h6.5c.4-.9 1.2-1.4 2.2-1.4 1.4 0 2.5 1.1 2.5 2.5S19.9 21 18.5 21c-1 0-1.9-.7-2.3-1.7zm3.2-11.5v6.5c0 .1-.2.2-.4.2h-1c-.2 0-.4-.1-.4-.2V7.7c-.9-.4-1.4-1.2-1.4-2.2 0-1.4 1.1-2.5 2.5-2.5S21 4.1 21 5.5c0 1-.7 1.9-1.6 2.3z"
    })
  }));
};

SvgConnectedSquare.displayName = 'SvgConnectedSquare';

var ConnectedSquareIcon = function ConnectedSquareIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgConnectedSquare, _objectSpread$1f(_objectSpread$1f({}, props), {}, {
        className: createClass(getIconStyles$1f(props, theme))
      }));
    }
  });
};

ConnectedSquareIcon.displayName = 'ConnectedSquareIcon';
var ConnectedSquareIcon$1 = ConnectedSquareIcon;

function ownKeys$1e(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1e(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1e(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1e(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1e = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1e = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1e[size], "px"),
        height: "".concat(iconSizes$1e[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1e.big, "px"),
        height: "".concat(iconSizes$1e.big, "px")
      };
  }
};

var getSizeStyle$1e = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1e(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1e = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1e(_objectSpread$1e({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1e = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1e(props.color, theme), ";}&,image{", getSizeStyle$1e(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgConnectedTriangle = function SvgConnectedTriangle(props) {
  return jsx("svg", _objectSpread$1e(_objectSpread$1e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M15.023 18.375H8.977A3 3 0 116.49 15.04l3.511-6.803a3 3 0 114.053-.051l3.74 6.82a3 3 0 11-2.771 3.368zm.195-1.5a3.01 3.01 0 011.133-1.381l-3.612-6.586a3.006 3.006 0 01-1.405.018l-3.47 6.723c.403.32.722.742.918 1.226h6.436z",
      fillRule: "nonzero"
    })
  }));
};

SvgConnectedTriangle.displayName = 'SvgConnectedTriangle';

var ConnectedTriangleIcon = function ConnectedTriangleIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgConnectedTriangle, _objectSpread$1e(_objectSpread$1e({}, props), {}, {
        className: createClass(getIconStyles$1e(props, theme))
      }));
    }
  });
};

ConnectedTriangleIcon.displayName = 'ConnectedTriangleIcon';
var ConnectedTriangleIcon$1 = ConnectedTriangleIcon;

function ownKeys$1d(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1d(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1d(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1d(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1d = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1d = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1d[size], "px"),
        height: "".concat(iconSizes$1d[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1d.big, "px"),
        height: "".concat(iconSizes$1d.big, "px")
      };
  }
};

var getSizeStyle$1d = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1d(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1d = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1d(_objectSpread$1d({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1d = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1d(props.color, theme), ";}&,image{", getSizeStyle$1d(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCopy = function SvgCopy(props) {
  return jsx("svg", _objectSpread$1d(_objectSpread$1d({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.91 15.324h-.564v2.762h.563v-2.762zm1.124 0h-.614v2.762h.614v-2.762zm-3.323 0h-1.075v2.762h1.075v-2.762zm1.125 2.762h-.614v-2.762h.614v2.762zM3.052 3.102v12.836H7.5V14.76H4.227V4.33H14.66v3.22h1.227V3.102H3.052zM7.5 20.336h12.784V7.552H7.5v12.784zM8.625 8.727h10.432V19.16H8.625V8.727z",
      fillRule: "evenodd"
    })
  }));
};

SvgCopy.displayName = 'SvgCopy';

var CopyIcon = function CopyIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCopy, _objectSpread$1d(_objectSpread$1d({}, props), {}, {
        className: createClass(getIconStyles$1d(props, theme))
      }));
    }
  });
};

CopyIcon.displayName = 'CopyIcon';
var CopyIcon$1 = CopyIcon;

function ownKeys$1c(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1c(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1c(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1c = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1c = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1c[size], "px"),
        height: "".concat(iconSizes$1c[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1c.big, "px"),
        height: "".concat(iconSizes$1c.big, "px")
      };
  }
};

var getSizeStyle$1c = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1c(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1c = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1c(_objectSpread$1c({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1c = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1c(props.color, theme), ";}&,image{", getSizeStyle$1c(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCube = function SvgCube(props) {
  return jsx("svg", _objectSpread$1c(_objectSpread$1c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M8.174 9.646l-.026.016-3.445-2.127L11.998 3l2.937 1.825.031-.02 4.327 2.73-7.295 4.535-3.824-2.424zm3.599 2.845v8.369L4.5 16.325v-8.37l3.513 2.198 3.76 2.338zm.45 0l7.273-4.535v8.369l-7.273 4.535v-8.37z",
      fillRule: "evenodd"
    })
  }));
};

SvgCube.displayName = 'SvgCube';

var CubeIcon = function CubeIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCube, _objectSpread$1c(_objectSpread$1c({}, props), {}, {
        className: createClass(getIconStyles$1c(props, theme))
      }));
    }
  });
};

CubeIcon.displayName = 'CubeIcon';
var CubeIcon$1 = CubeIcon;

function ownKeys$1b(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1b(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1b(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1b = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1b = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1b[size], "px"),
        height: "".concat(iconSizes$1b[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1b.big, "px"),
        height: "".concat(iconSizes$1b.big, "px")
      };
  }
};

var getSizeStyle$1b = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1b(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1b = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1b(_objectSpread$1b({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1b = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1b(props.color, theme), ";}&,image{", getSizeStyle$1b(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgCubes = function SvgCubes(props) {
  return jsx("svg", _objectSpread$1b(_objectSpread$1b({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.837 12.696l-4.265-1.558V6.393a.215.215 0 00-.145-.203L12.06 4.594a.218.218 0 00-.14 0L7.56 6.146a.201.201 0 00-.1.074.215.215 0 00-.05.136v4.78l-4.26 1.516a.203.203 0 00-.1.074.215.215 0 00-.05.137v4.823c0 .09.058.172.144.202l4.362 1.5a.22.22 0 00.141 0l4.344-1.493 4.335 1.493a.22.22 0 00.142 0l4.362-1.502a.214.214 0 00.152-.205V12.9a.214.214 0 00-.145-.203zm-5.025-1.885l-3.352 1.133V8.356l3.352-1.227v3.682zM11.99 5.373l3.117 1.162-3.114 1.15-3.29-1.132 3.287-1.18zm-4.407 8.82l-3.29-1.134 3.287-1.18 3.117 1.162-3.114 1.151zm3.819 3.125L8.05 18.45v-3.588l3.352-1.226v3.682zm5.001-3.126l-3.29-1.133 3.287-1.18 3.118 1.162-3.115 1.151zm3.819 3.126L16.87 18.45v-3.588l3.352-1.226v3.682z",
      fillRule: "evenodd"
    })
  }));
};

SvgCubes.displayName = 'SvgCubes';

var CubesIcon = function CubesIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgCubes, _objectSpread$1b(_objectSpread$1b({}, props), {}, {
        className: createClass(getIconStyles$1b(props, theme))
      }));
    }
  });
};

CubesIcon.displayName = 'CubesIcon';
var CubesIcon$1 = CubesIcon;

function ownKeys$1a(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1a(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1a(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1a = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1a = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1a[size], "px"),
        height: "".concat(iconSizes$1a[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1a.big, "px"),
        height: "".concat(iconSizes$1a.big, "px")
      };
  }
};

var getSizeStyle$1a = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1a(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1a = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1a(_objectSpread$1a({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1a = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1a(props.color, theme), ";}&,image{", getSizeStyle$1a(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgDot = function SvgDot(props) {
  return jsx("svg", _objectSpread$1a(_objectSpread$1a({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("circle", {
      cx: 106,
      cy: 18,
      r: 9,
      transform: "translate(-97 -9)",
      fillRule: "evenodd"
    })
  }));
};

SvgDot.displayName = 'SvgDot';

var DotIcon = function DotIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgDot, _objectSpread$1a(_objectSpread$1a({}, props), {}, {
        className: createClass(getIconStyles$1a(props, theme))
      }));
    }
  });
};

DotIcon.displayName = 'DotIcon';
var DotIcon$1 = DotIcon;

function ownKeys$19(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$19(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$19(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$19(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$19 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$19 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$19[size], "px"),
        height: "".concat(iconSizes$19[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$19.big, "px"),
        height: "".concat(iconSizes$19.big, "px")
      };
  }
};

var getSizeStyle$19 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$19(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$19 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$19(_objectSpread$19({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$19 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$19(props.color, theme), ";}&,image{", getSizeStyle$19(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgDownload = function SvgDownload(props) {
  return jsx("svg", _objectSpread$19(_objectSpread$19({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fillRule: "evenodd",
      children: jsx("path", {
        d: "M10.875 13.14V3.5a.5.5 0 01.5-.5H12.6a.5.5 0 01.5.5v9.662l4.804-4.844a.472.472 0 01.345-.151c.13 0 .246.05.346.151l.751.758a.482.482 0 010 .697l-7.002 7.061a.473.473 0 01-.346.152.473.473 0 01-.345-.152L4.65 9.773a.481.481 0 010-.697l.751-.758a.473.473 0 01.346-.151c.13 0 .246.05.346.151l4.782 4.823zM3.5 18.77h17a.5.5 0 01.5.5v1.23a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-1.23a.5.5 0 01.5-.5z",
        fillRule: "nonzero"
      })
    })
  }));
};

SvgDownload.displayName = 'SvgDownload';

var DownloadIcon = function DownloadIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgDownload, _objectSpread$19(_objectSpread$19({}, props), {}, {
        className: createClass(getIconStyles$19(props, theme))
      }));
    }
  });
};

DownloadIcon.displayName = 'DownloadIcon';
var DownloadIcon$1 = DownloadIcon;

function ownKeys$18(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$18(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$18(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$18(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$18 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$18 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$18[size], "px"),
        height: "".concat(iconSizes$18[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$18.big, "px"),
        height: "".concat(iconSizes$18.big, "px")
      };
  }
};

var getSizeStyle$18 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$18(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$18 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$18(_objectSpread$18({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$18 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$18(props.color, theme), ";}&,image{", getSizeStyle$18(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgDragDrop = function SvgDragDrop(props) {
  return jsx("svg", _objectSpread$18(_objectSpread$18({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12.982 9.877V7.293H16.076L12.037 3 8.076 7.293h3.016v6.753c0 .018 0 .035.002.052v2.585H8l4.039 4.292L16 16.683H12.983V9.929l-.001-.052z",
      fillRule: "evenodd"
    })
  }));
};

SvgDragDrop.displayName = 'SvgDragDrop';

var DragDropIcon = function DragDropIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgDragDrop, _objectSpread$18(_objectSpread$18({}, props), {}, {
        className: createClass(getIconStyles$18(props, theme))
      }));
    }
  });
};

DragDropIcon.displayName = 'DragDropIcon';
var DragDropIcon$1 = DragDropIcon;

function ownKeys$17(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$17(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$17(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$17(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$17 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$17 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$17[size], "px"),
        height: "".concat(iconSizes$17[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$17.big, "px"),
        height: "".concat(iconSizes$17.big, "px")
      };
  }
};

var getSizeStyle$17 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$17(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$17 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$17(_objectSpread$17({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$17 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$17(props.color, theme), ";}&,image{", getSizeStyle$17(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgDrag = function SvgDrag(props) {
  return jsx("svg", _objectSpread$17(_objectSpread$17({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M9 3h2v2H9V3zm4 0h2v2h-2V3zM9 7h2v2H9V7zm4 0h2v2h-2V7zm-4 4h2v2H9v-2zm4 0h2v2h-2v-2zm-4 4h2v2H9v-2zm4 0h2v2h-2v-2zm-4 4h2v2H9v-2zm4 0h2v2h-2v-2z",
      fillRule: "evenodd"
    })
  }));
};

SvgDrag.displayName = 'SvgDrag';

var DragIcon = function DragIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgDrag, _objectSpread$17(_objectSpread$17({}, props), {}, {
        className: createClass(getIconStyles$17(props, theme))
      }));
    }
  });
};

DragIcon.displayName = 'DragIcon';
var DragIcon$1 = DragIcon;

function ownKeys$16(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$16(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$16(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$16(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$16 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$16 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$16[size], "px"),
        height: "".concat(iconSizes$16[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$16.big, "px"),
        height: "".concat(iconSizes$16.big, "px")
      };
  }
};

var getSizeStyle$16 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$16(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$16 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$16(_objectSpread$16({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$16 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$16(props.color, theme), ";}&,image{", getSizeStyle$16(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkVkaXRSZWFjdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0hnRSIsImZpbGUiOiJFZGl0UmVhY3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLy8gVEhJUyBJUyBBTiBBVVRPR0VORVJBVEVEIEZJTEUuIERPIE5PVCBFRElUIFRISVMgRklMRSBESVJFQ1RMWS5cbi8vIFRoaXMgZmlsZSBpcyBjcmVhdGVkIHdpdGggJ3lhcm4gZ2VuZXJhdGUtaWNvbnMnLlxuLy8gT3JpZ2luYWwgU1ZHIGZpbGU6IHNyYy9zdmcvZWRpdC5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnRWRpdCA9IChwcm9wczogU1ZHUHJvcHMpID0+IChcbiAgPHN2Z1xuICAgIHdpZHRoPXsyNH1cbiAgICBoZWlnaHQ9ezI0fVxuICAgIHZpZXdCb3g9XCIwIDAgMjQgMjRcIlxuICAgIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIlxuICAgIHsuLi5wcm9wc31cbiAgPlxuICAgIDxwYXRoXG4gICAgICBkPVwiTTE2Ljg4MyAxMC44NTRsLTguMDI5IDguMDI5TDYgMTYuMDI4IDE0LjAyOCA4bDIuODU1IDIuODU0ek01IDE5Ljg1NFYxN2wyLjg1NSAyLjg1NUg1ek0xOC45NjIgNi4zNThhMS4zMzUgMS4zMzUgMCAwMTAgMS44ODhsLTEuMTA4IDEuMTA4TDE1IDYuNWwxLjEwOC0xLjEwOGExLjMzNSAxLjMzNSAwIDAxMS44ODggMGwuOTY2Ljk2NnpcIlxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cblN2Z0VkaXQuZGlzcGxheU5hbWUgPSAnU3ZnRWRpdCc7XG5cbmNvbnN0IEVkaXRJY29uID0gKHByb3BzOiBQcm9wcykgPT4ge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIHJldHVybiAoXG4gICAgPENsYXNzTmFtZXM+XG4gICAgICB7KHsgY3NzOiBjcmVhdGVDbGFzcyB9KSA9PiAoXG4gICAgICAgIDxTdmdFZGl0XG4gICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAgIGNsYXNzTmFtZT17Y3JlYXRlQ2xhc3MoZ2V0SWNvblN0eWxlcyhwcm9wcywgdGhlbWUpKX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgPC9DbGFzc05hbWVzPlxuICApO1xufTtcblxuRWRpdEljb24uZGlzcGxheU5hbWUgPSAnRWRpdEljb24nO1xuZXhwb3J0IGRlZmF1bHQgRWRpdEljb247XG4iXX0= */");
};

var SvgEdit = function SvgEdit(props) {
  return jsx("svg", _objectSpread$16(_objectSpread$16({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.883 10.854l-8.029 8.029L6 16.028 14.028 8l2.855 2.854zM5 19.854V17l2.855 2.855H5zM18.962 6.358a1.335 1.335 0 010 1.888l-1.108 1.108L15 6.5l1.108-1.108a1.335 1.335 0 011.888 0l.966.966z",
      fillRule: "evenodd"
    })
  }));
};

SvgEdit.displayName = 'SvgEdit';

var EditIcon = function EditIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgEdit, _objectSpread$16(_objectSpread$16({}, props), {}, {
        className: createClass(getIconStyles$16(props, theme))
      }));
    }
  });
};

EditIcon.displayName = 'EditIcon';
var EditIcon$1 = EditIcon;

function ownKeys$15(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$15(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$15(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$15(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$15 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$15 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$15[size], "px"),
        height: "".concat(iconSizes$15[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$15.big, "px"),
        height: "".concat(iconSizes$15.big, "px")
      };
  }
};

var getSizeStyle$15 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$15(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$15 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$15(_objectSpread$15({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$15 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$15(props.color, theme), ";}&,image{", getSizeStyle$15(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkVycm9yUmVhY3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStIZ0UiLCJmaWxlIjoiRXJyb3JSZWFjdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvLyBUSElTIElTIEFOIEFVVE9HRU5FUkFURUQgRklMRS4gRE8gTk9UIEVESVQgVEhJUyBGSUxFIERJUkVDVExZLlxuLy8gVGhpcyBmaWxlIGlzIGNyZWF0ZWQgd2l0aCAneWFybiBnZW5lcmF0ZS1pY29ucycuXG4vLyBPcmlnaW5hbCBTVkcgZmlsZTogc3JjL3N2Zy9lcnJvci5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnRXJyb3IgPSAocHJvcHM6IFNWR1Byb3BzKSA9PiAoXG4gIDxzdmdcbiAgICB3aWR0aD17MjR9XG4gICAgaGVpZ2h0PXsyNH1cbiAgICB2aWV3Qm94PVwiMCAwIDI0IDI0XCJcbiAgICB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCJcbiAgICB7Li4ucHJvcHN9XG4gID5cbiAgICA8cGF0aFxuICAgICAgZD1cIk04LjMzNyAxNy40OTFhNi42IDYuNiAwIDAwOS4xNTQtOS4xNTRsLTkuMTU0IDkuMTU0em0tMS43Mi0xLjY3M2w5LjIwMS05LjIwMmE2LjYgNi42IDAgMDAtOS4yMDIgOS4yMDJ6TTEyIDIxYTkgOSAwIDExMC0xOCA5IDkgMCAwMTAgMTh6XCJcbiAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5TdmdFcnJvci5kaXNwbGF5TmFtZSA9ICdTdmdFcnJvcic7XG5cbmNvbnN0IEVycm9ySWNvbiA9IChwcm9wczogUHJvcHMpID0+IHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICByZXR1cm4gKFxuICAgIDxDbGFzc05hbWVzPlxuICAgICAgeyh7IGNzczogY3JlYXRlQ2xhc3MgfSkgPT4gKFxuICAgICAgICA8U3ZnRXJyb3JcbiAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgICAgY2xhc3NOYW1lPXtjcmVhdGVDbGFzcyhnZXRJY29uU3R5bGVzKHByb3BzLCB0aGVtZSkpfVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICA8L0NsYXNzTmFtZXM+XG4gICk7XG59O1xuXG5FcnJvckljb24uZGlzcGxheU5hbWUgPSAnRXJyb3JJY29uJztcbmV4cG9ydCBkZWZhdWx0IEVycm9ySWNvbjtcbiJdfQ== */");
};

var SvgError = function SvgError(props) {
  return jsx("svg", _objectSpread$15(_objectSpread$15({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M8.337 17.491a6.6 6.6 0 009.154-9.154l-9.154 9.154zm-1.72-1.673l9.201-9.202a6.6 6.6 0 00-9.202 9.202zM12 21a9 9 0 110-18 9 9 0 010 18z",
      fillRule: "evenodd"
    })
  }));
};

SvgError.displayName = 'SvgError';

var ErrorIcon = function ErrorIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgError, _objectSpread$15(_objectSpread$15({}, props), {}, {
        className: createClass(getIconStyles$15(props, theme))
      }));
    }
  });
};

ErrorIcon.displayName = 'ErrorIcon';
var ErrorIcon$1 = ErrorIcon;

function ownKeys$14(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$14(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$14(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$14(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$14 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$14 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$14[size], "px"),
        height: "".concat(iconSizes$14[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$14.big, "px"),
        height: "".concat(iconSizes$14.big, "px")
      };
  }
};

var getSizeStyle$14 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$14(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$14 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$14(_objectSpread$14({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$14 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$14(props.color, theme), ";}&,image{", getSizeStyle$14(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgExpand = function SvgExpand(props) {
  return jsx("svg", _objectSpread$14(_objectSpread$14({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M10.344 12.532l1.094 1.094-4.741 4.74 2.591 2.593H3V14.67l2.602 2.603 4.742-4.741zM20.959 3v6.288l-2.592-2.591-4.741 4.74-1.094-1.093 4.74-4.742L14.67 3h6.289z",
      fillRule: "evenodd"
    })
  }));
};

SvgExpand.displayName = 'SvgExpand';

var ExpandIcon = function ExpandIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgExpand, _objectSpread$14(_objectSpread$14({}, props), {}, {
        className: createClass(getIconStyles$14(props, theme))
      }));
    }
  });
};

ExpandIcon.displayName = 'ExpandIcon';
var ExpandIcon$1 = ExpandIcon;

function ownKeys$13(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$13(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$13(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$13(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$13 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$13 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$13[size], "px"),
        height: "".concat(iconSizes$13[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$13.big, "px"),
        height: "".concat(iconSizes$13.big, "px")
      };
  }
};

var getSizeStyle$13 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$13(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$13 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$13(_objectSpread$13({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$13 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$13(props.color, theme), ";}&,image{", getSizeStyle$13(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4cG9ydFJlYWN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErSGdFIiwiZmlsZSI6IkV4cG9ydFJlYWN0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8vIFRISVMgSVMgQU4gQVVUT0dFTkVSQVRFRCBGSUxFLiBETyBOT1QgRURJVCBUSElTIEZJTEUgRElSRUNUTFkuXG4vLyBUaGlzIGZpbGUgaXMgY3JlYXRlZCB3aXRoICd5YXJuIGdlbmVyYXRlLWljb25zJy5cbi8vIE9yaWdpbmFsIFNWRyBmaWxlOiBzcmMvc3ZnL2V4cG9ydC5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnRXhwb3J0ID0gKHByb3BzOiBTVkdQcm9wcykgPT4gKFxuICA8c3ZnXG4gICAgd2lkdGg9ezI0fVxuICAgIGhlaWdodD17MjR9XG4gICAgdmlld0JveD1cIjAgMCAyNCAyNFwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gICAgey4uLnByb3BzfVxuICA+XG4gICAgPHBhdGhcbiAgICAgIGQ9XCJNOS45NTQgMTRDOS40MjcgMTQgOSAxMy41NDMgOSAxM2MwLS41NDIuNDI3LTEgLjk1NC0xSDE3VjlsNCA0LTQgNHYtM0g5Ljk1NHpNNy40MTQgM0gxNmExIDEgMCAwMTEgMXYzYTEgMSAwIDAxLTIgMFY1aC01djVINXY5aDEwYTEgMSAwIDAxMiAwdjFhMSAxIDAgMDEtMSAxSDRhMSAxIDAgMDEtMS0xVjcuNDE0YTEgMSAwIDAxLjI5My0uNzA3bDMuNDE0LTMuNDE0QTEgMSAwIDAxNy40MTQgM3pNNSA4aDNWNWgtLjE3Mkw1IDcuODI4Vjh6XCJcbiAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5TdmdFeHBvcnQuZGlzcGxheU5hbWUgPSAnU3ZnRXhwb3J0JztcblxuY29uc3QgRXhwb3J0SWNvbiA9IChwcm9wczogUHJvcHMpID0+IHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICByZXR1cm4gKFxuICAgIDxDbGFzc05hbWVzPlxuICAgICAgeyh7IGNzczogY3JlYXRlQ2xhc3MgfSkgPT4gKFxuICAgICAgICA8U3ZnRXhwb3J0XG4gICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAgIGNsYXNzTmFtZT17Y3JlYXRlQ2xhc3MoZ2V0SWNvblN0eWxlcyhwcm9wcywgdGhlbWUpKX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgPC9DbGFzc05hbWVzPlxuICApO1xufTtcblxuRXhwb3J0SWNvbi5kaXNwbGF5TmFtZSA9ICdFeHBvcnRJY29uJztcbmV4cG9ydCBkZWZhdWx0IEV4cG9ydEljb247XG4iXX0= */");
};

var SvgExport = function SvgExport(props) {
  return jsx("svg", _objectSpread$13(_objectSpread$13({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M9.954 14C9.427 14 9 13.543 9 13c0-.542.427-1 .954-1H17V9l4 4-4 4v-3H9.954zM7.414 3H16a1 1 0 011 1v3a1 1 0 01-2 0V5h-5v5H5v9h10a1 1 0 012 0v1a1 1 0 01-1 1H4a1 1 0 01-1-1V7.414a1 1 0 01.293-.707l3.414-3.414A1 1 0 017.414 3zM5 8h3V5h-.172L5 7.828V8z",
      fillRule: "evenodd"
    })
  }));
};

SvgExport.displayName = 'SvgExport';

var ExportIcon = function ExportIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgExport, _objectSpread$13(_objectSpread$13({}, props), {}, {
        className: createClass(getIconStyles$13(props, theme))
      }));
    }
  });
};

ExportIcon.displayName = 'ExportIcon';
var ExportIcon$1 = ExportIcon;

function ownKeys$12(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$12(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$12(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$12(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$12 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$12 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$12[size], "px"),
        height: "".concat(iconSizes$12[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$12.big, "px"),
        height: "".concat(iconSizes$12.big, "px")
      };
  }
};

var getSizeStyle$12 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$12(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$12 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$12(_objectSpread$12({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$12 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$12(props.color, theme), ";}&,image{", getSizeStyle$12(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgExternalLink = function SvgExternalLink(props) {
  return jsx("svg", _objectSpread$12(_objectSpread$12({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M17.822 4.788l-6.534 6.533a.984.984 0 001.391 1.391l6.532-6.53v2.184a.895.895 0 001.789 0V3.893A.89.89 0 0020.106 3h-4.473a.895.895 0 000 1.788h2.19zM21 9.522v9.235C21 19.996 20.107 21 19.005 21H4.995C3.893 21 3 19.994 3 18.757V7.243C3 6.004 3.893 5 4.995 5H10.2a.9.9 0 110 1.8H5.313c-.287 0-.513.269-.513.6v11.2c0 .325.23.6.513.6h13.374c.287 0 .513-.269.513-.6v-4.8a.9.9 0 111.8 0V9.522z",
      fill: "#1A1A1A",
      fillRule: "evenodd"
    })
  }));
};

SvgExternalLink.displayName = 'SvgExternalLink';

var ExternalLinkIcon = function ExternalLinkIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgExternalLink, _objectSpread$12(_objectSpread$12({}, props), {}, {
        className: createClass(getIconStyles$12(props, theme))
      }));
    }
  });
};

ExternalLinkIcon.displayName = 'ExternalLinkIcon';
var ExternalLinkIcon$1 = ExternalLinkIcon;

function ownKeys$11(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$11(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$11(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$11(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$11 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$11 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$11[size], "px"),
        height: "".concat(iconSizes$11[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$11.big, "px"),
        height: "".concat(iconSizes$11.big, "px")
      };
  }
};

var getSizeStyle$11 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$11(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$11 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$11(_objectSpread$11({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$11 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$11(props.color, theme), ";}&,image{", getSizeStyle$11(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgEyeCrossed = function SvgEyeCrossed(props) {
  return jsx("svg", _objectSpread$11(_objectSpread$11({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M15.6 6.487L13.776 8.37a3.327 3.327 0 00-1.254-.244c-1.895 0-3.432 1.587-3.432 3.544 0 .458.084.894.237 1.296L8.295 14.03a5.068 5.068 0 01-.577-2.36c0-1.421.578-2.703 1.505-3.608a9.877 9.877 0 00-1.728.886l-.121.078c-.126.084-.249.17-.367.256-.712.52-1.256 1.072-1.609 1.556-.08.11-.146.211-.202.305a2.441 2.441 0 00-.155.302.846.846 0 00-.068.224l.003.02a1.272 1.272 0 00.066.205c.066.16.18.365.356.607.353.484.897 1.035 1.609 1.556.242.177.499.347.77.509l-1 1.033C4.833 14.355 3.6 12.72 3.6 11.67 3.6 9.78 7.595 6 12.522 6c1.082 0 2.119.182 3.078.487zm-4.776 8.542c.389.158.812.245 1.254.245 1.895 0 3.432-1.587 3.432-3.544a3.64 3.64 0 00-.237-1.296l1.032-1.065c.368.702.577 1.506.577 2.36 0 1.421-.578 2.703-1.505 3.608a9.967 9.967 0 002.216-1.22c.712-.52 1.256-1.072 1.609-1.556.115-.159.204-.302.27-.427a2.393 2.393 0 00.087-.18.848.848 0 00.068-.224.391.391 0 00-.012-.061 1.184 1.184 0 00-.056-.164 3.123 3.123 0 00-.357-.607c-.353-.484-.897-1.035-1.609-1.556a9.785 9.785 0 00-.77-.509l1-1.033C19.767 9.045 21 10.68 21 11.73c0 1.89-3.994 5.67-8.922 5.67A10.18 10.18 0 019 16.913l1.824-1.884zM19.59 3.242a.826.826 0 111.168 1.168L4.41 20.758a.826.826 0 01-1.168-1.168L19.59 3.242z",
      fill: "#1A1A1A",
      fillRule: "evenodd"
    })
  }));
};

SvgEyeCrossed.displayName = 'SvgEyeCrossed';

var EyeCrossedIcon = function EyeCrossedIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgEyeCrossed, _objectSpread$11(_objectSpread$11({}, props), {}, {
        className: createClass(getIconStyles$11(props, theme))
      }));
    }
  });
};

EyeCrossedIcon.displayName = 'EyeCrossedIcon';
var EyeCrossedIcon$1 = EyeCrossedIcon;

function ownKeys$10(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$10(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$10(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$10(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$10 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$10 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$10[size], "px"),
        height: "".concat(iconSizes$10[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$10.big, "px"),
        height: "".concat(iconSizes$10.big, "px")
      };
  }
};

var getSizeStyle$10 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$10(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$10 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$10(_objectSpread$10({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$10 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$10(props.color, theme), ";}&,image{", getSizeStyle$10(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgEye = function SvgEye(props) {
  return jsx("svg", _objectSpread$10(_objectSpread$10({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M3.535 11.65c0-2.454 4.772-5.73 8.756-5.73 3.98 0 8.7 3.27 8.7 5.73 0 2.47-4.72 5.79-8.7 5.79-3.984 0-8.756-3.326-8.756-5.79zm1.4 0c0 1.56 4.06 4.39 7.356 4.39 3.29 0 7.3-2.82 7.3-4.39 0-1.553-4.007-4.33-7.3-4.33-3.299 0-7.356 2.785-7.356 4.33zm7.282 3.16a3 3 0 110-6 3 3 0 010 6z",
      fill: "#1A1A1A",
      fillRule: "evenodd"
    })
  }));
};

SvgEye.displayName = 'SvgEye';

var EyeIcon = function EyeIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgEye, _objectSpread$10(_objectSpread$10({}, props), {}, {
        className: createClass(getIconStyles$10(props, theme))
      }));
    }
  });
};

EyeIcon.displayName = 'EyeIcon';
var EyeIcon$1 = EyeIcon;

function ownKeys$$(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$$(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$$(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$$(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$$ = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$$ = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$$[size], "px"),
        height: "".concat(iconSizes$$[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$$.big, "px"),
        height: "".concat(iconSizes$$.big, "px")
      };
  }
};

var getSizeStyle$$ = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$$(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$$ = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$$(_objectSpread$$({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$$ = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$$(props.color, theme), ";}&,image{", getSizeStyle$$(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgFilterAndList = function SvgFilterAndList(props) {
  return jsx("svg", _objectSpread$$(_objectSpread$$({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.25 18a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5zM18.026 3c.35 0 .586.216.685.508.068.229.052.546-.085.804l-.097.148-5.503 6.601v9.05c0 .375-.145.639-.436.79a.736.736 0 01-.188.06l-.09.008c-.162 0-.301-.055-.419-.164l-.084-.092-2.858-3.427a.893.893 0 01-.198-.434l-.014-.169v-5.622L3.236 4.459c-.23-.258-.283-.687-.197-.967.12-.297.327-.446.574-.483L3.739 3h14.287zm-1.484 1.498L5.22 4.495l5.02 6.023-.005 5.965 1.29 1.548v-7.513l5.017-6.02zM20.25 13.5a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5zm0-4.5a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5z",
      fillRule: "nonzero"
    })
  }));
};

SvgFilterAndList.displayName = 'SvgFilterAndList';

var FilterAndListIcon = function FilterAndListIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgFilterAndList, _objectSpread$$(_objectSpread$$({}, props), {}, {
        className: createClass(getIconStyles$$(props, theme))
      }));
    }
  });
};

FilterAndListIcon.displayName = 'FilterAndListIcon';
var FilterAndListIcon$1 = FilterAndListIcon;

function ownKeys$_(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$_(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$_(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$_(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$_ = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$_ = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$_[size], "px"),
        height: "".concat(iconSizes$_[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$_.big, "px"),
        height: "".concat(iconSizes$_.big, "px")
      };
  }
};

var getSizeStyle$_ = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$_(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$_ = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$_(_objectSpread$_({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$_ = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$_(props.color, theme), ";}&,image{", getSizeStyle$_(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgFilter = function SvgFilter(props) {
  return jsx("svg", _objectSpread$_(_objectSpread$_({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M19.718 3H4.298c-.325 0-.606.143-.756.483-.093.275-.036.695.213.949l5.94 6.476v5.516c0 .227.076.425.228.591l3.085 3.362c.144.167.325.25.542.25a.78.78 0 00.302-.066c.313-.148.47-.407.47-.775v-8.878l5.94-6.476a.996.996 0 00.195-.934.752.752 0 00-.739-.498z",
      fillRule: "evenodd"
    })
  }));
};

SvgFilter.displayName = 'SvgFilter';

var FilterIcon = function FilterIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgFilter, _objectSpread$_(_objectSpread$_({}, props), {}, {
        className: createClass(getIconStyles$_(props, theme))
      }));
    }
  });
};

FilterIcon.displayName = 'FilterIcon';
var FilterIcon$1 = FilterIcon;

function ownKeys$Z(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$Z(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$Z(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$Z(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$Z = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$Z = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$Z[size], "px"),
        height: "".concat(iconSizes$Z[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$Z.big, "px"),
        height: "".concat(iconSizes$Z.big, "px")
      };
  }
};

var getSizeStyle$Z = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$Z(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$Z = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$Z(_objectSpread$Z({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$Z = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$Z(props.color, theme), ";}&,image{", getSizeStyle$Z(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgFlagFilled = function SvgFlagFilled(props) {
  return jsx("svg", _objectSpread$Z(_objectSpread$Z({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M4 3v18h1.838v-8.451H20l-4.526-4.336L20 3.878H5.838V3",
      fillRule: "evenodd"
    })
  }));
};

SvgFlagFilled.displayName = 'SvgFlagFilled';

var FlagFilledIcon = function FlagFilledIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgFlagFilled, _objectSpread$Z(_objectSpread$Z({}, props), {}, {
        className: createClass(getIconStyles$Z(props, theme))
      }));
    }
  });
};

FlagFilledIcon.displayName = 'FlagFilledIcon';
var FlagFilledIcon$1 = FlagFilledIcon;

function ownKeys$Y(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$Y(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$Y(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$Y(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$Y = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$Y = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$Y[size], "px"),
        height: "".concat(iconSizes$Y[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$Y.big, "px"),
        height: "".concat(iconSizes$Y.big, "px")
      };
  }
};

var getSizeStyle$Y = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$Y(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$Y = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$Y(_objectSpread$Y({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$Y = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$Y(props.color, theme), ";}&,image{", getSizeStyle$Y(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgFlagLinear = function SvgFlagLinear(props) {
  return jsx("svg", _objectSpread$Y(_objectSpread$Y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M4.167 3.25v17.417h1.79v-8.178H19.75l-4.408-4.195L19.75 4.1H5.957v-.85h-1.79zm1.79 2.549h9.479l-2.623 2.495 2.623 2.496h-9.48V5.8z",
      fillRule: "evenodd"
    })
  }));
};

SvgFlagLinear.displayName = 'SvgFlagLinear';

var FlagLinearIcon = function FlagLinearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgFlagLinear, _objectSpread$Y(_objectSpread$Y({}, props), {}, {
        className: createClass(getIconStyles$Y(props, theme))
      }));
    }
  });
};

FlagLinearIcon.displayName = 'FlagLinearIcon';
var FlagLinearIcon$1 = FlagLinearIcon;

function ownKeys$X(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$X(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$X(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$X(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$X = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$X = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$X[size], "px"),
        height: "".concat(iconSizes$X[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$X.big, "px"),
        height: "".concat(iconSizes$X.big, "px")
      };
  }
};

var getSizeStyle$X = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$X(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$X = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$X(_objectSpread$X({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$X = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$X(props.color, theme), ";}&,image{", getSizeStyle$X(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgFlame = function SvgFlame(props) {
  return jsx("svg", _objectSpread$X(_objectSpread$X({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12.014 21C8.134 21 5 17.735 5 13.692c0-1.677.539-3.953 2.156-4.492 0 0 .266 2.208 1.617 3.347.173-1.857-1.1-7.42 4.305-9.547 0 3.414-.532 3.37 1.085 9 0-3.384.812-4.418 3.17-5.106-.03 3.264 1.667 4.372 1.667 6.768.029 4.073-3.105 7.338-6.986 7.338z",
      fillRule: "evenodd"
    })
  }));
};

SvgFlame.displayName = 'SvgFlame';

var FlameIcon = function FlameIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgFlame, _objectSpread$X(_objectSpread$X({}, props), {}, {
        className: createClass(getIconStyles$X(props, theme))
      }));
    }
  });
};

FlameIcon.displayName = 'FlameIcon';
var FlameIcon$1 = FlameIcon;

function ownKeys$W(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$W(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$W(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$W(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$W = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$W = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$W[size], "px"),
        height: "".concat(iconSizes$W[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$W.big, "px"),
        height: "".concat(iconSizes$W.big, "px")
      };
  }
};

var getSizeStyle$W = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$W(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$W = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$W(_objectSpread$W({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$W = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$W(props.color, theme), ";}&,image{", getSizeStyle$W(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgFractionDigits = function SvgFractionDigits(props) {
  return jsx("svg", _objectSpread$W(_objectSpread$W({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsxs("g", {
      fillRule: "evenodd",
      children: [jsx("path", {
        d: "M4.686 11.162c0-.328.087-.576.263-.744.176-.168.432-.252.768-.252.324 0 .575.086.753.258.177.172.266.418.266.738 0 .309-.09.552-.27.73-.179.177-.429.266-.75.266-.327 0-.581-.087-.76-.26-.18-.174-.27-.42-.27-.736zm9.158-3.445c0 1.496-.245 2.603-.736 3.322-.49.719-1.245 1.078-2.264 1.078-.989 0-1.734-.37-2.236-1.113-.502-.742-.753-1.838-.753-3.287 0-1.512.245-2.626.733-3.343.488-.717 1.24-1.075 2.256-1.075.988 0 1.735.375 2.241 1.125s.759 1.847.759 3.293zm-4.19 0c0 1.05.091 1.804.273 2.259.181.455.487.682.917.682.422 0 .726-.23.914-.691.187-.461.281-1.211.281-2.25 0-1.051-.095-1.806-.284-2.265-.19-.459-.493-.688-.911-.688-.426 0-.73.23-.914.688-.184.46-.276 1.214-.276 2.265zm11.04 0c0 1.496-.246 2.603-.736 3.322-.49.719-1.245 1.078-2.265 1.078-.988 0-1.733-.37-2.235-1.113-.502-.742-.753-1.838-.753-3.287 0-1.512.244-2.626.732-3.343.489-.717 1.24-1.075 2.256-1.075.989 0 1.736.375 2.242 1.125.505.75.758 1.847.758 3.293zm-4.19 0c0 1.05.09 1.804.272 2.259.182.455.488.682.917.682.422 0 .727-.23.914-.691.188-.461.282-1.211.282-2.25 0-1.051-.095-1.806-.285-2.265-.189-.459-.493-.688-.91-.688-.426 0-.731.23-.915.688-.183.46-.275 1.214-.275 2.265z",
        fill: "#1A1A1A",
        fillRule: "nonzero"
      }), jsxs("g", {
        fill: "#1A1A1A",
        fillRule: "nonzero",
        children: [jsx("path", {
          d: "M7.002 18.017l-.004-2 10.5-.019.004 2z"
        }), jsx("path", {
          d: "M16.945 13.581v6.869l4.145-3.466z"
        })]
      })]
    })
  }));
};

SvgFractionDigits.displayName = 'SvgFractionDigits';

var FractionDigitsIcon = function FractionDigitsIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgFractionDigits, _objectSpread$W(_objectSpread$W({}, props), {}, {
        className: createClass(getIconStyles$W(props, theme))
      }));
    }
  });
};

FractionDigitsIcon.displayName = 'FractionDigitsIcon';
var FractionDigitsIcon$1 = FractionDigitsIcon;

function ownKeys$V(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$V(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$V(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$V(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$V = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$V = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$V[size], "px"),
        height: "".concat(iconSizes$V[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$V.big, "px"),
        height: "".concat(iconSizes$V.big, "px")
      };
  }
};

var getSizeStyle$V = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$V(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$V = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$V(_objectSpread$V({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$V = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$V(props.color, theme), ";}&,image{", getSizeStyle$V(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgGear = function SvgGear(props) {
  return jsx("svg", _objectSpread$V(_objectSpread$V({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M13.993 2.982l.235 2.102a7.241 7.241 0 012.625 1.515l1.937-.851 2 3.468-1.71 1.25c.104.49.163.996.163 1.516s-.06 1.026-.164 1.516l1.711 1.25-2 3.468-1.937-.851a7.241 7.241 0 01-2.625 1.515l-.235 2.102h-4L9.76 18.88a7.241 7.241 0 01-2.625-1.515l-1.937.851-2-3.468 1.71-1.25a7.269 7.269 0 01-.164-1.516c0-.52.06-1.026.165-1.516l-1.711-1.25 2-3.468 1.937.851A7.241 7.241 0 019.76 5.084l.234-2.102h4zm-2 4.625a4.366 4.366 0 00-4.375 4.375 4.366 4.366 0 004.375 4.375 4.366 4.366 0 004.375-4.375 4.366 4.366 0 00-4.375-4.375z",
      fillRule: "evenodd"
    })
  }));
};

SvgGear.displayName = 'SvgGear';

var GearIcon = function GearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgGear, _objectSpread$V(_objectSpread$V({}, props), {}, {
        className: createClass(getIconStyles$V(props, theme))
      }));
    }
  });
};

GearIcon.displayName = 'GearIcon';
var GearIcon$1 = GearIcon;

function ownKeys$U(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$U(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$U(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$U(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$U = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$U = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$U[size], "px"),
        height: "".concat(iconSizes$U[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$U.big, "px"),
        height: "".concat(iconSizes$U.big, "px")
      };
  }
};

var getSizeStyle$U = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$U(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$U = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$U(_objectSpread$U({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$U = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$U(props.color, theme), ";}&,image{", getSizeStyle$U(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgGraduationCap = function SvgGraduationCap(props) {
  return jsx("svg", _objectSpread$U(_objectSpread$U({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M15.872 17.068L12 19l-3.872-1.932c-.772-.445-1.065-1.24-1.087-2.146-.092-.57 0-2.18 0-2.922L12 14.906 16.96 12c0 .742.091 2.352-.001 2.922-.021.905-.315 1.7-1.087 2.146zM12 4l9 4.802-1.375.734v4.093a.702.702 0 01.515.672c0 .386-.32.699-.714.699a.707.707 0 01-.714-.7c0-.318.217-.586.515-.67V9.747c-2.41 1.285-4.82 2.568-7.227 3.857C9.003 12 6 10.403 3 8.802L12 4z",
      fill: "#1A1A1A",
      fillRule: "evenodd"
    })
  }));
};

SvgGraduationCap.displayName = 'SvgGraduationCap';

var GraduationCapIcon = function GraduationCapIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgGraduationCap, _objectSpread$U(_objectSpread$U({}, props), {}, {
        className: createClass(getIconStyles$U(props, theme))
      }));
    }
  });
};

GraduationCapIcon.displayName = 'GraduationCapIcon';
var GraduationCapIcon$1 = GraduationCapIcon;

function ownKeys$T(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$T(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$T(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$T(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$T = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$T = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$T[size], "px"),
        height: "".concat(iconSizes$T[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$T.big, "px"),
        height: "".concat(iconSizes$T.big, "px")
      };
  }
};

var getSizeStyle$T = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$T(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$T = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$T(_objectSpread$T({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$T = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$T(props.color, theme), ";}&,image{", getSizeStyle$T(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgGraph = function SvgGraph(props) {
  return jsx("svg", _objectSpread$T(_objectSpread$T({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M3 12.51c0-.282.215-.51.498-.51h4.004a.5.5 0 01.498.51v7.98c0 .282-.215.51-.498.51H3.498A.5.5 0 013 20.49v-7.98zM9.51 3.5c0-.276.216-.5.498-.5h4.005c.275 0 .498.228.498.5v17c0 .276-.215.5-.498.5h-4.005a.501.501 0 01-.497-.5v-17zM16 8.494A.49.49 0 0116.498 8h4.004c.275 0 .498.226.498.494v12.012a.49.49 0 01-.498.494h-4.004a.499.499 0 01-.498-.494V8.494z",
      fillRule: "evenodd"
    })
  }));
};

SvgGraph.displayName = 'SvgGraph';

var GraphIcon = function GraphIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgGraph, _objectSpread$T(_objectSpread$T({}, props), {}, {
        className: createClass(getIconStyles$T(props, theme))
      }));
    }
  });
};

GraphIcon.displayName = 'GraphIcon';
var GraphIcon$1 = GraphIcon;

function ownKeys$S(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$S(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$S(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$S(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$S = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$S = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$S[size], "px"),
        height: "".concat(iconSizes$S[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$S.big, "px"),
        height: "".concat(iconSizes$S.big, "px")
      };
  }
};

var getSizeStyle$S = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$S(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$S = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$S(_objectSpread$S({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$S = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$S(props.color, theme), ";}&,image{", getSizeStyle$S(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgGrid = function SvgGrid(props) {
  return jsx("svg", _objectSpread$S(_objectSpread$S({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fillRule: "evenodd",
      children: jsx("path", {
        fill: "#1A1A1A",
        d: "M0 .5h7.5v3H0zM10.5.5H18v3h-7.5zM0 5h7.5v3H0zM10.5 5H18v3h-7.5zM0 9.5h7.5v3H0zM10.5 9.5H18v3h-7.5zM0 14h7.5v3H0zM10.5 14H18v3h-7.5z"
      })
    })
  }));
};

SvgGrid.displayName = 'SvgGrid';

var GridIcon = function GridIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgGrid, _objectSpread$S(_objectSpread$S({}, props), {}, {
        className: createClass(getIconStyles$S(props, theme))
      }));
    }
  });
};

GridIcon.displayName = 'GridIcon';
var GridIcon$1 = GridIcon;

function ownKeys$R(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$R(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$R(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$R(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$R = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$R = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$R[size], "px"),
        height: "".concat(iconSizes$R[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$R.big, "px"),
        height: "".concat(iconSizes$R.big, "px")
      };
  }
};

var getSizeStyle$R = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$R(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$R = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$R(_objectSpread$R({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$R = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$R(props.color, theme), ";}&,image{", getSizeStyle$R(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgHeart = function SvgHeart(props) {
  return jsx("svg", _objectSpread$R(_objectSpread$R({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      className: "heart_react_svg__st0",
      d: "M16 3.7c-1.7 0-3.3.9-4.1 2.4-.9-1.5-2.4-2.4-4-2.4-2.5 0-4.6 2.1-4.8 5 0 .1-.1.8.2 1.9.4 1.6 1.2 3 2.5 4.1l6.2 5.7 6.3-5.7c1.2-1.1 2.1-2.6 2.5-4.1.3-1.1.2-1.8.2-1.9-.4-3-2.5-5-5-5z"
    })
  }));
};

SvgHeart.displayName = 'SvgHeart';

var HeartIcon = function HeartIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgHeart, _objectSpread$R(_objectSpread$R({}, props), {}, {
        className: createClass(getIconStyles$R(props, theme))
      }));
    }
  });
};

HeartIcon.displayName = 'HeartIcon';
var HeartIcon$1 = HeartIcon;

function ownKeys$Q(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$Q(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$Q(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$Q(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$Q = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$Q = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$Q[size], "px"),
        height: "".concat(iconSizes$Q[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$Q.big, "px"),
        height: "".concat(iconSizes$Q.big, "px")
      };
  }
};

var getSizeStyle$Q = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$Q(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$Q = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$Q(_objectSpread$Q({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$Q = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$Q(props.color, theme), ";}&,image{", getSizeStyle$Q(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltcG9ydFJlYWN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErSGdFIiwiZmlsZSI6IkltcG9ydFJlYWN0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8vIFRISVMgSVMgQU4gQVVUT0dFTkVSQVRFRCBGSUxFLiBETyBOT1QgRURJVCBUSElTIEZJTEUgRElSRUNUTFkuXG4vLyBUaGlzIGZpbGUgaXMgY3JlYXRlZCB3aXRoICd5YXJuIGdlbmVyYXRlLWljb25zJy5cbi8vIE9yaWdpbmFsIFNWRyBmaWxlOiBzcmMvc3ZnL2ltcG9ydC5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnSW1wb3J0ID0gKHByb3BzOiBTVkdQcm9wcykgPT4gKFxuICA8c3ZnXG4gICAgd2lkdGg9ezI0fVxuICAgIGhlaWdodD17MjR9XG4gICAgdmlld0JveD1cIjAgMCAyNCAyNFwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gICAgey4uLnByb3BzfVxuICA+XG4gICAgPHBhdGhcbiAgICAgIGQ9XCJNMy4zMjkgMTkuODU1aDE3LjAxNVYzLjU4SDMuMzN2MTYuMjc1ek00LjUgNC44MzVoMTQuNzE5VjE4LjZINC41VjQuODM1ek0xNS41MTYgMTcuMmgtNy4zNnYtNC4wNTdoNy4zNnY0LjA1N3pNMTIuMDk0IDYuMzhjLS4xNDEtLjE5NC0uMzc1LS4xOTQtLjUxNiAwTDkuNTYyIDguNDU4aDEuMjY2djMuNzE5aDEuOTY5di0zLjcyaDEuMzEybC0yLjAxNS0yLjA3NnpcIlxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cblN2Z0ltcG9ydC5kaXNwbGF5TmFtZSA9ICdTdmdJbXBvcnQnO1xuXG5jb25zdCBJbXBvcnRJY29uID0gKHByb3BzOiBQcm9wcykgPT4ge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIHJldHVybiAoXG4gICAgPENsYXNzTmFtZXM+XG4gICAgICB7KHsgY3NzOiBjcmVhdGVDbGFzcyB9KSA9PiAoXG4gICAgICAgIDxTdmdJbXBvcnRcbiAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgICAgY2xhc3NOYW1lPXtjcmVhdGVDbGFzcyhnZXRJY29uU3R5bGVzKHByb3BzLCB0aGVtZSkpfVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICA8L0NsYXNzTmFtZXM+XG4gICk7XG59O1xuXG5JbXBvcnRJY29uLmRpc3BsYXlOYW1lID0gJ0ltcG9ydEljb24nO1xuZXhwb3J0IGRlZmF1bHQgSW1wb3J0SWNvbjtcbiJdfQ== */");
};

var SvgImport = function SvgImport(props) {
  return jsx("svg", _objectSpread$Q(_objectSpread$Q({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M3.329 19.855h17.015V3.58H3.33v16.275zM4.5 4.835h14.719V18.6H4.5V4.835zM15.516 17.2h-7.36v-4.057h7.36v4.057zM12.094 6.38c-.141-.194-.375-.194-.516 0L9.562 8.458h1.266v3.719h1.969v-3.72h1.312l-2.015-2.076z",
      fillRule: "evenodd"
    })
  }));
};

SvgImport.displayName = 'SvgImport';

var ImportIcon = function ImportIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgImport, _objectSpread$Q(_objectSpread$Q({}, props), {}, {
        className: createClass(getIconStyles$Q(props, theme))
      }));
    }
  });
};

ImportIcon.displayName = 'ImportIcon';
var ImportIcon$1 = ImportIcon;

function ownKeys$P(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$P(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$P(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$P(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$P = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$P = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$P[size], "px"),
        height: "".concat(iconSizes$P[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$P.big, "px"),
        height: "".concat(iconSizes$P.big, "px")
      };
  }
};

var getSizeStyle$P = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$P(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$P = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$P(_objectSpread$P({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$P = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$P(props.color, theme), ";}&,image{", getSizeStyle$P(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgInfo = function SvgInfo(props) {
  return jsx("svg", _objectSpread$P(_objectSpread$P({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12 3a9 9 0 100 18 9 9 0 000-18zm0 4.5a1.125 1.125 0 110 2.25 1.125 1.125 0 010-2.25zm1.688 9h-3.376a.562.562 0 110-1.125h.563V12h-.563a.562.562 0 110-1.125h2.25c.311 0 .563.252.563.563v3.937h.563a.563.563 0 010 1.125z",
      fillRule: "evenodd"
    })
  }));
};

SvgInfo.displayName = 'SvgInfo';

var InfoIcon = function InfoIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgInfo, _objectSpread$P(_objectSpread$P({}, props), {}, {
        className: createClass(getIconStyles$P(props, theme))
      }));
    }
  });
};

InfoIcon.displayName = 'InfoIcon';
var InfoIcon$1 = InfoIcon;

function ownKeys$O(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$O(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$O(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$O(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$O = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$O = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$O[size], "px"),
        height: "".concat(iconSizes$O[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$O.big, "px"),
        height: "".concat(iconSizes$O.big, "px")
      };
  }
};

var getSizeStyle$O = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$O(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$O = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$O(_objectSpread$O({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$O = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$O(props.color, theme), ";}&,image{", getSizeStyle$O(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgInformation = function SvgInformation(props) {
  return jsx("svg", _objectSpread$O(_objectSpread$O({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M11.856 4.773a1.932 1.932 0 110 3.863 1.932 1.932 0 010-3.863zm3.112 14.81H9.173a.966.966 0 110-1.932h.966v-5.795h-.966a.966.966 0 110-1.932h3.864c.533 0 .966.433.966.966v6.761h.965a.966.966 0 010 1.932z",
      fillRule: "evenodd"
    })
  }));
};

SvgInformation.displayName = 'SvgInformation';

var InformationIcon = function InformationIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgInformation, _objectSpread$O(_objectSpread$O({}, props), {}, {
        className: createClass(getIconStyles$O(props, theme))
      }));
    }
  });
};

InformationIcon.displayName = 'InformationIcon';
var InformationIcon$1 = InformationIcon;

function ownKeys$N(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$N(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$N(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$N(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$N = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$N = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$N[size], "px"),
        height: "".concat(iconSizes$N[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$N.big, "px"),
        height: "".concat(iconSizes$N.big, "px")
      };
  }
};

var getSizeStyle$N = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$N(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$N = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$N(_objectSpread$N({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$N = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$N(props.color, theme), ";}&,image{", getSizeStyle$N(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgListWithSearch = function SvgListWithSearch(props) {
  return jsx("svg", _objectSpread$N(_objectSpread$N({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsxs("g", {
      fillRule: "evenodd",
      children: [jsx("path", {
        d: "M27.735 25.952a.927.927 0 00-.308-.662l-5.31-4.736a7.795 7.795 0 01-1.882 1.883l4.734 5.311a.929.929 0 001.341.039l1.155-1.155a.927.927 0 00.27-.68zM23.123 13.94c0-4.764-3.876-8.64-8.64-8.64-4.764 0-8.64 3.876-8.64 8.64 0 4.764 3.876 8.64 8.64 8.64 4.764 0 8.64-3.876 8.64-8.64zm-8.64 6.583A6.59 6.59 0 017.9 13.94a6.59 6.59 0 016.583-6.583 6.59 6.59 0 016.583 6.583 6.59 6.59 0 01-6.583 6.583z",
        fillRule: "nonzero"
      }), jsx("path", {
        d: "M13.697 14.776l-.917-.972a.5.5 0 00-.728 0l-.713.756a.5.5 0 000 .686l2.358 2.499 4.339-4.599a.5.5 0 000-.686l-.714-.756a.5.5 0 00-.727 0l-2.898 3.072z",
        fillRule: "nonzero"
      }), jsx("path", {
        d: "M6.421 19.001L4.6 19a.6.6 0 01-.592-.503L4 18.4v-1.8a.6.6 0 01.503-.592L4.6 16l.611.001a9.443 9.443 0 001.21 3zM25.4 16a.6.6 0 01.6.6v1.8a.6.6 0 01-.6.6l-2.821.001c.564-.91.978-1.92 1.21-3L25.4 16zM5.052 13H4.6a.6.6 0 01-.592-.503L4 12.4v-1.8a.6.6 0 01.503-.592L4.6 10h1.28a9.438 9.438 0 00-.828 3zM25.4 10a.6.6 0 01.6.6v1.8a.6.6 0 01-.6.6h-1.452a9.438 9.438 0 00-.829-3H25.4zm0-6a.6.6 0 01.6.6v1.8a.6.6 0 01-.6.6h-4.477A9.466 9.466 0 0014.5 4.5 9.466 9.466 0 008.077 7H4.6a.6.6 0 01-.592-.503L4 6.4V4.6a.6.6 0 01.503-.592L4.6 4h20.8z"
      })]
    })
  }));
};

SvgListWithSearch.displayName = 'SvgListWithSearch';

var ListWithSearchIcon = function ListWithSearchIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgListWithSearch, _objectSpread$N(_objectSpread$N({}, props), {}, {
        className: createClass(getIconStyles$N(props, theme))
      }));
    }
  });
};

ListWithSearchIcon.displayName = 'ListWithSearchIcon';
var ListWithSearchIcon$1 = ListWithSearchIcon;

function ownKeys$M(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$M(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$M(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$M(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$M = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$M = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$M[size], "px"),
        height: "".concat(iconSizes$M[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$M.big, "px"),
        height: "".concat(iconSizes$M.big, "px")
      };
  }
};

var getSizeStyle$M = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$M(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$M = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$M(_objectSpread$M({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$M = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$M(props.color, theme), ";}&,image{", getSizeStyle$M(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgList = function SvgList(props) {
  return jsx("svg", _objectSpread$M(_objectSpread$M({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M5.248 9.837a.31.31 0 01.226.094.304.304 0 01.095.223v1.905c0 .086-.031.16-.095.223a.31.31 0 01-.226.094H3.321a.311.311 0 01-.226-.094.303.303 0 01-.095-.223v-1.905c0-.086.032-.16.095-.223a.31.31 0 01.226-.094h1.927zm0 7.617a.31.31 0 01.226.094.303.303 0 01.095.224v1.904c0 .086-.031.16-.095.223a.31.31 0 01-.226.094H3.321a.31.31 0 01-.226-.094.303.303 0 01-.095-.223v-1.904c0-.086.032-.16.095-.224a.31.31 0 01.226-.094h1.927zm0-3.808a.31.31 0 01.226.094.304.304 0 01.095.223v1.904c0 .086-.031.16-.095.223a.31.31 0 01-.226.095H3.321a.31.31 0 01-.226-.095.303.303 0 01-.095-.223v-1.904c0-.086.032-.16.095-.223a.311.311 0 01.226-.094h1.927zm0-7.618c.087 0 .163.032.226.095a.303.303 0 01.095.223V8.25c0 .086-.031.16-.095.223a.31.31 0 01-.226.094H3.321a.31.31 0 01-.226-.094A.303.303 0 013 8.25V6.346c0-.086.032-.16.095-.223a.31.31 0 01.226-.095h1.927zm15.418 11.426c.087 0 .162.032.226.094a.303.303 0 01.095.224v1.904c0 .086-.032.16-.095.223a.31.31 0 01-.226.094H7.176a.31.31 0 01-.226-.094.303.303 0 01-.096-.223v-1.904c0-.086.032-.16.096-.224a.31.31 0 01.226-.094h13.49zm0-3.808c.087 0 .162.031.226.094a.304.304 0 01.095.223v1.904c0 .086-.032.16-.095.223a.31.31 0 01-.226.095H7.176a.31.31 0 01-.226-.095.303.303 0 01-.096-.223v-1.904c0-.086.032-.16.096-.223a.311.311 0 01.226-.094h13.49zm.226-7.523a.304.304 0 01.095.223V8.25c0 .086-.032.16-.095.223a.31.31 0 01-.226.094H7.176a.31.31 0 01-.226-.094.303.303 0 01-.096-.223V6.346c0-.086.032-.16.096-.223a.31.31 0 01.226-.095h13.49c.087 0 .162.032.226.095zm-.226 3.714a.31.31 0 01.226.094.304.304 0 01.095.223v1.905c0 .086-.032.16-.095.223a.31.31 0 01-.226.094H7.176a.311.311 0 01-.226-.094.303.303 0 01-.096-.223v-1.905c0-.086.032-.16.096-.223a.31.31 0 01.226-.094h13.49z",
      fillRule: "evenodd"
    })
  }));
};

SvgList.displayName = 'SvgList';

var ListIcon = function ListIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgList, _objectSpread$M(_objectSpread$M({}, props), {}, {
        className: createClass(getIconStyles$M(props, theme))
      }));
    }
  });
};

ListIcon.displayName = 'ListIcon';
var ListIcon$1 = ListIcon;

function ownKeys$L(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$L(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$L(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$L(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$L = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$L = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$L[size], "px"),
        height: "".concat(iconSizes$L[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$L.big, "px"),
        height: "".concat(iconSizes$L.big, "px")
      };
  }
};

var getSizeStyle$L = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$L(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$L = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$L(_objectSpread$L({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$L = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$L(props.color, theme), ";}&,image{", getSizeStyle$L(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgLock = function SvgLock(props) {
  return jsx("svg", _objectSpread$L(_objectSpread$L({
    width: 24,
    height: 24,
    viewBox: "0 0 87 118",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M84.167 49.925h-6.824V34.04C77.343 15.268 62.043 0 43.22 0 24.404 0 9.099 15.268 9.099 34.04v15.885H2.275A2.273 2.273 0 000 52.195v51.99c0 .79.414 1.524 1.087 1.937C13.84 113.892 28.407 118 43.221 118c14.813 0 29.381-4.107 42.138-11.878a2.284 2.284 0 001.083-1.938v-51.99a2.276 2.276 0 00-2.275-2.269zM48.59 83.914v15.868c0 1.572-1.208 2.858-2.684 2.858h-5.37c-1.482 0-2.685-1.286-2.685-2.858V83.914c-3.2-1.983-5.37-5.617-5.37-9.846 0-6.308 4.812-11.428 10.74-11.428s10.74 5.12 10.74 11.428c0 4.217-2.17 7.863-5.37 9.846zm14.526-34.519H21.953V33.788c0-11.064 9.235-20.067 20.582-20.067 11.343 0 20.581 9.003 20.581 20.067v15.607z",
      fill: "#999",
      fillRule: "nonzero"
    })
  }));
};

SvgLock.displayName = 'SvgLock';

var LockIcon = function LockIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgLock, _objectSpread$L(_objectSpread$L({}, props), {}, {
        className: createClass(getIconStyles$L(props, theme))
      }));
    }
  });
};

LockIcon.displayName = 'LockIcon';
var LockIcon$1 = LockIcon;

function ownKeys$K(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$K(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$K(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$K(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$K = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$K = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$K[size], "px"),
        height: "".concat(iconSizes$K[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$K.big, "px"),
        height: "".concat(iconSizes$K.big, "px")
      };
  }
};

var getSizeStyle$K = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$K(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$K = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$K(_objectSpread$K({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$K = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$K(props.color, theme), ";}&,image{", getSizeStyle$K(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgLogout = function SvgLogout(props) {
  return jsx("svg", _objectSpread$K(_objectSpread$K({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M15.763 18.105c-1.358.878-2.953 1.398-4.65 1.398-2.886 0-5.567-1.495-6.993-3.835-1.46-2.373-1.46-5.298-.034-7.703 1.46-2.34 4.107-3.835 6.992-3.835 1.596 0 3.123.455 4.413 1.268l-.883 1.3a7.005 7.005 0 00-3.53-.975c-2.308 0-4.48 1.138-5.6 3.055a5.882 5.882 0 000 6.143c1.12 1.917 3.292 3.055 5.6 3.055 1.358 0 2.614-.39 3.7-1.105l.985 1.234zm4.616-6.24l-3.7-3.478v1.95h-5.906v3.055h5.906v1.983l3.7-3.51z",
      fillRule: "evenodd"
    })
  }));
};

SvgLogout.displayName = 'SvgLogout';

var LogoutIcon = function LogoutIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgLogout, _objectSpread$K(_objectSpread$K({}, props), {}, {
        className: createClass(getIconStyles$K(props, theme))
      }));
    }
  });
};

LogoutIcon.displayName = 'LogoutIcon';
var LogoutIcon$1 = LogoutIcon;

function ownKeys$J(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$J(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$J(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$J(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$J = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$J = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$J[size], "px"),
        height: "".concat(iconSizes$J[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$J.big, "px"),
        height: "".concat(iconSizes$J.big, "px")
      };
  }
};

var getSizeStyle$J = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$J(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$J = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$J(_objectSpread$J({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$J = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$J(props.color, theme), ";}&,image{", getSizeStyle$J(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgMail = function SvgMail(props) {
  return jsx("svg", _objectSpread$J(_objectSpread$J({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12 13.312L3 6h18l-9 7.312zm-2.244-1.046L3 6.926V17.41l6.756-5.144zm2.398 1.752c-.112.092-.194.093-.308 0l-1.599-1.335-7.221 5.653h17.948l-7.221-5.653-1.599 1.335zm2.112-1.73l6.757-5.34v10.485l-6.757-5.145z",
      fillRule: "nonzero"
    })
  }));
};

SvgMail.displayName = 'SvgMail';

var MailIcon = function MailIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgMail, _objectSpread$J(_objectSpread$J({}, props), {}, {
        className: createClass(getIconStyles$J(props, theme))
      }));
    }
  });
};

MailIcon.displayName = 'MailIcon';
var MailIcon$1 = MailIcon;

function ownKeys$I(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$I(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$I(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$I(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$I = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$I = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$I[size], "px"),
        height: "".concat(iconSizes$I[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$I.big, "px"),
        height: "".concat(iconSizes$I.big, "px")
      };
  }
};

var getSizeStyle$I = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$I(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$I = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$I(_objectSpread$I({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$I = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$I(props.color, theme), ";}&,image{", getSizeStyle$I(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgMinimize = function SvgMinimize(props) {
  return jsx("svg", _objectSpread$I(_objectSpread$I({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M6 11h12v2H6z",
      fillRule: "evenodd"
    })
  }));
};

SvgMinimize.displayName = 'SvgMinimize';

var MinimizeIcon = function MinimizeIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgMinimize, _objectSpread$I(_objectSpread$I({}, props), {}, {
        className: createClass(getIconStyles$I(props, theme))
      }));
    }
  });
};

MinimizeIcon.displayName = 'MinimizeIcon';
var MinimizeIcon$1 = MinimizeIcon;

function ownKeys$H(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$H(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$H(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$H(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$H = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$H = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$H[size], "px"),
        height: "".concat(iconSizes$H[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$H.big, "px"),
        height: "".concat(iconSizes$H.big, "px")
      };
  }
};

var getSizeStyle$H = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$H(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$H = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$H(_objectSpread$H({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$H = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$H(props.color, theme), ";}&,image{", getSizeStyle$H(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgNestedView = function SvgNestedView(props) {
  return jsx("svg", _objectSpread$H(_objectSpread$H({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.235 7.176H3.53A.53.53 0 013 6.647V4.53A.53.53 0 013.53 4h12.705a.53.53 0 01.53.53v2.117a.53.53 0 01-.53.53zM20.538 14H9.462C9.207 14 9 13.776 9 13.5v-2c0-.276.207-.5.462-.5h11.076c.255 0 .462.224.462.5v2c0 .276-.207.5-.462.5zm0 6H9.462C9.207 20 9 19.776 9 19.5v-2c0-.276.207-.5.462-.5h11.076c.255 0 .462.224.462.5v2c0 .276-.207.5-.462.5zM7.01 19c.317 0 .573.224.573.5s-.256.5-.573.5H3.573C3.257 20 3 19.776 3 19.5v-10c0-.276.257-.5.573-.5.316 0 .573.224.573.5V13H7.01c.317 0 .573.224.573.5s-.256.5-.573.5H4.146v5H7.01z",
      fillRule: "evenodd"
    })
  }));
};

SvgNestedView.displayName = 'SvgNestedView';

var NestedViewIcon = function NestedViewIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgNestedView, _objectSpread$H(_objectSpread$H({}, props), {}, {
        className: createClass(getIconStyles$H(props, theme))
      }));
    }
  });
};

NestedViewIcon.displayName = 'NestedViewIcon';
var NestedViewIcon$1 = NestedViewIcon;

function ownKeys$G(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$G(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$G(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$G(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$G = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$G = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$G[size], "px"),
        height: "".concat(iconSizes$G[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$G.big, "px"),
        height: "".concat(iconSizes$G.big, "px")
      };
  }
};

var getSizeStyle$G = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$G(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$G = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$G(_objectSpread$G({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$G = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$G(props.color, theme), ";}&,image{", getSizeStyle$G(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgOperations = function SvgOperations(props) {
  return jsx("svg", _objectSpread$G(_objectSpread$G({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsxs("g", {
      fillRule: "nonzero",
      children: [jsx("path", {
        d: "M8 11c-.542 0-1 .458-1 1 0 .56.458 1 1 1 .56 0 1-.458 1-1s-.44-1-1-1zM16 11c-.56 0-1 .458-1 1 0 .56.458 1 1 1s1-.44 1-1c0-.542-.458-1-1-1zM12 11c-.56 0-1 .458-1 1 0 .56.458 1 1 1 .56 0 1-.458 1-1s-.44-1-1-1z"
      }), jsx("path", {
        d: "M21 14.5h-1.79l.027-.13a7.13 7.13 0 00.13-1.009l.007-.098c.009-.122.017-.243.017-.367 0-3.635-2.59-5.532-6.195-5.89v2.225L9.555 6.11 13.195 3l.001 2.241c4.592.364 7.958 3.04 7.958 7.655 0 .083-.006.164-.011.245a5.12 5.12 0 00-.009.142 9.046 9.046 0 01-.118 1.127L21 14.5zM10.881 21v-2.235c-4.649-.316-7.826-2.994-7.826-7.66 0-.11.008-.218.015-.326l.01-.146c.018-.36.056-.711.114-1.043l.015-.09H5l-.028.131c-.07.336-.115.7-.135 1.111l-.008.121c-.006.08-.011.16-.011.241 0 3.685 2.402 5.585 6.062 5.896v-2.255l3.642 3.145-3.64 3.11z"
      })]
    })
  }));
};

SvgOperations.displayName = 'SvgOperations';

var OperationsIcon = function OperationsIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgOperations, _objectSpread$G(_objectSpread$G({}, props), {}, {
        className: createClass(getIconStyles$G(props, theme))
      }));
    }
  });
};

OperationsIcon.displayName = 'OperationsIcon';
var OperationsIcon$1 = OperationsIcon;

function ownKeys$F(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$F(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$F(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$F(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$F = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$F = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$F[size], "px"),
        height: "".concat(iconSizes$F[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$F.big, "px"),
        height: "".concat(iconSizes$F.big, "px")
      };
  }
};

var getSizeStyle$F = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$F(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$F = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$F(_objectSpread$F({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$F = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$F(props.color, theme), ";}&,image{", getSizeStyle$F(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPageGear = function SvgPageGear(props) {
  return jsxs("svg", _objectSpread$F(_objectSpread$F({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [jsx("defs", {
      children: jsx("path", {
        d: "M12.553 4l-.062-.059h-.045l.062.059h.045zm3.824 6.086H11V4.941H5V19.06h4.779a.97.97 0 110 1.941h-5.53C3.567 21 3 20.467 3 19.794V4.206C3 3.533 3.566 3 4.25 3h9.032L18 7.441c.24.226.377.537.377.863v2.403a1 1 0 01-2 0v-.62zm-.914-2.328L13.06 5.494v2.264h2.404zm4.488 9.183l.976.742a.223.223 0 01.055.288l-.925 1.558c-.055.099-.176.139-.282.099l-1.152-.45c-.24.175-.5.328-.782.44l-.176 1.193a.224.224 0 01-.226.189h-1.85a.224.224 0 01-.228-.189l-.175-1.192a3.404 3.404 0 01-.782-.442l-1.152.45a.236.236 0 01-.282-.098l-.926-1.558a.223.223 0 01.056-.288l.976-.742v-.882l-.976-.743a.218.218 0 01-.056-.288l.926-1.556c.055-.1.176-.14.282-.1l1.152.45c.24-.175.5-.328.782-.44l.175-1.193a.224.224 0 01.227-.189h1.85c.116 0 .213.081.227.189l.176 1.193c.282.112.541.26.782.44l1.152-.45a.236.236 0 01.282.1l.925 1.556a.223.223 0 01-.055.288l-.976.743v.882zm-3.438 1.134c.893 0 1.62-.706 1.62-1.575 0-.868-.727-1.575-1.62-1.575-.892 0-1.619.707-1.619 1.575 0 .869.727 1.575 1.62 1.575z",
        id: "page-gear_react_svg__a"
      })
    }), jsx("use", {
      fill: "#1A1A1A",
      xlinkHref: "#page-gear_react_svg__a",
      fillRule: "evenodd"
    })]
  }));
};

SvgPageGear.displayName = 'SvgPageGear';

var PageGearIcon = function PageGearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPageGear, _objectSpread$F(_objectSpread$F({}, props), {}, {
        className: createClass(getIconStyles$F(props, theme))
      }));
    }
  });
};

PageGearIcon.displayName = 'PageGearIcon';
var PageGearIcon$1 = PageGearIcon;

function ownKeys$E(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$E(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$E(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$E(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$E = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$E = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$E[size], "px"),
        height: "".concat(iconSizes$E[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$E.big, "px"),
        height: "".concat(iconSizes$E.big, "px")
      };
  }
};

var getSizeStyle$E = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$E(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$E = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$E(_objectSpread$E({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$E = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$E(props.color, theme), ";}&,image{", getSizeStyle$E(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPages = function SvgPages(props) {
  return jsx("svg", _objectSpread$E(_objectSpread$E({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M7.737 18.058a.325.325 0 01-.322-.327V6.253c0-.181.146-.327.322-.327h8.526c.175 0 .32.146.32.327v.746H9.35a.851.851 0 00-.852.851v10.208h-.763zM6.5 6.253v9.813h-.763a.325.325 0 01-.322-.326V4.26c0-.18.146-.327.322-.327h8.526c.175 0 .32.147.32.327v.732H7.736A1.25 1.25 0 006.5 6.253zm12.15.746H17.5v-.746a1.25 1.25 0 00-1.238-1.261H15.5V4.26A1.25 1.25 0 0014.262 3H5.736A1.25 1.25 0 004.5 4.26v11.48c0 .693.554 1.26 1.237 1.26H6.5v.731c0 .696.554 1.26 1.237 1.26h.762v1.158c0 .469.381.85.851.85h9.3a.85.85 0 00.85-.85V7.85a.851.851 0 00-.85-.851z",
      fillRule: "evenodd"
    })
  }));
};

SvgPages.displayName = 'SvgPages';

var PagesIcon = function PagesIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPages, _objectSpread$E(_objectSpread$E({}, props), {}, {
        className: createClass(getIconStyles$E(props, theme))
      }));
    }
  });
};

PagesIcon.displayName = 'PagesIcon';
var PagesIcon$1 = PagesIcon;

function ownKeys$D(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$D(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$D(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$D(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$D = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$D = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$D[size], "px"),
        height: "".concat(iconSizes$D[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$D.big, "px"),
        height: "".concat(iconSizes$D.big, "px")
      };
  }
};

var getSizeStyle$D = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$D(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$D = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$D(_objectSpread$D({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$D = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$D(props.color, theme), ";}&,image{", getSizeStyle$D(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPaperBillInverted = function SvgPaperBillInverted(props) {
  return jsx("svg", _objectSpread$D(_objectSpread$D({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.324 19.7h-.002v.006L14.913 21l-1.42-1.256V19.7h-.002v.006L12.083 21l-1.42-1.256V19.7h-.002v.006L9.25 21l-1.42-1.256V19.7H7.83v.006L6.42 21 5 19.744V4.342L6.42 3l1.408 1.341V4.4h.003v-.058L9.251 3l1.408 1.341V4.4h.003v-.058L12.082 3l1.407 1.341V4.4h.003v-.058L14.913 3l1.407 1.341V4.4h.004v-.058L17.744 3l1.407 1.341.002 15.365L17.744 21l-1.42-1.256V19.7zM6.857 8.225c0 .258.22.481.49.481h8.64c.272 0 .491-.215.491-.481a.49.49 0 00-.49-.481h-8.64a.485.485 0 00-.49.48zm0 2.886c0 .258.22.481.49.481h8.64c.272 0 .491-.215.491-.48a.49.49 0 00-.49-.482h-8.64a.485.485 0 00-.49.481zm.284 2.887c0 .257.212.48.473.48h4.828a.482.482 0 000-.961H7.614a.482.482 0 00-.473.48z",
      fillRule: "evenodd"
    })
  }));
};

SvgPaperBillInverted.displayName = 'SvgPaperBillInverted';

var PaperBillInvertedIcon = function PaperBillInvertedIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPaperBillInverted, _objectSpread$D(_objectSpread$D({}, props), {}, {
        className: createClass(getIconStyles$D(props, theme))
      }));
    }
  });
};

PaperBillInvertedIcon.displayName = 'PaperBillInvertedIcon';
var PaperBillInvertedIcon$1 = PaperBillInvertedIcon;

function ownKeys$C(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$C(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$C(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$C(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$C = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$C = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$C[size], "px"),
        height: "".concat(iconSizes$C[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$C.big, "px"),
        height: "".concat(iconSizes$C.big, "px")
      };
  }
};

var getSizeStyle$C = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$C(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$C = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$C(_objectSpread$C({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$C = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$C(props.color, theme), ";}&,image{", getSizeStyle$C(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPaperclip = function SvgPaperclip(props) {
  return jsx("svg", _objectSpread$C(_objectSpread$C({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      d: "M9.3 18.7c-.5.5-1.3.8-2.1.8s-1.5-.3-2.1-.8c-.5-.5-.9-1.1-.9-1.8s.3-1.4.9-1.8L16.4 5c.7-.6 1.9-.6 2.6 0 .7.7.7 1.7 0 2.4l-10 9c-.3.3-.8.3-1.1 0-.1-.1-.2-.3-.2-.5s.1-.4.2-.5l5.9-5.1c.2-.1.2-.3.2-.4 0-.2-.1-.3-.2-.4-.3-.2-.7-.2-1 0l-5.9 5.1c-.4.4-.6.8-.6 1.4 0 .5.2 1 .6 1.4.8.7 2.2.7 3 0l10.1-9c.7-.7 1-1.4 1-2.2 0-.8-.3-1.5-.9-2-.6-.5-1.4-.8-2.3-.8-.9 0-1.7.3-2.3.8l-11.2 10c-.9.7-1.3 1.7-1.3 2.7 0 1 .4 2 1.2 2.7.8.7 1.9 1.1 3 1.1s2.2-.4 3-1.1l9.3-8.4c.1-.1.2-.3.2-.4 0-.2-.1-.3-.2-.4-.3-.2-.7-.2-1 0l-9.2 8.3z"
    })
  }));
};

SvgPaperclip.displayName = 'SvgPaperclip';

var PaperclipIcon = function PaperclipIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPaperclip, _objectSpread$C(_objectSpread$C({}, props), {}, {
        className: createClass(getIconStyles$C(props, theme))
      }));
    }
  });
};

PaperclipIcon.displayName = 'PaperclipIcon';
var PaperclipIcon$1 = PaperclipIcon;

function ownKeys$B(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$B(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$B(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$B(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$B = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$B = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$B[size], "px"),
        height: "".concat(iconSizes$B[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$B.big, "px"),
        height: "".concat(iconSizes$B.big, "px")
      };
  }
};

var getSizeStyle$B = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$B(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$B = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$B(_objectSpread$B({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$B = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$B(props.color, theme), ";}&,image{", getSizeStyle$B(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPinFilled = function SvgPinFilled(props) {
  return jsx("svg", _objectSpread$B(_objectSpread$B({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M14.286 18.122a1.673 1.673 0 00-.4-2.332l-.682-.478 3.98-5.683c.75.503 1.772.31 2.298-.44l-8.156-5.711a1.673 1.673 0 00.4 2.332l-3.978 5.681-.682-.477a1.673 1.673 0 00-2.329.422l4.092 2.866-3.737 5.337 1.364.955 3.737-5.337 4.093 2.865z",
      fillRule: "evenodd"
    })
  }));
};

SvgPinFilled.displayName = 'SvgPinFilled';

var PinFilledIcon = function PinFilledIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPinFilled, _objectSpread$B(_objectSpread$B({}, props), {}, {
        className: createClass(getIconStyles$B(props, theme))
      }));
    }
  });
};

PinFilledIcon.displayName = 'PinFilledIcon';
var PinFilledIcon$1 = PinFilledIcon;

function ownKeys$A(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$A(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$A(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$A(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$A = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$A = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$A[size], "px"),
        height: "".concat(iconSizes$A[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$A.big, "px"),
        height: "".concat(iconSizes$A.big, "px")
      };
  }
};

var getSizeStyle$A = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$A(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$A = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$A(_objectSpread$A({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$A = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$A(props.color, theme), ";}&,image{", getSizeStyle$A(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPinGear = function SvgPinGear(props) {
  return jsxs("svg", _objectSpread$A(_objectSpread$A({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [jsx("defs", {
      children: jsx("path", {
        d: "M19.938 16.541l.976.742a.223.223 0 01.056.288l-.925 1.557c-.056.1-.176.14-.282.1l-1.152-.45c-.241.175-.5.328-.782.44l-.176 1.193a.224.224 0 01-.227.189h-1.85a.224.224 0 01-.227-.189l-.176-1.193a3.404 3.404 0 01-.782-.44l-1.151.45a.236.236 0 01-.283-.1l-.925-1.557a.223.223 0 01.056-.288l.976-.742v-.882l-.976-.743a.218.218 0 01-.056-.288l.925-1.557c.056-.099.176-.139.283-.099l1.151.45c.241-.175.5-.328.782-.44l.176-1.193a.224.224 0 01.227-.189h1.85c.116 0 .213.081.227.189l.176 1.192c.282.113.541.261.782.441l1.152-.45a.236.236 0 01.282.1l.925 1.556a.223.223 0 01-.056.288l-.976.743v.882zm-3.437 1.134c.893 0 1.62-.707 1.62-1.575 0-.869-.727-1.575-1.62-1.575-.893 0-1.62.706-1.62 1.575 0 .868.727 1.575 1.62 1.575z",
        id: "pin-gear_react_svg__a"
      })
    }), jsxs("g", {
      fillRule: "evenodd",
      children: [jsx("use", {
        fill: "#1A1A1A",
        xlinkHref: "#pin-gear_react_svg__a",
        transform: "translate(-3 -3)"
      }), jsx("path", {
        d: "M5.664 11.893l-3.74 5.342-1.407-.985 3.74-5.342-3.4-2.382c.867-.762 1.619-.92 2.256-.475.001.002 1.329-1.894 3.982-5.686C6.21 1.63 6.063.844 6.653 0c0-.003 2.803 1.96 8.412 5.89-.758.839-1.539.977-2.343.414.002.001-.565.81-1.7 2.428l-1.394-.976 1.7-2.428-2.826-1.98L4.52 9.038l2.11 1.477 1.712 1.2-.965 1.378-1.713-1.2z",
        fill: "#1A1A1A"
      })]
    })]
  }));
};

SvgPinGear.displayName = 'SvgPinGear';

var PinGearIcon = function PinGearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPinGear, _objectSpread$A(_objectSpread$A({}, props), {}, {
        className: createClass(getIconStyles$A(props, theme))
      }));
    }
  });
};

PinGearIcon.displayName = 'PinGearIcon';
var PinGearIcon$1 = PinGearIcon;

function ownKeys$z(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$z(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$z(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$z(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$z = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$z = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$z[size], "px"),
        height: "".concat(iconSizes$z[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$z.big, "px"),
        height: "".concat(iconSizes$z.big, "px")
      };
  }
};

var getSizeStyle$z = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$z(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$z = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$z(_objectSpread$z({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$z = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$z(props.color, theme), ";}&,image{", getSizeStyle$z(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPinLinear = function SvgPinLinear(props) {
  return jsx("svg", _objectSpread$z(_objectSpread$z({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M9.023 12.328l2.813 1.97 3.982-5.687-2.813-1.97-3.982 5.687zm5.365 5.811c.533-.761.336-1.82-.441-2.363l-.704-.493 3.983-5.688c.774.519 1.816.339 2.342-.413l-8.411-5.89c-.533.762-.336 1.82.441 2.364l-3.982 5.687-.703-.492c-.777-.545-1.84-.368-2.372.393L8.76 14.2l-3.74 5.342 1.406.985 3.74-5.342 4.221 2.955z",
      fillRule: "evenodd"
    })
  }));
};

SvgPinLinear.displayName = 'SvgPinLinear';

var PinLinearIcon = function PinLinearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPinLinear, _objectSpread$z(_objectSpread$z({}, props), {}, {
        className: createClass(getIconStyles$z(props, theme))
      }));
    }
  });
};

PinLinearIcon.displayName = 'PinLinearIcon';
var PinLinearIcon$1 = PinLinearIcon;

function ownKeys$y(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$y(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$y(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$y(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$y = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$y = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$y[size], "px"),
        height: "".concat(iconSizes$y[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$y.big, "px"),
        height: "".concat(iconSizes$y.big, "px")
      };
  }
};

var getSizeStyle$y = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$y(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$y = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$y(_objectSpread$y({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$y = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$y(props.color, theme), ";}&,image{", getSizeStyle$y(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBsdWdpblJlYWN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErSGdFIiwiZmlsZSI6IlBsdWdpblJlYWN0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8vIFRISVMgSVMgQU4gQVVUT0dFTkVSQVRFRCBGSUxFLiBETyBOT1QgRURJVCBUSElTIEZJTEUgRElSRUNUTFkuXG4vLyBUaGlzIGZpbGUgaXMgY3JlYXRlZCB3aXRoICd5YXJuIGdlbmVyYXRlLWljb25zJy5cbi8vIE9yaWdpbmFsIFNWRyBmaWxlOiBzcmMvc3ZnL3BsdWdpbi5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnUGx1Z2luID0gKHByb3BzOiBTVkdQcm9wcykgPT4gKFxuICA8c3ZnXG4gICAgd2lkdGg9ezI0fVxuICAgIGhlaWdodD17MjR9XG4gICAgdmlld0JveD1cIjAgMCAyNCAyNFwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gICAgeG1sbnNYbGluaz1cImh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmtcIlxuICAgIHsuLi5wcm9wc31cbiAgPlxuICAgIDxkZWZzPlxuICAgICAgPHBhdGhcbiAgICAgICAgZD1cIk0yMS4xNyAxMS40MjNhMi4wNDYgMi4wNDYgMCAwMC0xLjk3LTEuNDcgMi4xNzUgMi4xNzUgMCAwMC0uOTExLjIwNi40My40MyAwIDAxLS40LS4wNDcuMzk0LjM5NCAwIDAxLS4xNjQtLjMyNFY0Ljk1NmEuMjMuMjMgMCAwMC0uMjA2LS4yMDZIMy40NTZhLjIyMy4yMjMgMCAwMC0uMjA2LjIwNnY0LjgzMmMwIC4wOTYuMDQ5LjE4NS4xMy4yMzZhLjE1My4xNTMgMCAwMC4xNyAwIDIuMTkzIDIuMTkzIDAgMDExLjAwNS0uMjMgMi4yMSAyLjIxIDAgMDEwIDQuNDIxIDIuMzUyIDIuMzUyIDAgMDEtLjk5My0uMjI5LjI3Ni4yNzYgMCAwMC0uMjI0LjAzNS4yMTguMjE4IDAgMDAtLjA4OC4xODN2NC44MzJjLjAwOC4xMS4wOTYuMTk4LjIwNi4yMDZoNC44MzNjLjA3IDAgLjEzNi0uMDM2LjE3Ni0uMDk0YS4yNTkuMjU5IDAgMDAuMDM1LS4yMyAyLjA5OSAyLjA5OSAwIDAxLS4yMy0uOTgxIDIuMjEgMi4yMSAwIDAxLjg2LTEuNzUyIDIuMjQ2IDIuMjQ2IDAgMDExLjk2My0uNCAyLjIyMiAyLjIyMiAwIDAxMS42MDUgMi4xMzQgMi4zNTIgMi4zNTIgMCAwMS0uMjMuOTk0LjI0MS4yNDEgMCAwMC4wMzYuMjE3Yy4wNC4wNTkuMTA2LjA5NC4xNzYuMDk1aDQuODM5YS4yMy4yMyAwIDAwLjIwNi0uMjA2di00LjgzM2EuNDM1LjQzNSAwIDAxLjIyMy0uMzg4LjMzNS4zMzUgMCAwMS4zNTMgMGMuMjc5LjE0LjU4Ny4yMTEuOS4yMDZhMi4wNTggMi4wNTggMCAwMDEuOTY5LTIuNTk5di4wMTh6XCJcbiAgICAgICAgaWQ9XCJwbHVnaW5fcmVhY3Rfc3ZnX19hXCJcbiAgICAgIC8+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIxLjE3IDExLjQyM2EyLjA0NiAyLjA0NiAwIDAwLTEuOTctMS40NyAyLjE3NSAyLjE3NSAwIDAwLS45MTEuMjA2LjQzLjQzIDAgMDEtLjQtLjA0Ny4zOTQuMzk0IDAgMDEtLjE2NC0uMzI0VjQuOTU2YS4yMy4yMyAwIDAwLS4yMDYtLjIwNkgzLjQ1NmEuMjIzLjIyMyAwIDAwLS4yMDYuMjA2djQuODMyYzAgLjA5Ni4wNDkuMTg1LjEzLjIzNmEuMTUzLjE1MyAwIDAwLjE3IDAgMi4xOTMgMi4xOTMgMCAwMTEuMDA1LS4yMyAyLjIxIDIuMjEgMCAwMTAgNC40MjEgMi4zNTIgMi4zNTIgMCAwMS0uOTkzLS4yMjkuMjc2LjI3NiAwIDAwLS4yMjQuMDM1LjIxOC4yMTggMCAwMC0uMDg4LjE4M3Y0LjgzMmMuMDA4LjExLjA5Ni4xOTguMjA2LjIwNmg0LjgzM2MuMDcgMCAuMTM2LS4wMzYuMTc2LS4wOTRhLjI1OS4yNTkgMCAwMC4wMzUtLjIzIDIuMDk5IDIuMDk5IDAgMDEtLjIzLS45ODEgMi4yMSAyLjIxIDAgMDEuODYtMS43NTIgMi4yNDYgMi4yNDYgMCAwMTEuOTYzLS40IDIuMjIyIDIuMjIyIDAgMDExLjYwNSAyLjEzNCAyLjM1MiAyLjM1MiAwIDAxLS4yMy45OTQuMjQxLjI0MSAwIDAwLjAzNi4yMTdjLjA0LjA1OS4xMDYuMDk0LjE3Ni4wOTVoNC44MzlhLjIzLjIzIDAgMDAuMjA2LS4yMDZ2LTQuODMzYS40MzUuNDM1IDAgMDEuMjIzLS4zODguMzM1LjMzNSAwIDAxLjM1MyAwYy4yNzkuMTQuNTg3LjIxMS45LjIwNmEyLjA1OCAyLjA1OCAwIDAwMS45NjktMi41OTl2LjAxOHpcIlxuICAgICAgICBpZD1cInBsdWdpbl9yZWFjdF9zdmdfX2NcIlxuICAgICAgLz5cbiAgICA8L2RlZnM+XG4gICAgPGcgZmlsbFJ1bGU9XCJldmVub2RkXCI+XG4gICAgICA8bWFzayBpZD1cInBsdWdpbl9yZWFjdF9zdmdfX2JcIiBmaWxsPVwiI2ZmZlwiPlxuICAgICAgICA8dXNlIHhsaW5rSHJlZj1cIiNwbHVnaW5fcmVhY3Rfc3ZnX19hXCIgLz5cbiAgICAgIDwvbWFzaz5cbiAgICAgIDx1c2VcbiAgICAgICAgZmlsbFJ1bGU9XCJub256ZXJvXCJcbiAgICAgICAgdHJhbnNmb3JtPVwicm90YXRlKC05MCAxMi4yNDYgMTEuOTk2KVwiXG4gICAgICAgIHhsaW5rSHJlZj1cIiNwbHVnaW5fcmVhY3Rfc3ZnX19hXCJcbiAgICAgIC8+XG4gICAgICA8Zz5cbiAgICAgICAgPG1hc2sgaWQ9XCJwbHVnaW5fcmVhY3Rfc3ZnX19kXCIgZmlsbD1cIiNmZmZcIj5cbiAgICAgICAgICA8dXNlIHhsaW5rSHJlZj1cIiNwbHVnaW5fcmVhY3Rfc3ZnX19jXCIgLz5cbiAgICAgICAgPC9tYXNrPlxuICAgICAgICA8dXNlXG4gICAgICAgICAgZmlsbFJ1bGU9XCJub256ZXJvXCJcbiAgICAgICAgICB0cmFuc2Zvcm09XCJyb3RhdGUoLTkwIDEyLjI0NiAxMS45OTYpXCJcbiAgICAgICAgICB4bGlua0hyZWY9XCIjcGx1Z2luX3JlYWN0X3N2Z19fY1wiXG4gICAgICAgIC8+XG4gICAgICA8L2c+XG4gICAgPC9nPlxuICA8L3N2Zz5cbik7XG5cblN2Z1BsdWdpbi5kaXNwbGF5TmFtZSA9ICdTdmdQbHVnaW4nO1xuXG5jb25zdCBQbHVnaW5JY29uID0gKHByb3BzOiBQcm9wcykgPT4ge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIHJldHVybiAoXG4gICAgPENsYXNzTmFtZXM+XG4gICAgICB7KHsgY3NzOiBjcmVhdGVDbGFzcyB9KSA9PiAoXG4gICAgICAgIDxTdmdQbHVnaW5cbiAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgICAgY2xhc3NOYW1lPXtjcmVhdGVDbGFzcyhnZXRJY29uU3R5bGVzKHByb3BzLCB0aGVtZSkpfVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICA8L0NsYXNzTmFtZXM+XG4gICk7XG59O1xuXG5QbHVnaW5JY29uLmRpc3BsYXlOYW1lID0gJ1BsdWdpbkljb24nO1xuZXhwb3J0IGRlZmF1bHQgUGx1Z2luSWNvbjtcbiJdfQ== */");
};

var SvgPlugin = function SvgPlugin(props) {
  return jsxs("svg", _objectSpread$y(_objectSpread$y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [jsxs("defs", {
      children: [jsx("path", {
        d: "M21.17 11.423a2.046 2.046 0 00-1.97-1.47 2.175 2.175 0 00-.911.206.43.43 0 01-.4-.047.394.394 0 01-.164-.324V4.956a.23.23 0 00-.206-.206H3.456a.223.223 0 00-.206.206v4.832c0 .096.049.185.13.236a.153.153 0 00.17 0 2.193 2.193 0 011.005-.23 2.21 2.21 0 010 4.421 2.352 2.352 0 01-.993-.229.276.276 0 00-.224.035.218.218 0 00-.088.183v4.832c.008.11.096.198.206.206h4.833c.07 0 .136-.036.176-.094a.259.259 0 00.035-.23 2.099 2.099 0 01-.23-.981 2.21 2.21 0 01.86-1.752 2.246 2.246 0 011.963-.4 2.222 2.222 0 011.605 2.134 2.352 2.352 0 01-.23.994.241.241 0 00.036.217c.04.059.106.094.176.095h4.839a.23.23 0 00.206-.206v-4.833a.435.435 0 01.223-.388.335.335 0 01.353 0c.279.14.587.211.9.206a2.058 2.058 0 001.969-2.599v.018z",
        id: "plugin_react_svg__a"
      }), jsx("path", {
        d: "M21.17 11.423a2.046 2.046 0 00-1.97-1.47 2.175 2.175 0 00-.911.206.43.43 0 01-.4-.047.394.394 0 01-.164-.324V4.956a.23.23 0 00-.206-.206H3.456a.223.223 0 00-.206.206v4.832c0 .096.049.185.13.236a.153.153 0 00.17 0 2.193 2.193 0 011.005-.23 2.21 2.21 0 010 4.421 2.352 2.352 0 01-.993-.229.276.276 0 00-.224.035.218.218 0 00-.088.183v4.832c.008.11.096.198.206.206h4.833c.07 0 .136-.036.176-.094a.259.259 0 00.035-.23 2.099 2.099 0 01-.23-.981 2.21 2.21 0 01.86-1.752 2.246 2.246 0 011.963-.4 2.222 2.222 0 011.605 2.134 2.352 2.352 0 01-.23.994.241.241 0 00.036.217c.04.059.106.094.176.095h4.839a.23.23 0 00.206-.206v-4.833a.435.435 0 01.223-.388.335.335 0 01.353 0c.279.14.587.211.9.206a2.058 2.058 0 001.969-2.599v.018z",
        id: "plugin_react_svg__c"
      })]
    }), jsxs("g", {
      fillRule: "evenodd",
      children: [jsx("mask", {
        id: "plugin_react_svg__b",
        fill: "#fff",
        children: jsx("use", {
          xlinkHref: "#plugin_react_svg__a"
        })
      }), jsx("use", {
        fillRule: "nonzero",
        transform: "rotate(-90 12.246 11.996)",
        xlinkHref: "#plugin_react_svg__a"
      }), jsxs("g", {
        children: [jsx("mask", {
          id: "plugin_react_svg__d",
          fill: "#fff",
          children: jsx("use", {
            xlinkHref: "#plugin_react_svg__c"
          })
        }), jsx("use", {
          fillRule: "nonzero",
          transform: "rotate(-90 12.246 11.996)",
          xlinkHref: "#plugin_react_svg__c"
        })]
      })]
    })]
  }));
};

SvgPlugin.displayName = 'SvgPlugin';

var PluginIcon = function PluginIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPlugin, _objectSpread$y(_objectSpread$y({}, props), {}, {
        className: createClass(getIconStyles$y(props, theme))
      }));
    }
  });
};

PluginIcon.displayName = 'PluginIcon';
var PluginIcon$1 = PluginIcon;

function ownKeys$x(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$x(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$x(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$x(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$x = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$x = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$x[size], "px"),
        height: "".concat(iconSizes$x[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$x.big, "px"),
        height: "".concat(iconSizes$x.big, "px")
      };
  }
};

var getSizeStyle$x = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$x(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$x = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$x(_objectSpread$x({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$x = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$x(props.color, theme), ";}&,image{", getSizeStyle$x(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPlusBold = function SvgPlusBold(props) {
  return jsx("svg", _objectSpread$x(_objectSpread$x({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M13.844 10.334v-3.51c0-.97-.784-1.755-1.75-1.755-.967 0-1.75.785-1.75 1.755v3.51h-3.5c-.967 0-1.75.785-1.75 1.754 0 .97.783 1.755 1.75 1.755h3.5v3.51c0 .97.783 1.755 1.75 1.755.966 0 1.75-.786 1.75-1.755v-3.51h3.5c.966 0 1.75-.785 1.75-1.755 0-.969-.784-1.754-1.75-1.754h-3.5z",
      fillRule: "nonzero"
    })
  }));
};

SvgPlusBold.displayName = 'SvgPlusBold';

var PlusBoldIcon = function PlusBoldIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPlusBold, _objectSpread$x(_objectSpread$x({}, props), {}, {
        className: createClass(getIconStyles$x(props, theme))
      }));
    }
  });
};

PlusBoldIcon.displayName = 'PlusBoldIcon';
var PlusBoldIcon$1 = PlusBoldIcon;

function ownKeys$w(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$w(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$w(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$w(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$w = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$w = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$w[size], "px"),
        height: "".concat(iconSizes$w[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$w.big, "px"),
        height: "".concat(iconSizes$w.big, "px")
      };
  }
};

var getSizeStyle$w = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$w(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$w = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$w(_objectSpread$w({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$w = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$w(props.color, theme), ";}&,image{", getSizeStyle$w(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgPlusThin = function SvgPlusThin(props) {
  return jsx("svg", _objectSpread$w(_objectSpread$w({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12.5 11.5v-8a.5.5 0 10-1 0v8h-8a.5.5 0 100 1h8v8a.5.5 0 101 0v-8h8a.5.5 0 100-1h-8z",
      fillRule: "evenodd"
    })
  }));
};

SvgPlusThin.displayName = 'SvgPlusThin';

var PlusThinIcon = function PlusThinIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgPlusThin, _objectSpread$w(_objectSpread$w({}, props), {}, {
        className: createClass(getIconStyles$w(props, theme))
      }));
    }
  });
};

PlusThinIcon.displayName = 'PlusThinIcon';
var PlusThinIcon$1 = PlusThinIcon;

function ownKeys$v(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$v(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$v(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$v(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$v = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$v = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$v[size], "px"),
        height: "".concat(iconSizes$v[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$v.big, "px"),
        height: "".concat(iconSizes$v.big, "px")
      };
  }
};

var getSizeStyle$v = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$v(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$v = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$v(_objectSpread$v({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$v = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$v(props.color, theme), ";}&,image{", getSizeStyle$v(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgRefresh = function SvgRefresh(props) {
  return jsx("svg", _objectSpread$v(_objectSpread$v({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M18.257 5.329c-3.59-3.217-9.137-3.101-12.586.347-3.542 3.595-3.542 9.41.026 12.98a9.145 9.145 0 006.477 2.669 9.19 9.19 0 006.476-2.67 9.176 9.176 0 002.326-3.965 1.041 1.041 0 00-.74-1.295 1.041 1.041 0 00-1.295.74 7.006 7.006 0 01-1.798 3.04 7.052 7.052 0 01-9.965 0 7.052 7.052 0 010-9.965 7.053 7.053 0 019.567-.37l-1.153 1.153a.354.354 0 00-.101.285.445.445 0 00.135.298.445.445 0 00.298.134l4.075.234a.355.355 0 00.285-.102.354.354 0 00.102-.284l-.234-4.076a.445.445 0 00-.135-.298.445.445 0 00-.297-.135.354.354 0 00-.285.101L18.257 5.33z",
      fillRule: "nonzero"
    })
  }));
};

SvgRefresh.displayName = 'SvgRefresh';

var RefreshIcon = function RefreshIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgRefresh, _objectSpread$v(_objectSpread$v({}, props), {}, {
        className: createClass(getIconStyles$v(props, theme))
      }));
    }
  });
};

RefreshIcon.displayName = 'RefreshIcon';
var RefreshIcon$1 = RefreshIcon;

function ownKeys$u(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$u(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$u(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$u(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$u = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$u = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$u[size], "px"),
        height: "".concat(iconSizes$u[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$u.big, "px"),
        height: "".concat(iconSizes$u.big, "px")
      };
  }
};

var getSizeStyle$u = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$u(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$u = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$u(_objectSpread$u({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$u = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$u(props.color, theme), ";}&,image{", getSizeStyle$u(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgRestore = function SvgRestore(props) {
  return jsx("svg", _objectSpread$u(_objectSpread$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      d: "M17.42 8.314a.777.777 0 011.305-.843 8.545 8.545 0 11-5.88-3.81.777.777 0 01-.235 1.535 6.991 6.991 0 104.81 3.118zm-6.976-.676a.777.777 0 011.553-.019l.063 5.111a.777.777 0 11-1.554.02l-.062-5.112zm4.278 6.133a.777.777 0 11-.757 1.356l-3.06-1.709a.777.777 0 11.757-1.356l3.06 1.709zm1.845-3.443a.332.332 0 01-.184-.173.332.332 0 01-.014-.253l1.015-3.06a.296.296 0 01.403-.188l2.996 1.19a.331.331 0 01.184.173.332.332 0 01.015.253.296.296 0 01-.16.184l-4.011 1.87a.296.296 0 01-.244.004z"
    })
  }));
};

SvgRestore.displayName = 'SvgRestore';

var RestoreIcon = function RestoreIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgRestore, _objectSpread$u(_objectSpread$u({}, props), {}, {
        className: createClass(getIconStyles$u(props, theme))
      }));
    }
  });
};

RestoreIcon.displayName = 'RestoreIcon';
var RestoreIcon$1 = RestoreIcon;

function ownKeys$t(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$t(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$t(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$t(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$t = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$t = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$t[size], "px"),
        height: "".concat(iconSizes$t[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$t.big, "px"),
        height: "".concat(iconSizes$t.big, "px")
      };
  }
};

var getSizeStyle$t = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$t(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$t = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$t(_objectSpread$t({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$t = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$t(props.color, theme), ";}&,image{", getSizeStyle$t(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgRevert = function SvgRevert(props) {
  return jsx("svg", _objectSpread$t(_objectSpread$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 18 10"
  }, props), {}, {
    children: jsx("path", {
      d: "M9.458 0a8.524 8.524 0 00-6.7 3.246L.796 1.283C.358.845 0 .993 0 1.613v7.335c0 .619.024.594.643.594h7.286c.619 0 .767-.358.33-.796L6.015 6.503a6.283 6.283 0 015.697-3.64 6.283 6.283 0 016.277 6.085A8.542 8.542 0 009.459 0z"
    })
  }));
};

SvgRevert.displayName = 'SvgRevert';

var RevertIcon = function RevertIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgRevert, _objectSpread$t(_objectSpread$t({}, props), {}, {
        className: createClass(getIconStyles$t(props, theme))
      }));
    }
  });
};

RevertIcon.displayName = 'RevertIcon';
var RevertIcon$1 = RevertIcon;

function ownKeys$s(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$s(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$s(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$s(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$s = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$s = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$s[size], "px"),
        height: "".concat(iconSizes$s[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$s.big, "px"),
        height: "".concat(iconSizes$s.big, "px")
      };
  }
};

var getSizeStyle$s = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$s(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$s = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$s(_objectSpread$s({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$s = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$s(props.color, theme), ";}&,image{", getSizeStyle$s(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgReview = function SvgReview(props) {
  return jsxs("svg", _objectSpread$s(_objectSpread$s({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [jsx("defs", {
      children: jsx("path", {
        d: "M11.986 17.972a5.986 5.986 0 110-11.972 5.986 5.986 0 010 11.972zm3.366-9.115a.34.34 0 00-.48 0l-4.247 4.248a.34.34 0 01-.48 0L9.1 12.06a.34.34 0 00-.479 0l-.641.642a.34.34 0 000 .48l2.167 2.166a.34.34 0 00.479 0l5.369-5.37a.34.34 0 000-.478l-.642-.642z",
        id: "review_react_svg__a"
      })
    }), jsxs("g", {
      transform: "translate(3 3)",
      fill: "#000105",
      fillRule: "evenodd",
      children: [jsx("path", {
        d: "M16 5.07V4H2v12h3.07c.436.753.99 1.428 1.638 2H0V0h18v6.708a8.037 8.037 0 00-2-1.638zm2 12.908V18h-.019l.019-.022z"
      }), jsx("use", {
        xlinkHref: "#review_react_svg__a"
      })]
    })]
  }));
};

SvgReview.displayName = 'SvgReview';

var ReviewIcon = function ReviewIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgReview, _objectSpread$s(_objectSpread$s({}, props), {}, {
        className: createClass(getIconStyles$s(props, theme))
      }));
    }
  });
};

ReviewIcon.displayName = 'ReviewIcon';
var ReviewIcon$1 = ReviewIcon;

function ownKeys$r(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$r(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$r(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$r(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$r = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$r = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$r[size], "px"),
        height: "".concat(iconSizes$r[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$r.big, "px"),
        height: "".concat(iconSizes$r.big, "px")
      };
  }
};

var getSizeStyle$r = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$r(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$r = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$r(_objectSpread$r({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$r = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$r(props.color, theme), ";}&,image{", getSizeStyle$r(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgRightTriangleFilled = function SvgRightTriangleFilled(props) {
  return jsx("svg", _objectSpread$r(_objectSpread$r({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M8 0v8H0z",
      fill: "#1A1A1A",
      fillRule: "evenodd"
    })
  }));
};

SvgRightTriangleFilled.displayName = 'SvgRightTriangleFilled';

var RightTriangleFilledIcon = function RightTriangleFilledIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgRightTriangleFilled, _objectSpread$r(_objectSpread$r({}, props), {}, {
        className: createClass(getIconStyles$r(props, theme))
      }));
    }
  });
};

RightTriangleFilledIcon.displayName = 'RightTriangleFilledIcon';
var RightTriangleFilledIcon$1 = RightTriangleFilledIcon;

function ownKeys$q(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$q(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$q(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$q(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$q = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$q = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$q[size], "px"),
        height: "".concat(iconSizes$q[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$q.big, "px"),
        height: "".concat(iconSizes$q.big, "px")
      };
  }
};

var getSizeStyle$q = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$q(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$q = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$q(_objectSpread$q({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$q = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$q(props.color, theme), ";}&,image{", getSizeStyle$q(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgRightTriangleLinear = function SvgRightTriangleLinear(props) {
  return jsx("svg", _objectSpread$q(_objectSpread$q({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M8 0v8H0l8-8zM7 2.287L2.247 7H7V2.287z",
      fill: "#1A1A1A",
      fillRule: "evenodd"
    })
  }));
};

SvgRightTriangleLinear.displayName = 'SvgRightTriangleLinear';

var RightTriangleLinearIcon = function RightTriangleLinearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgRightTriangleLinear, _objectSpread$q(_objectSpread$q({}, props), {}, {
        className: createClass(getIconStyles$q(props, theme))
      }));
    }
  });
};

RightTriangleLinearIcon.displayName = 'RightTriangleLinearIcon';
var RightTriangleLinearIcon$1 = RightTriangleLinearIcon;

function ownKeys$p(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$p(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$p(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$p(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$p = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$p = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$p[size], "px"),
        height: "".concat(iconSizes$p[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$p.big, "px"),
        height: "".concat(iconSizes$p.big, "px")
      };
  }
};

var getSizeStyle$p = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$p(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$p = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$p(_objectSpread$p({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$p = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$p(props.color, theme), ";}&,image{", getSizeStyle$p(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgRocket = function SvgRocket(props) {
  return jsx("svg", _objectSpread$p(_objectSpread$p({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fillRule: "evenodd",
      children: jsx("g", {
        fill: "#1A1A1A",
        fillRule: "nonzero",
        children: jsx("path", {
          d: "M20.539 3.068a9.168 9.168 0 00-4.084.427 9.17 9.17 0 00-3.482 2.174l-2.29 2.29-.044.005-3.257.42a.207.207 0 00-.12.058l-3.14 3.141a.205.205 0 00.108.347l2.415.448.622.622-.157.085-.993.538a.206.206 0 00-.047.326l3.767 3.767a.206.206 0 00.325-.048l.623-1.15.622.622.008.04.44 2.375a.205.205 0 00.347.108l3.14-3.14a.205.205 0 00.06-.12l.425-3.302.032-.032 2.257-2.257a9.173 9.173 0 002.175-3.482 9.172 9.172 0 00.426-4.083.205.205 0 00-.178-.179zM7.523 16.326a.405.405 0 010 .574l-2.905 2.905a.404.404 0 11-.573-.573l2.905-2.906a.405.405 0 01.573 0zM8.449 17.252a.405.405 0 010 .573l-1.31 1.31a.405.405 0 11-.572-.574l1.308-1.309a.405.405 0 01.574 0zM5 16.997a.406.406 0 010 .573l-1.308 1.309a.404.404 0 01-.573 0 .405.405 0 010-.573l1.308-1.31a.406.406 0 01.574 0zM6.065 16.62a.5.5 0 11-1 0 .5.5 0 011 0zM6.598 19.684a.5.5 0 11-1 0 .5.5 0 011 0z"
        })
      })
    })
  }));
};

SvgRocket.displayName = 'SvgRocket';

var RocketIcon = function RocketIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgRocket, _objectSpread$p(_objectSpread$p({}, props), {}, {
        className: createClass(getIconStyles$p(props, theme))
      }));
    }
  });
};

RocketIcon.displayName = 'RocketIcon';
var RocketIcon$1 = RocketIcon;

function ownKeys$o(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$o(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$o(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$o(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$o = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$o = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$o[size], "px"),
        height: "".concat(iconSizes$o[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$o.big, "px"),
        height: "".concat(iconSizes$o.big, "px")
      };
  }
};

var getSizeStyle$o = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$o(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$o = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$o(_objectSpread$o({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$o = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$o(props.color, theme), ";}&,image{", getSizeStyle$o(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcmVlbkdlYXJSZWFjdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0hnRSIsImZpbGUiOiJTY3JlZW5HZWFyUmVhY3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLy8gVEhJUyBJUyBBTiBBVVRPR0VORVJBVEVEIEZJTEUuIERPIE5PVCBFRElUIFRISVMgRklMRSBESVJFQ1RMWS5cbi8vIFRoaXMgZmlsZSBpcyBjcmVhdGVkIHdpdGggJ3lhcm4gZ2VuZXJhdGUtaWNvbnMnLlxuLy8gT3JpZ2luYWwgU1ZHIGZpbGU6IHNyYy9zdmcvc2NyZWVuLWdlYXIucmVhY3Quc3ZnXG5cbi8qIGVzbGludC1kaXNhYmxlIEB0eXBlc2NyaXB0LWVzbGludC9uby11bnVzZWQtdmFycyAqL1xuaW1wb3J0IHR5cGUgeyBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IHdhcm5pbmcgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC91dGlscyc7XG5pbXBvcnQgeyBjc3MsIENsYXNzTmFtZXMsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5leHBvcnQgdHlwZSBQcm9wcyA9IHtcbiAgY29sb3I/OlxuICAgIHwgJ3NvbGlkJ1xuICAgIHwgJ25ldXRyYWw2MCdcbiAgICB8ICdzdXJmYWNlJ1xuICAgIHwgJ2luZm8nXG4gICAgfCAncHJpbWFyeSdcbiAgICB8ICdwcmltYXJ5NDAnXG4gICAgfCAnd2FybmluZydcbiAgICB8ICdlcnJvcic7XG4gIHNpemU/OiAnc21hbGwnIHwgJ21lZGl1bScgfCAnYmlnJyB8ICdzY2FsZSc7XG59O1xuZXhwb3J0IHR5cGUgU1ZHUHJvcHMgPSBQcm9wcyAmIHtcbiAgY2xhc3NOYW1lOiBzdHJpbmc7XG59O1xuY29uc3QgaWNvblNpemVzID0ge1xuICBzbWFsbDogMTIsXG4gIG1lZGl1bTogMTYsXG4gIGJpZzogMjQsXG59IGFzIGNvbnN0O1xuXG5jb25zdCBnZXRTaXplRGltZW5zaW9ucyA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ3NjYWxlJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICAgIGhlaWdodDogJ2F1dG8nLFxuICAgICAgfTtcblxuICAgIGNhc2UgJ3NtYWxsJzpcbiAgICBjYXNlICdtZWRpdW0nOlxuICAgIGNhc2UgJ2JpZyc6XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogYCR7aWNvblNpemVzW3NpemVdfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgfTtcblxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogYCR7aWNvblNpemVzLmJpZ31weGAsXG4gICAgICAgIGhlaWdodDogYCR7aWNvblNpemVzLmJpZ31weGAsXG4gICAgICB9O1xuICB9XG59O1xuXG5jb25zdCBnZXRTaXplU3R5bGUgPSAoc2l6ZTogUHJvcHNbJ3NpemUnXSkgPT4ge1xuICBjb25zdCBkaW1lbnNpb25zID0gZ2V0U2l6ZURpbWVuc2lvbnMoc2l6ZSk7XG5cbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgJjpub3QoOnJvb3QpIHtcbiAgICAgICAgICB3aWR0aDogJHtkaW1lbnNpb25zLndpZHRofTtcbiAgICAgICAgICBoZWlnaHQ6ICR7ZGltZW5zaW9ucy5oZWlnaHR9O1xuICAgICAgICB9XG4gICAgICBgO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBgXG4gICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICBoZWlnaHQ6ICR7ZGltZW5zaW9ucy5oZWlnaHR9O1xuICAgICAgYDtcbiAgfVxufTtcblxuY29uc3QgZ2V0Q29sb3IgPSAoY29sb3I6IFByb3BzWydjb2xvciddLCB0aGVtZTogVGhlbWUpID0+IHtcbiAgaWYgKCFjb2xvcikgcmV0dXJuICdpbmhlcml0JztcbiAgY29uc3Qgb3ZlcndyaXR0ZW5WYXJzID0geyAuLi52YXJzLCAuLi50aGVtZSB9O1xuICBsZXQgaWNvbkNvbG9yO1xuXG4gIHN3aXRjaCAoY29sb3IpIHtcbiAgICBjYXNlICdzb2xpZCc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JTb2xpZDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnbmV1dHJhbDYwJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvck5ldXRyYWw2MDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnc3VyZmFjZSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JTdXJmYWNlO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdpbmZvJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckluZm87XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ3ByaW1hcnknOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeTQwJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclByaW1hcnk0MDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnd2FybmluZyc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JXYXJuaW5nO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdlcnJvcic6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JFcnJvcjtcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgaWYgKCFpY29uQ29sb3IpIHtcbiAgICB3YXJuaW5nKFxuICAgICAgY29sb3IsXG4gICAgICBgdWkta2l0L0ljb246IHRoZSBzcGVjaWZpZWQgY29sb3IgJyR7Y29sb3J9JyBpcyBub3Qgc3VwcG9ydGVkLmBcbiAgICApO1xuICAgIHJldHVybiAnaW5oZXJpdCc7XG4gIH1cblxuICByZXR1cm4gaWNvbkNvbG9yO1xufTtcblxuZXhwb3J0IGNvbnN0IGdldEljb25TdHlsZXMgPSAocHJvcHM6IFByb3BzLCB0aGVtZTogVGhlbWUpID0+IGNzc2BcbiAgKjpub3QoW2ZpbGw9J25vbmUnXSkge1xuICAgIGZpbGw6ICR7Z2V0Q29sb3IocHJvcHMuY29sb3IsIHRoZW1lKX07XG4gIH1cbiAgJixcbiAgaW1hZ2Uge1xuICAgICR7Z2V0U2l6ZVN0eWxlKHByb3BzLnNpemUpfTtcbiAgfVxuICBmbGV4LXNocmluazogMDtcbmA7XG5cbmNvbnN0IFN2Z1NjcmVlbkdlYXIgPSAocHJvcHM6IFNWR1Byb3BzKSA9PiAoXG4gIDxzdmdcbiAgICB3aWR0aD17MjR9XG4gICAgaGVpZ2h0PXsyNH1cbiAgICB2aWV3Qm94PVwiMCAwIDI0IDI0XCJcbiAgICB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCJcbiAgICB7Li4ucHJvcHN9XG4gID5cbiAgICA8cGF0aFxuICAgICAgZD1cIk0xNi41MSA1LjY2MUg1LjcwMXYtLjloMTAuODA3di45ek0zLjkgMTQuNzA4aDIuNzAydi45SDMuOTAxYS45LjkgMCAwMS0uOTAxLS45VjMuOTAxQS45LjkgMCAwMTMuOSAzaDE0LjQxYS45LjkgMCAwMS45MDEuOXYzLjYwM2gtLjlWMy45MDFIMy45djEwLjgwN3ptMTUuNTE5LjJsMS40NjUgMS4xMTRhLjMzNS4zMzUgMCAwMS4wODMuNDMybC0xLjM4OSAyLjMzN2MtLjA4My4xNDktLjI2My4yMS0uNDIzLjE0OWwtMS43My0uNjc2Yy0uMzYuMjY0LS43NS40OTMtMS4xNzMuNjYybC0uMjY0IDEuNzlhLjMzNi4zMzYgMCAwMS0uMzQuMjg0SDEyLjg3YS4zMzYuMzM2IDAgMDEtLjM0LS4yODRsLS4yNjQtMS43OWE1LjExIDUuMTEgMCAwMS0xLjE3My0uNjYybC0xLjczLjY3NmEuMzU0LjM1NCAwIDAxLS40MjMtLjE0OWwtMS4zODktMi4zMzdhLjMzNS4zMzUgMCAwMS4wODQtLjQzMkw5LjEgMTQuOTA3di0xLjMyNEw3LjYzNSAxMi40N2EuMzI3LjMyNyAwIDAxLS4wODQtLjQzMmwxLjM5LTIuMzM4YS4zNDMuMzQzIDAgMDEuNDIzLS4xNDhsMS43MjkuNjc1Yy4zNi0uMjYzLjc1LS40OTMgMS4xNzMtLjY2MmwuMjY0LTEuNzlhLjMzNi4zMzYgMCAwMS4zNC0uMjgzaDIuNzc4Yy4xNzQgMCAuMzIuMTIxLjM0LjI4M2wuMjY0IDEuNzlhNS4xMSA1LjExIDAgMDExLjE3NC42NjJsMS43MjktLjY3NWMuMTUzLS4wNTQuMzQgMCAuNDIzLjE0OGwxLjM5IDIuMzM4YS4zMzUuMzM1IDAgMDEtLjA4NC40MzJsLTEuNDY1IDEuMTE0djEuMzI0ek05LjMwNCA3LjQ2Mkg1LjcwMnYtLjkwMWgzLjYwMnYuOXptNC45NTUgOS4xNDZjMS4zNCAwIDIuNDMtMS4wNiAyLjQzLTIuMzY0IDAtMS4zMDMtMS4wOS0yLjM2NC0yLjQzLTIuMzY0cy0yLjQzIDEuMDYtMi40MyAyLjM2NGMwIDEuMzA0IDEuMDkgMi4zNjQgMi40MyAyLjM2NHpcIlxuICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cblN2Z1NjcmVlbkdlYXIuZGlzcGxheU5hbWUgPSAnU3ZnU2NyZWVuR2Vhcic7XG5cbmNvbnN0IFNjcmVlbkdlYXJJY29uID0gKHByb3BzOiBQcm9wcykgPT4ge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIHJldHVybiAoXG4gICAgPENsYXNzTmFtZXM+XG4gICAgICB7KHsgY3NzOiBjcmVhdGVDbGFzcyB9KSA9PiAoXG4gICAgICAgIDxTdmdTY3JlZW5HZWFyXG4gICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAgIGNsYXNzTmFtZT17Y3JlYXRlQ2xhc3MoZ2V0SWNvblN0eWxlcyhwcm9wcywgdGhlbWUpKX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgPC9DbGFzc05hbWVzPlxuICApO1xufTtcblxuU2NyZWVuR2Vhckljb24uZGlzcGxheU5hbWUgPSAnU2NyZWVuR2Vhckljb24nO1xuZXhwb3J0IGRlZmF1bHQgU2NyZWVuR2Vhckljb247XG4iXX0= */");
};

var SvgScreenGear = function SvgScreenGear(props) {
  return jsx("svg", _objectSpread$o(_objectSpread$o({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.51 5.661H5.701v-.9h10.807v.9zM3.9 14.708h2.702v.9H3.901a.9.9 0 01-.901-.9V3.901A.9.9 0 013.9 3h14.41a.9.9 0 01.901.9v3.603h-.9V3.901H3.9v10.807zm15.519.2l1.465 1.114a.335.335 0 01.083.432l-1.389 2.337c-.083.149-.263.21-.423.149l-1.73-.676c-.36.264-.75.493-1.173.662l-.264 1.79a.336.336 0 01-.34.284H12.87a.336.336 0 01-.34-.284l-.264-1.79a5.11 5.11 0 01-1.173-.662l-1.73.676a.354.354 0 01-.423-.149l-1.389-2.337a.335.335 0 01.084-.432L9.1 14.907v-1.324L7.635 12.47a.327.327 0 01-.084-.432l1.39-2.338a.343.343 0 01.423-.148l1.729.675c.36-.263.75-.493 1.173-.662l.264-1.79a.336.336 0 01.34-.283h2.778c.174 0 .32.121.34.283l.264 1.79a5.11 5.11 0 011.174.662l1.729-.675c.153-.054.34 0 .423.148l1.39 2.338a.335.335 0 01-.084.432l-1.465 1.114v1.324zM9.304 7.462H5.702v-.901h3.602v.9zm4.955 9.146c1.34 0 2.43-1.06 2.43-2.364 0-1.303-1.09-2.364-2.43-2.364s-2.43 1.06-2.43 2.364c0 1.304 1.09 2.364 2.43 2.364z",
      fillRule: "evenodd"
    })
  }));
};

SvgScreenGear.displayName = 'SvgScreenGear';

var ScreenGearIcon = function ScreenGearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgScreenGear, _objectSpread$o(_objectSpread$o({}, props), {}, {
        className: createClass(getIconStyles$o(props, theme))
      }));
    }
  });
};

ScreenGearIcon.displayName = 'ScreenGearIcon';
var ScreenGearIcon$1 = ScreenGearIcon;

function ownKeys$n(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$n(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$n(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$n(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$n = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$n = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$n[size], "px"),
        height: "".concat(iconSizes$n[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$n.big, "px"),
        height: "".concat(iconSizes$n.big, "px")
      };
  }
};

var getSizeStyle$n = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$n(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$n = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$n(_objectSpread$n({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$n = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$n(props.color, theme), ";}&,image{", getSizeStyle$n(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgScreenUser = function SvgScreenUser(props) {
  return jsx("svg", _objectSpread$n(_objectSpread$n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M16.5 6.6H5.7v-.9h10.8v.9zM3.9 14.7h2.7v.9H3.9a.9.9 0 01-.9-.9V3.9a.9.9 0 01.9-.9h14.4a.9.9 0 01.9.9v3.6h-.9V3.9H3.9v10.8zm5.4-6.3H5.7v-.9h3.6v.9zm4.95-.9a3.37 3.37 0 013.375 3.375 3.37 3.37 0 01-3.375 3.375 3.37 3.37 0 01-3.375-3.375A3.37 3.37 0 0114.25 7.5zM21 21H7.5v-1.125c0-2.25 4.5-3.488 6.75-3.488S21 17.625 21 19.875V21z",
      fillRule: "evenodd"
    })
  }));
};

SvgScreenUser.displayName = 'SvgScreenUser';

var ScreenUserIcon = function ScreenUserIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgScreenUser, _objectSpread$n(_objectSpread$n({}, props), {}, {
        className: createClass(getIconStyles$n(props, theme))
      }));
    }
  });
};

ScreenUserIcon.displayName = 'ScreenUserIcon';
var ScreenUserIcon$1 = ScreenUserIcon;

function ownKeys$m(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$m(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$m(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$m(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$m = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$m = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$m[size], "px"),
        height: "".concat(iconSizes$m[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$m.big, "px"),
        height: "".concat(iconSizes$m.big, "px")
      };
  }
};

var getSizeStyle$m = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$m(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$m = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$m(_objectSpread$m({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$m = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$m(props.color, theme), ";}&,image{", getSizeStyle$m(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlYXJjaFJlYWN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErSGdFIiwiZmlsZSI6IlNlYXJjaFJlYWN0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8vIFRISVMgSVMgQU4gQVVUT0dFTkVSQVRFRCBGSUxFLiBETyBOT1QgRURJVCBUSElTIEZJTEUgRElSRUNUTFkuXG4vLyBUaGlzIGZpbGUgaXMgY3JlYXRlZCB3aXRoICd5YXJuIGdlbmVyYXRlLWljb25zJy5cbi8vIE9yaWdpbmFsIFNWRyBmaWxlOiBzcmMvc3ZnL3NlYXJjaC5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnU2VhcmNoID0gKHByb3BzOiBTVkdQcm9wcykgPT4gKFxuICA8c3ZnXG4gICAgd2lkdGg9ezI0fVxuICAgIGhlaWdodD17MjR9XG4gICAgdmlld0JveD1cIjAgMCAyNCAyNFwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gICAgey4uLnByb3BzfVxuICA+XG4gICAgPHBhdGhcbiAgICAgIGQ9XCJNNS41NTYgMTIuMTRhNC44MzIgNC44MzIgMCAwMTAtNC44MUE0Ljc4MiA0Ljc4MiAwIDAxOS43IDQuOTI0YzEuNzEgMCAzLjI5LjkxNyA0LjE0NSAyLjQwNmE0LjgzMiA0LjgzMiAwIDAxMCA0LjgxQTQuNzgyIDQuNzgyIDAgMDE5LjcgMTQuNTQ3Yy0xLjcxIDAtMy4yOS0uOTE3LTQuMTQ1LTIuNDA1bTE1LjE4IDcuNDI3bC01LjcxMy01Ljc0MmE2Ljc1MiA2Ljc1MiAwIDAwLjQ4LTcuNDU4QTYuNjk0IDYuNjk0IDAgMDA5LjcwMiAzYTYuNjk0IDYuNjk0IDAgMDAtNS44MDMgMy4zNjggNi43NjUgNi43NjUgMCAwMDAgNi43MzUgNi42NzYgNi42NzYgMCAwMDkuODUgMmw1LjcxNSA1Ljc0NWEuODk2Ljg5NiAwIDAwMS4yNzMgMCAuOTA5LjkwOSAwIDAwMC0xLjI4XCJcbiAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5TdmdTZWFyY2guZGlzcGxheU5hbWUgPSAnU3ZnU2VhcmNoJztcblxuY29uc3QgU2VhcmNoSWNvbiA9IChwcm9wczogUHJvcHMpID0+IHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICByZXR1cm4gKFxuICAgIDxDbGFzc05hbWVzPlxuICAgICAgeyh7IGNzczogY3JlYXRlQ2xhc3MgfSkgPT4gKFxuICAgICAgICA8U3ZnU2VhcmNoXG4gICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAgIGNsYXNzTmFtZT17Y3JlYXRlQ2xhc3MoZ2V0SWNvblN0eWxlcyhwcm9wcywgdGhlbWUpKX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgPC9DbGFzc05hbWVzPlxuICApO1xufTtcblxuU2VhcmNoSWNvbi5kaXNwbGF5TmFtZSA9ICdTZWFyY2hJY29uJztcbmV4cG9ydCBkZWZhdWx0IFNlYXJjaEljb247XG4iXX0= */");
};

var SvgSearch = function SvgSearch(props) {
  return jsx("svg", _objectSpread$m(_objectSpread$m({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M5.556 12.14a4.832 4.832 0 010-4.81A4.782 4.782 0 019.7 4.924c1.71 0 3.29.917 4.145 2.406a4.832 4.832 0 010 4.81A4.782 4.782 0 019.7 14.547c-1.71 0-3.29-.917-4.145-2.405m15.18 7.427l-5.713-5.742a6.752 6.752 0 00.48-7.458A6.694 6.694 0 009.702 3a6.694 6.694 0 00-5.803 3.368 6.765 6.765 0 000 6.735 6.676 6.676 0 009.85 2l5.715 5.745a.896.896 0 001.273 0 .909.909 0 000-1.28",
      fillRule: "evenodd"
    })
  }));
};

SvgSearch.displayName = 'SvgSearch';

var SearchIcon = function SearchIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSearch, _objectSpread$m(_objectSpread$m({}, props), {}, {
        className: createClass(getIconStyles$m(props, theme))
      }));
    }
  });
};

SearchIcon.displayName = 'SearchIcon';
var SearchIcon$1 = SearchIcon;

function ownKeys$l(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$l(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$l(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$l(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$l = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$l = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$l[size], "px"),
        height: "".concat(iconSizes$l[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$l.big, "px"),
        height: "".concat(iconSizes$l.big, "px")
      };
  }
};

var getSizeStyle$l = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$l(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$l = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$l(_objectSpread$l({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$l = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$l(props.color, theme), ";}&,image{", getSizeStyle$l(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgSorting = function SvgSorting(props) {
  return jsx("svg", _objectSpread$l(_objectSpread$l({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12.994 17.318L9.554 21l-3.506-3.682h2.686v-5.5a.82.82 0 011.641 0v5.5h2.62zM11.006 6.682L14.446 3l3.506 3.682h-2.686v5.5a.82.82 0 01-1.641 0v-5.5h-2.62z",
      fillRule: "evenodd"
    })
  }));
};

SvgSorting.displayName = 'SvgSorting';

var SortingIcon = function SortingIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSorting, _objectSpread$l(_objectSpread$l({}, props), {}, {
        className: createClass(getIconStyles$l(props, theme))
      }));
    }
  });
};

SortingIcon.displayName = 'SortingIcon';
var SortingIcon$1 = SortingIcon;

function ownKeys$k(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$k(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$k(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$k(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$k = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$k = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$k[size], "px"),
        height: "".concat(iconSizes$k[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$k.big, "px"),
        height: "".concat(iconSizes$k.big, "px")
      };
  }
};

var getSizeStyle$k = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$k(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$k = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$k(_objectSpread$k({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$k = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$k(props.color, theme), ";}&,image{", getSizeStyle$k(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgSpeechBubble = function SvgSpeechBubble(props) {
  return jsx("svg", _objectSpread$k(_objectSpread$k({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M3 15.094c.002 1.162 1.008 2.104 2.25 2.105h6.175l4.393 3.408c.07.039.15.06.232.06.248 0 .45-.189.45-.421v-3.047h2.25c1.242-.001 2.249-.943 2.25-2.105V5.772c-.001-1.162-1.008-2.104-2.25-2.105H5.25c-1.242 0-2.248.943-2.25 2.105v9.322z",
      fill: "#1A1A1A",
      fillRule: "evenodd"
    })
  }));
};

SvgSpeechBubble.displayName = 'SvgSpeechBubble';

var SpeechBubbleIcon = function SpeechBubbleIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSpeechBubble, _objectSpread$k(_objectSpread$k({}, props), {}, {
        className: createClass(getIconStyles$k(props, theme))
      }));
    }
  });
};

SpeechBubbleIcon.displayName = 'SpeechBubbleIcon';
var SpeechBubbleIcon$1 = SpeechBubbleIcon;

function ownKeys$j(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$j(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$j(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$j(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$j = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$j = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$j[size], "px"),
        height: "".concat(iconSizes$j[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$j.big, "px"),
        height: "".concat(iconSizes$j.big, "px")
      };
  }
};

var getSizeStyle$j = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$j(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$j = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$j(_objectSpread$j({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$j = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$j(props.color, theme), ";}&,image{", getSizeStyle$j(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgSpeedometer = function SvgSpeedometer(props) {
  return jsx("svg", _objectSpread$j(_objectSpread$j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M15.383 10.035a4.788 4.788 0 00-3.387-1.398 4.788 4.788 0 00-4.793 4.794c0 1.223.458 2.34 1.213 3.189.065.073 0 0 0 0s-.116.528-.507.918l-1.51 1.505c-.395.393-.842.565-1.008.391 0 0 .097.107 0 0a8.886 8.886 0 01-2.327-6.004c0-2.46.999-4.69 2.614-6.305a8.893 8.893 0 016.318-2.627 8.89 8.89 0 016.314 2.623l.01-.01c.824.822 1.488 1.801 1.944 2.89-.221.068-.44.142-.66.217l-3.353 1.01c-.23-.44-.52-.844-.87-1.192h.002zm-3.36 2.405l3.748-.502-2.881 2.478c-.093.087-.361.239-.483.294a1.145 1.145 0 01-1.514-.581c-.258-.579 0-1.26.579-1.52.122-.053.424-.16.55-.169zm8.089 4.724c.404-.917.67-1.911.76-2.96-1.38.005-2.76-.008-4.137-.104-.05.366-.143.719-.268 1.054a54.338 54.338 0 013.645 2.01zm-3.1-3.629l3.922.028.002-.061c0-.981-.157-1.925-.435-2.811l-2.351.727c-.492.175-.99.336-1.495.462l-.123.038c.164.498.258 1.029.258 1.584l-.001.021c.074.006.148.008.222.012zm-1.038 2.51c-.327.441-.279 1.117.102 1.505l1.542 1.568a.864.864 0 001.325-.075s.44-.482.843-1.214l-3.633-2.025-.179.241z",
      fillRule: "evenodd"
    })
  }));
};

SvgSpeedometer.displayName = 'SvgSpeedometer';

var SpeedometerIcon = function SpeedometerIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSpeedometer, _objectSpread$j(_objectSpread$j({}, props), {}, {
        className: createClass(getIconStyles$j(props, theme))
      }));
    }
  });
};

SpeedometerIcon.displayName = 'SpeedometerIcon';
var SpeedometerIcon$1 = SpeedometerIcon;

function ownKeys$i(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$i(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$i(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$i(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$i = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$i = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$i[size], "px"),
        height: "".concat(iconSizes$i[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$i.big, "px"),
        height: "".concat(iconSizes$i.big, "px")
      };
  }
};

var getSizeStyle$i = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$i(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$i = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$i(_objectSpread$i({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$i = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$i(props.color, theme), ";}&,image{", getSizeStyle$i(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgSplit = function SvgSplit(props) {
  return jsx("svg", _objectSpread$i(_objectSpread$i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M11.667 19l-5.844-5.368a2 2 0 11.044-3.232l5.8-5.4h5V3.438c0-.119.044-.222.132-.308A.431.431 0 0117.11 3a.43.43 0 01.313.13l3.11 3.062c.089.087.133.19.133.308a.418.418 0 01-.132.308L17.424 9.87a.43.43 0 01-.313.13.43.43 0 01-.312-.13.417.417 0 01-.132-.308V7h-4.263L7 12.039 12.32 17h4.347v-2.562c0-.119.044-.222.132-.308a.431.431 0 01.312-.13.43.43 0 01.313.13l3.11 3.062c.089.087.133.19.133.308a.418.418 0 01-.132.308l-3.111 3.062a.43.43 0 01-.313.13.43.43 0 01-.312-.13.417.417 0 01-.132-.308V19h-5z",
      fillRule: "evenodd"
    })
  }));
};

SvgSplit.displayName = 'SvgSplit';

var SplitIcon = function SplitIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSplit, _objectSpread$i(_objectSpread$i({}, props), {}, {
        className: createClass(getIconStyles$i(props, theme))
      }));
    }
  });
};

SplitIcon.displayName = 'SplitIcon';
var SplitIcon$1 = SplitIcon;

function ownKeys$h(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$h(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$h(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$h(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$h = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$h = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$h[size], "px"),
        height: "".concat(iconSizes$h[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$h.big, "px"),
        height: "".concat(iconSizes$h.big, "px")
      };
  }
};

var getSizeStyle$h = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$h(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$h = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$h(_objectSpread$h({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$h = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$h(props.color, theme), ";}&,image{", getSizeStyle$h(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgStack = function SvgStack(props) {
  return jsx("svg", _objectSpread$h(_objectSpread$h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fillRule: "evenodd",
      fill: "#1A1A1A",
      children: jsx("path", {
        d: "M3.698 11.153l8.16 2.007a.548.548 0 00.262 0l8.16-2.007a.535.535 0 01.669.513v1.113a.53.53 0 01-.407.514l-8.422 2.071a.548.548 0 01-.261 0l-8.422-2.071a.53.53 0 01-.407-.514v-1.113c0-.344.328-.597.668-.513M3.698 15.56l8.16 2.009a.548.548 0 00.262 0l8.16-2.008c.34-.084.669.169.669.513v1.113a.53.53 0 01-.407.514l-8.553 2.104L3.437 17.7a.53.53 0 01-.407-.514v-1.113c0-.344.328-.597.668-.513M3.437 6.524l8.422-2.072a.543.543 0 01.26 0l8.422 2.072a.53.53 0 01.408.513v1.378a.53.53 0 01-.408.513L12.12 11a.548.548 0 01-.26 0L3.437 8.928a.53.53 0 01-.407-.513V7.037a.53.53 0 01.407-.513"
      })
    })
  }));
};

SvgStack.displayName = 'SvgStack';

var StackIcon = function StackIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgStack, _objectSpread$h(_objectSpread$h({}, props), {}, {
        className: createClass(getIconStyles$h(props, theme))
      }));
    }
  });
};

StackIcon.displayName = 'StackIcon';
var StackIcon$1 = StackIcon;

function ownKeys$g(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$g(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$g(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$g(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$g = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$g = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$g[size], "px"),
        height: "".concat(iconSizes$g[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$g.big, "px"),
        height: "".concat(iconSizes$g.big, "px")
      };
  }
};

var getSizeStyle$g = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$g(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$g = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$g(_objectSpread$g({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$g = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$g(props.color, theme), ";}&,image{", getSizeStyle$g(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0YXJSZWFjdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0hnRSIsImZpbGUiOiJTdGFyUmVhY3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLy8gVEhJUyBJUyBBTiBBVVRPR0VORVJBVEVEIEZJTEUuIERPIE5PVCBFRElUIFRISVMgRklMRSBESVJFQ1RMWS5cbi8vIFRoaXMgZmlsZSBpcyBjcmVhdGVkIHdpdGggJ3lhcm4gZ2VuZXJhdGUtaWNvbnMnLlxuLy8gT3JpZ2luYWwgU1ZHIGZpbGU6IHNyYy9zdmcvc3Rhci5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnU3RhciA9IChwcm9wczogU1ZHUHJvcHMpID0+IChcbiAgPHN2ZyB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCIgdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30+XG4gICAgPHBhdGhcbiAgICAgIGNsYXNzTmFtZT1cInN0YXJfcmVhY3Rfc3ZnX19zdDBcIlxuICAgICAgZD1cIk05LjEgOUwxMiAzbDIuOSA2IDYuNi45LTQuOSA0LjUgMS4zIDYuNi01LjktMy4yTDYuMSAyMWwxLjMtNi42LTQuOS00LjV6XCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cblN2Z1N0YXIuZGlzcGxheU5hbWUgPSAnU3ZnU3Rhcic7XG5cbmNvbnN0IFN0YXJJY29uID0gKHByb3BzOiBQcm9wcykgPT4ge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIHJldHVybiAoXG4gICAgPENsYXNzTmFtZXM+XG4gICAgICB7KHsgY3NzOiBjcmVhdGVDbGFzcyB9KSA9PiAoXG4gICAgICAgIDxTdmdTdGFyXG4gICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAgIGNsYXNzTmFtZT17Y3JlYXRlQ2xhc3MoZ2V0SWNvblN0eWxlcyhwcm9wcywgdGhlbWUpKX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgPC9DbGFzc05hbWVzPlxuICApO1xufTtcblxuU3Rhckljb24uZGlzcGxheU5hbWUgPSAnU3Rhckljb24nO1xuZXhwb3J0IGRlZmF1bHQgU3Rhckljb247XG4iXX0= */");
};

var SvgStar = function SvgStar(props) {
  return jsx("svg", _objectSpread$g(_objectSpread$g({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      className: "star_react_svg__st0",
      d: "M9.1 9L12 3l2.9 6 6.6.9-4.9 4.5 1.3 6.6-5.9-3.2L6.1 21l1.3-6.6-4.9-4.5z"
    })
  }));
};

SvgStar.displayName = 'SvgStar';

var StarIcon = function StarIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgStar, _objectSpread$g(_objectSpread$g({}, props), {}, {
        className: createClass(getIconStyles$g(props, theme))
      }));
    }
  });
};

StarIcon.displayName = 'StarIcon';
var StarIcon$1 = StarIcon;

function ownKeys$f(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$f(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$f(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$f(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$f = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$f = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$f[size], "px"),
        height: "".concat(iconSizes$f[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$f.big, "px"),
        height: "".concat(iconSizes$f.big, "px")
      };
  }
};

var getSizeStyle$f = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$f(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$f = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$f(_objectSpread$f({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$f = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$f(props.color, theme), ";}&,image{", getSizeStyle$f(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgSubdirectoryArrow = function SvgSubdirectoryArrow(props) {
  return jsxs("svg", _objectSpread$f(_objectSpread$f({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [jsx("defs", {
      children: jsx("path", {
        d: "M16.404 17v-1.625c0-.102.04-.19.118-.264a.394.394 0 01.28-.111c.107 0 .2.037.279.111l2.78 2.625a.351.351 0 010 .527l-2.78 2.626a.393.393 0 01-.28.111.393.393 0 01-.279-.111.35.35 0 01-.118-.264V19H10a1 1 0 01-1-1V4a1 1 0 112 0v13h5.404z",
        id: "subdirectory-arrow_react_svg__a"
      })
    }), jsx("use", {
      fill: "#1A1A1A",
      xlinkHref: "#subdirectory-arrow_react_svg__a",
      transform: "translate(-9 -3)",
      fillRule: "evenodd"
    })]
  }));
};

SvgSubdirectoryArrow.displayName = 'SvgSubdirectoryArrow';

var SubdirectoryArrowIcon = function SubdirectoryArrowIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSubdirectoryArrow, _objectSpread$f(_objectSpread$f({}, props), {}, {
        className: createClass(getIconStyles$f(props, theme))
      }));
    }
  });
};

SubdirectoryArrowIcon.displayName = 'SubdirectoryArrowIcon';
var SubdirectoryArrowIcon$1 = SubdirectoryArrowIcon;

function ownKeys$e(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$e(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$e(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$e(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$e = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$e = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$e[size], "px"),
        height: "".concat(iconSizes$e[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$e.big, "px"),
        height: "".concat(iconSizes$e.big, "px")
      };
  }
};

var getSizeStyle$e = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$e(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$e = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$e(_objectSpread$e({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$e = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$e(props.color, theme), ";}&,image{", getSizeStyle$e(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgSupport = function SvgSupport(props) {
  return jsx("svg", _objectSpread$e(_objectSpread$e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M14.7 10.732c-.26.389-.614.72-1.054.986-.409.241-.688.47-.83.682-.14.206-.21.478-.21.808v.54h-1.383v-.72c-.004-.462.11-.867.34-1.205.226-.333.58-.643 1.051-.922.373-.227.641-.458.797-.685.152-.222.23-.504.23-.838 0-.388-.135-.7-.412-.953-.275-.253-.653-.381-1.123-.381-.475 0-.86.132-1.145.39-.283.26-.444.618-.478 1.066l-.007.097H9.122l.006-.11c.037-.746.309-1.389.81-1.91.502-.523 1.247-.788 2.214-.788.866 0 1.58.242 2.122.719.546.48.823 1.09.823 1.81 0 .545-.134 1.021-.396 1.414zm-1.954 5.83a1.001 1.001 0 01-.74.293c-.3 0-.551-.098-.745-.292a1.012 1.012 0 01-.292-.744c0-.304.098-.557.292-.75.194-.195.444-.293.744-.293s.55.099.741.293c.192.193.289.446.289.75 0 .3-.097.55-.289.744zM12 3a9 9 0 00-7.619 13.793l-1.046 3.906 3.92-1.05A9 9 0 0021 12a9 9 0 00-9-9z",
      fillRule: "evenodd"
    })
  }));
};

SvgSupport.displayName = 'SvgSupport';

var SupportIcon = function SupportIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSupport, _objectSpread$e(_objectSpread$e({}, props), {}, {
        className: createClass(getIconStyles$e(props, theme))
      }));
    }
  });
};

SupportIcon.displayName = 'SupportIcon';
var SupportIcon$1 = SupportIcon;

function ownKeys$d(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$d(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$d(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$d(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$d = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$d = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$d[size], "px"),
        height: "".concat(iconSizes$d[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$d.big, "px"),
        height: "".concat(iconSizes$d.big, "px")
      };
  }
};

var getSizeStyle$d = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$d(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$d = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$d(_objectSpread$d({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$d = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$d(props.color, theme), ";}&,image{", getSizeStyle$d(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgSwitcher = function SvgSwitcher(props) {
  return jsx("svg", _objectSpread$d(_objectSpread$d({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M3.77 10.996v.797-.797c-.424 0-.77-.387-.77-.863 0-2.659 2.056-4.11 4.49-4.11h11.035l-1.25-1.587a.94.94 0 01.069-1.22.714.714 0 011.087.076l2.377 3.023a.945.945 0 010 1.143l-2.377 3.024a.733.733 0 01-.578.292.721.721 0 01-.508-.216.94.94 0 01-.068-1.22l1.248-1.588H7.491c-1.6 0-2.95.66-2.95 2.382 0 .477-.345.864-.77.864zm15.69.99c0-.524.345-.78.77-.78.426 0 .77.256.77.779 0 2.924-2.056 4.348-4.49 4.348H5.475l1.248 1.918c.282.394.251 1.164-.067 1.512-.32.347-.806.309-1.087-.086L3.192 16.35a1.132 1.132 0 010-1.262l2.377-3.336c.152-.212.365-.343.578-.343.18 0 .362.036.509.195.318.347.35.863.067 1.256l-1.248 1.575H16.51c1.6 0 2.95-.552 2.95-2.448z",
      fillRule: "evenodd"
    })
  }));
};

SvgSwitcher.displayName = 'SvgSwitcher';

var SwitcherIcon = function SwitcherIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgSwitcher, _objectSpread$d(_objectSpread$d({}, props), {}, {
        className: createClass(getIconStyles$d(props, theme))
      }));
    }
  });
};

SwitcherIcon.displayName = 'SwitcherIcon';
var SwitcherIcon$1 = SwitcherIcon;

function ownKeys$c(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$c(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$c(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$c = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$c = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$c[size], "px"),
        height: "".concat(iconSizes$c[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$c.big, "px"),
        height: "".concat(iconSizes$c.big, "px")
      };
  }
};

var getSizeStyle$c = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$c(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$c = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$c(_objectSpread$c({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$c = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$c(props.color, theme), ";}&,image{", getSizeStyle$c(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgTable = function SvgTable(props) {
  return jsx("svg", _objectSpread$c(_objectSpread$c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.458 4.51a1.676 1.676 0 00-1.22-.5H4.728c-.476 0-.882.167-1.22.5A1.628 1.628 0 003 5.713v12.94c0 .47.17.87.507 1.203.339.334.745.5 1.22.5h14.51c.476 0 .883-.166 1.221-.5.338-.333.507-.734.507-1.202V5.713c0-.468-.169-.87-.507-1.203zm-9.166 14.484H4.727a.335.335 0 01-.242-.1.325.325 0 01-.103-.24V6.734h6.91v12.26zm8.291-.34a.325.325 0 01-.102.24.335.335 0 01-.243.1h-6.564V6.734h6.91v11.92z",
      fillRule: "evenodd"
    })
  }));
};

SvgTable.displayName = 'SvgTable';

var TableIcon = function TableIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgTable, _objectSpread$c(_objectSpread$c({}, props), {}, {
        className: createClass(getIconStyles$c(props, theme))
      }));
    }
  });
};

TableIcon.displayName = 'TableIcon';
var TableIcon$1 = TableIcon;

function ownKeys$b(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$b(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$b(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$b = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$b = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$b[size], "px"),
        height: "".concat(iconSizes$b[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$b.big, "px"),
        height: "".concat(iconSizes$b.big, "px")
      };
  }
};

var getSizeStyle$b = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$b(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$b = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$b(_objectSpread$b({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$b = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$b(props.color, theme), ";}&,image{", getSizeStyle$b(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhZ011bHRpUmVhY3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStIZ0UiLCJmaWxlIjoiVGFnTXVsdGlSZWFjdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvLyBUSElTIElTIEFOIEFVVE9HRU5FUkFURUQgRklMRS4gRE8gTk9UIEVESVQgVEhJUyBGSUxFIERJUkVDVExZLlxuLy8gVGhpcyBmaWxlIGlzIGNyZWF0ZWQgd2l0aCAneWFybiBnZW5lcmF0ZS1pY29ucycuXG4vLyBPcmlnaW5hbCBTVkcgZmlsZTogc3JjL3N2Zy90YWctbXVsdGkucmVhY3Quc3ZnXG5cbi8qIGVzbGludC1kaXNhYmxlIEB0eXBlc2NyaXB0LWVzbGludC9uby11bnVzZWQtdmFycyAqL1xuaW1wb3J0IHR5cGUgeyBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IHdhcm5pbmcgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC91dGlscyc7XG5pbXBvcnQgeyBjc3MsIENsYXNzTmFtZXMsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5leHBvcnQgdHlwZSBQcm9wcyA9IHtcbiAgY29sb3I/OlxuICAgIHwgJ3NvbGlkJ1xuICAgIHwgJ25ldXRyYWw2MCdcbiAgICB8ICdzdXJmYWNlJ1xuICAgIHwgJ2luZm8nXG4gICAgfCAncHJpbWFyeSdcbiAgICB8ICdwcmltYXJ5NDAnXG4gICAgfCAnd2FybmluZydcbiAgICB8ICdlcnJvcic7XG4gIHNpemU/OiAnc21hbGwnIHwgJ21lZGl1bScgfCAnYmlnJyB8ICdzY2FsZSc7XG59O1xuZXhwb3J0IHR5cGUgU1ZHUHJvcHMgPSBQcm9wcyAmIHtcbiAgY2xhc3NOYW1lOiBzdHJpbmc7XG59O1xuY29uc3QgaWNvblNpemVzID0ge1xuICBzbWFsbDogMTIsXG4gIG1lZGl1bTogMTYsXG4gIGJpZzogMjQsXG59IGFzIGNvbnN0O1xuXG5jb25zdCBnZXRTaXplRGltZW5zaW9ucyA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ3NjYWxlJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICAgIGhlaWdodDogJ2F1dG8nLFxuICAgICAgfTtcblxuICAgIGNhc2UgJ3NtYWxsJzpcbiAgICBjYXNlICdtZWRpdW0nOlxuICAgIGNhc2UgJ2JpZyc6XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogYCR7aWNvblNpemVzW3NpemVdfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgfTtcblxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogYCR7aWNvblNpemVzLmJpZ31weGAsXG4gICAgICAgIGhlaWdodDogYCR7aWNvblNpemVzLmJpZ31weGAsXG4gICAgICB9O1xuICB9XG59O1xuXG5jb25zdCBnZXRTaXplU3R5bGUgPSAoc2l6ZTogUHJvcHNbJ3NpemUnXSkgPT4ge1xuICBjb25zdCBkaW1lbnNpb25zID0gZ2V0U2l6ZURpbWVuc2lvbnMoc2l6ZSk7XG5cbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgJjpub3QoOnJvb3QpIHtcbiAgICAgICAgICB3aWR0aDogJHtkaW1lbnNpb25zLndpZHRofTtcbiAgICAgICAgICBoZWlnaHQ6ICR7ZGltZW5zaW9ucy5oZWlnaHR9O1xuICAgICAgICB9XG4gICAgICBgO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBgXG4gICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICBoZWlnaHQ6ICR7ZGltZW5zaW9ucy5oZWlnaHR9O1xuICAgICAgYDtcbiAgfVxufTtcblxuY29uc3QgZ2V0Q29sb3IgPSAoY29sb3I6IFByb3BzWydjb2xvciddLCB0aGVtZTogVGhlbWUpID0+IHtcbiAgaWYgKCFjb2xvcikgcmV0dXJuICdpbmhlcml0JztcbiAgY29uc3Qgb3ZlcndyaXR0ZW5WYXJzID0geyAuLi52YXJzLCAuLi50aGVtZSB9O1xuICBsZXQgaWNvbkNvbG9yO1xuXG4gIHN3aXRjaCAoY29sb3IpIHtcbiAgICBjYXNlICdzb2xpZCc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JTb2xpZDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnbmV1dHJhbDYwJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvck5ldXRyYWw2MDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnc3VyZmFjZSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JTdXJmYWNlO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdpbmZvJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckluZm87XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ3ByaW1hcnknOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeTQwJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclByaW1hcnk0MDtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAnd2FybmluZyc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JXYXJuaW5nO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdlcnJvcic6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JFcnJvcjtcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgaWYgKCFpY29uQ29sb3IpIHtcbiAgICB3YXJuaW5nKFxuICAgICAgY29sb3IsXG4gICAgICBgdWkta2l0L0ljb246IHRoZSBzcGVjaWZpZWQgY29sb3IgJyR7Y29sb3J9JyBpcyBub3Qgc3VwcG9ydGVkLmBcbiAgICApO1xuICAgIHJldHVybiAnaW5oZXJpdCc7XG4gIH1cblxuICByZXR1cm4gaWNvbkNvbG9yO1xufTtcblxuZXhwb3J0IGNvbnN0IGdldEljb25TdHlsZXMgPSAocHJvcHM6IFByb3BzLCB0aGVtZTogVGhlbWUpID0+IGNzc2BcbiAgKjpub3QoW2ZpbGw9J25vbmUnXSkge1xuICAgIGZpbGw6ICR7Z2V0Q29sb3IocHJvcHMuY29sb3IsIHRoZW1lKX07XG4gIH1cbiAgJixcbiAgaW1hZ2Uge1xuICAgICR7Z2V0U2l6ZVN0eWxlKHByb3BzLnNpemUpfTtcbiAgfVxuICBmbGV4LXNocmluazogMDtcbmA7XG5cbmNvbnN0IFN2Z1RhZ011bHRpID0gKHByb3BzOiBTVkdQcm9wcykgPT4gKFxuICA8c3ZnXG4gICAgd2lkdGg9ezI0fVxuICAgIGhlaWdodD17MjR9XG4gICAgdmlld0JveD1cIjAgMCAyNCAyNFwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gICAgey4uLnByb3BzfVxuICA+XG4gICAgPHBhdGhcbiAgICAgIGQ9XCJNMjAuNzIgMTEuNTZMMTIuOTcgNEg3LjQ3N0M2Ljc3MiA0IDYuMiA0LjU1OCA2LjIgNS4yNDZ2NS4zNmw3Ljc0OCA3LjU2YS45NzQuOTc0IDAgMDAxLjM1NSAwbDUuNDE2LTUuMjg1YS45MTguOTE4IDAgMDAwLTEuMzJ6TTkuMDU1IDYuNzg3YS45NzQuOTc0IDAgMDEtMS4zNTQgMCAuOTE4LjkxOCAwIDAxMC0xLjMyLjk3NS45NzUgMCAwMTEuMzU0IDAgLjkxOC45MTggMCAwMTAgMS4zMnptLTQuMzggNC4wN2wyLjE4NiA3Ljk1NS0zLjE1Mi0uODIzYS45MzMuOTMzIDAgMDEtLjY3Ny0xLjE0NWwxLjY0NC01Ljk4NnptMS44MTYgMS43OTZsNi41MSA2LjM1MS0zLjUyMi45MjFhLjk2MS45NjEgMCAwMS0xLjE3Mi0uNjZsLTEuODE2LTYuNjEyelwiXG4gICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuU3ZnVGFnTXVsdGkuZGlzcGxheU5hbWUgPSAnU3ZnVGFnTXVsdGknO1xuXG5jb25zdCBUYWdNdWx0aUljb24gPSAocHJvcHM6IFByb3BzKSA9PiB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcbiAgcmV0dXJuIChcbiAgICA8Q2xhc3NOYW1lcz5cbiAgICAgIHsoeyBjc3M6IGNyZWF0ZUNsYXNzIH0pID0+IChcbiAgICAgICAgPFN2Z1RhZ011bHRpXG4gICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAgIGNsYXNzTmFtZT17Y3JlYXRlQ2xhc3MoZ2V0SWNvblN0eWxlcyhwcm9wcywgdGhlbWUpKX1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgPC9DbGFzc05hbWVzPlxuICApO1xufTtcblxuVGFnTXVsdGlJY29uLmRpc3BsYXlOYW1lID0gJ1RhZ011bHRpSWNvbic7XG5leHBvcnQgZGVmYXVsdCBUYWdNdWx0aUljb247XG4iXX0= */");
};

var SvgTagMulti = function SvgTagMulti(props) {
  return jsx("svg", _objectSpread$b(_objectSpread$b({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.72 11.56L12.97 4H7.477C6.772 4 6.2 4.558 6.2 5.246v5.36l7.748 7.56a.974.974 0 001.355 0l5.416-5.285a.918.918 0 000-1.32zM9.055 6.787a.974.974 0 01-1.354 0 .918.918 0 010-1.32.975.975 0 011.354 0 .918.918 0 010 1.32zm-4.38 4.07l2.186 7.955-3.152-.823a.933.933 0 01-.677-1.145l1.644-5.986zm1.816 1.796l6.51 6.351-3.522.921a.961.961 0 01-1.172-.66l-1.816-6.612z",
      fillRule: "evenodd"
    })
  }));
};

SvgTagMulti.displayName = 'SvgTagMulti';

var TagMultiIcon = function TagMultiIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgTagMulti, _objectSpread$b(_objectSpread$b({}, props), {}, {
        className: createClass(getIconStyles$b(props, theme))
      }));
    }
  });
};

TagMultiIcon.displayName = 'TagMultiIcon';
var TagMultiIcon$1 = TagMultiIcon;

function ownKeys$a(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$a(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$a(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$a = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$a = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$a[size], "px"),
        height: "".concat(iconSizes$a[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$a.big, "px"),
        height: "".concat(iconSizes$a.big, "px")
      };
  }
};

var getSizeStyle$a = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$a(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$a = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$a(_objectSpread$a({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$a = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$a(props.color, theme), ";}&,image{", getSizeStyle$a(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgTagStacked = function SvgTagStacked(props) {
  return jsx("svg", _objectSpread$a(_objectSpread$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("path", {
      fillRule: "evenodd",
      d: "M17.524 14.792a.07.07 0 01.003.004c.59.644.644 1.36.073 1.915-2.197 2.331-3.448 3.638-3.782 3.95-.488.453-1.072.453-1.644-.007L7 15.633v-5.155l.9.887v1.84l4.847 4.705c.21.168.323.168.48.022.311-.29 1.567-1.601 3.753-3.92.178-.173.186-.31-.14-.63l-.678-.766.596-.668c.15.148.739.787.769.848.59.644.644 1.36.073 1.915l-.076.08zm-.62.656c-1.767 1.872-2.79 2.936-3.086 3.212-.488.454-1.072.454-1.644-.006l-4.273-4.147v.698l4.846 4.705c.21.168.323.168.48.022.311-.29 1.567-1.601 3.753-3.92.165-.161.184-.29-.075-.564zM11.49 3.001l5.852 6.442a.744.744 0 010 1.07l-4.022 4.145a.79.79 0 01-1.099 0L6 8.357V4.01C6 3.452 6.464 3 7.036 3h4.454zM7.028 6.07a.79.79 0 001.098 0 .744.744 0 000-1.071.79.79 0 00-1.098 0 .744.744 0 000 1.07z"
    })
  }));
};

SvgTagStacked.displayName = 'SvgTagStacked';

var TagStackedIcon = function TagStackedIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgTagStacked, _objectSpread$a(_objectSpread$a({}, props), {}, {
        className: createClass(getIconStyles$a(props, theme))
      }));
    }
  });
};

TagStackedIcon.displayName = 'TagStackedIcon';
var TagStackedIcon$1 = TagStackedIcon;

function ownKeys$9(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$9(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$9(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$9 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$9 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$9[size], "px"),
        height: "".concat(iconSizes$9[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$9.big, "px"),
        height: "".concat(iconSizes$9.big, "px")
      };
  }
};

var getSizeStyle$9 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$9(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$9 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$9(_objectSpread$9({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$9 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$9(props.color, theme), ";}&,image{", getSizeStyle$9(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgTag = function SvgTag(props) {
  return jsx("svg", _objectSpread$9(_objectSpread$9({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.659 12.424L11.235 3 4.554 3C3.696 3 3 3.696 3 4.553v6.683l9.424 9.423a1.164 1.164 0 001.647 0l6.587-6.588a1.164 1.164 0 000-1.647zM6.474 6.474A1.164 1.164 0 114.827 4.83a1.164 1.164 0 011.647 1.644z",
      fillRule: "evenodd"
    })
  }));
};

SvgTag.displayName = 'SvgTag';

var TagIcon = function TagIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgTag, _objectSpread$9(_objectSpread$9({}, props), {}, {
        className: createClass(getIconStyles$9(props, theme))
      }));
    }
  });
};

TagIcon.displayName = 'TagIcon';
var TagIcon$1 = TagIcon;

function ownKeys$8(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$8(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$8(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$8 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$8 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$8[size], "px"),
        height: "".concat(iconSizes$8[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$8.big, "px"),
        height: "".concat(iconSizes$8.big, "px")
      };
  }
};

var getSizeStyle$8 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$8(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$8 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$8(_objectSpread$8({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$8 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$8(props.color, theme), ";}&,image{", getSizeStyle$8(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgTerminal = function SvgTerminal(props) {
  return jsx("svg", _objectSpread$8(_objectSpread$8({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fillRule: "evenodd",
      fill: "#1A1A1A",
      children: jsx("path", {
        d: "M5.753 13.405l2.796-2.75a.427.427 0 01.612 0 .41.41 0 010 .602l-2.49 2.448 2.49 2.449a.41.41 0 010 .601.435.435 0 01-.306.13.435.435 0 01-.306-.13l-2.796-2.727a.42.42 0 01-.131-.301.47.47 0 01.13-.322zm4.413 2.856l3.015-5.498c.11-.215.372-.28.59-.172.219.108.284.365.175.58l-3.015 5.498a.461.461 0 01-.393.237c-.066 0-.131-.022-.197-.043-.218-.13-.306-.387-.175-.602zm4.763-4.983a.41.41 0 010-.6.427.427 0 01.612 0l2.797 2.748a.42.42 0 01.13.3.42.42 0 01-.13.302l-2.797 2.749a.436.436 0 01-.306.129.434.434 0 01-.306-.13.41.41 0 010-.6l2.49-2.45-2.49-2.448zM3 17.034c0 .838.677 1.504 1.53 1.504H19.56c.852 0 1.53-.666 1.53-1.504V8.873H3v8.161zM8.086 6.504c0-.482.385-.879.853-.879.469 0 .853.397.853.879s-.384.878-.853.878c-.468 0-.853-.396-.853-.878zm-2.324 0c0-.482.384-.879.853-.879.468 0 .853.397.853.879s-.385.878-.853.878c-.469 0-.853-.396-.853-.878zm-2.325 0c0-.482.385-.879.853-.879.468 0 .853.397.853.879s-.385.878-.853.878c-.468 0-.853-.396-.853-.878zm1.092-1.658C3.677 4.846 3 5.535 3 6.4v1.667h18.09V6.4c0-.844-.699-1.555-1.529-1.555H4.529z"
      })
    })
  }));
};

SvgTerminal.displayName = 'SvgTerminal';

var TerminalIcon = function TerminalIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgTerminal, _objectSpread$8(_objectSpread$8({}, props), {}, {
        className: createClass(getIconStyles$8(props, theme))
      }));
    }
  });
};

TerminalIcon.displayName = 'TerminalIcon';
var TerminalIcon$1 = TerminalIcon;

function ownKeys$7(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$7(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$7(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$7 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$7 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$7[size], "px"),
        height: "".concat(iconSizes$7[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$7.big, "px"),
        height: "".concat(iconSizes$7.big, "px")
      };
  }
};

var getSizeStyle$7 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$7(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$7 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$7(_objectSpread$7({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$7 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$7(props.color, theme), ";}&,image{", getSizeStyle$7(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgTreeStructure = function SvgTreeStructure(props) {
  return jsx("svg", _objectSpread$7(_objectSpread$7({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M11.25 4.91V4.5H15v-.495C15 3.45 15.448 3 15.999 3H18.5c.552 0 .999.445.999 1.005v1.74c0 .555-.448 1.005-.999 1.005H16A.999.999 0 0115 5.745V5.22h-3.03v6.03H15v-.495c0-.555.448-1.005.999-1.005H18.5c.552 0 .999.445.999 1.005v1.74c0 .555-.448 1.005-.999 1.005H16A.999.999 0 0115 12.495v-.525h-3.03v6.78H15v-.495c0-.555.448-1.005.999-1.005H18.5c.552 0 .999.445.999 1.005v1.74c0 .555-.448 1.005-.999 1.005H16A.999.999 0 0115 19.995v-.525h-3.75v-7.5h-3v-.72h3V4.91zm-7.5 5.845c0-.555.448-1.005.999-1.005H7.25c.552 0 .999.445.999 1.005v1.74c0 .555-.448 1.005-.999 1.005H4.75a.999.999 0 01-.999-1.005v-1.74z",
      fillRule: "evenodd"
    })
  }));
};

SvgTreeStructure.displayName = 'SvgTreeStructure';

var TreeStructureIcon = function TreeStructureIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgTreeStructure, _objectSpread$7(_objectSpread$7({}, props), {}, {
        className: createClass(getIconStyles$7(props, theme))
      }));
    }
  });
};

TreeStructureIcon.displayName = 'TreeStructureIcon';
var TreeStructureIcon$1 = TreeStructureIcon;

function ownKeys$6(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$6(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$6(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$6 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$6 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$6[size], "px"),
        height: "".concat(iconSizes$6[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$6.big, "px"),
        height: "".concat(iconSizes$6.big, "px")
      };
  }
};

var getSizeStyle$6 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$6(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$6 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$6(_objectSpread$6({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$6 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$6(props.color, theme), ";}&,image{", getSizeStyle$6(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgTruck = function SvgTruck(props) {
  return jsx("svg", _objectSpread$6(_objectSpread$6({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.19 14.308a2.9 2.9 0 00-5.535 0h-1.27V7.385l2.43-.012c1.914-.008 3.149 1.082 2.762 2.435l1.59 1.061c.454.304.833 1.008.833 1.565v1.874h-.81zm-9.75 0a2.9 2.9 0 00-5.535 0H3v-4.3A4.01 4.01 0 016.998 6h5.694v8.308h-2.251zm-2.767 3.115a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zm9.75 0a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5z",
      fillRule: "evenodd"
    })
  }));
};

SvgTruck.displayName = 'SvgTruck';

var TruckIcon = function TruckIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgTruck, _objectSpread$6(_objectSpread$6({}, props), {}, {
        className: createClass(getIconStyles$6(props, theme))
      }));
    }
  });
};

TruckIcon.displayName = 'TruckIcon';
var TruckIcon$1 = TruckIcon;

function ownKeys$5(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$5(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$5(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$5 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$5 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$5[size], "px"),
        height: "".concat(iconSizes$5[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$5.big, "px"),
        height: "".concat(iconSizes$5.big, "px")
      };
  }
};

var getSizeStyle$5 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$5(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$5 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$5(_objectSpread$5({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$5 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$5(props.color, theme), ";}&,image{", getSizeStyle$5(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgUserFilled = function SvgUserFilled(props) {
  return jsx("svg", _objectSpread$5(_objectSpread$5({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M12.107 19.998A3.533 3.533 0 0112 20c-2.696 0-7.513-3.081-7.513-3.081-.702-.714-.635-3.805.137-4.42L7.67 12c.17 0 2.75 1.965 4.313 2 .04 0 .078.004.117.008a1.11 1.11 0 01.113-.008c1.525-.035 4.042-2 4.209-2l2.97.498c.754.616.819 3.707.134 4.42 0 0-4.683 3.082-7.313 3.082-.035 0-.07 0-.105-.002zM12 13c-1.551 0-4-2.239-4-5s1.581-5 4-5 4 2.239 4 5-2.449 5-4 5z",
      fillRule: "evenodd"
    })
  }));
};

SvgUserFilled.displayName = 'SvgUserFilled';

var UserFilledIcon = function UserFilledIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgUserFilled, _objectSpread$5(_objectSpread$5({}, props), {}, {
        className: createClass(getIconStyles$5(props, theme))
      }));
    }
  });
};

UserFilledIcon.displayName = 'UserFilledIcon';
var UserFilledIcon$1 = UserFilledIcon;

function ownKeys$4(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$4(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$4(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$4 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$4 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$4[size], "px"),
        height: "".concat(iconSizes$4[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$4.big, "px"),
        height: "".concat(iconSizes$4.big, "px")
      };
  }
};

var getSizeStyle$4 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$4(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$4 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$4(_objectSpread$4({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$4 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$4(props.color, theme), ";}&,image{", getSizeStyle$4(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgUserLinear = function SvgUserLinear(props) {
  return jsx("svg", _objectSpread$4(_objectSpread$4({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M5.689 15.91c-.518-.68-.434-1.668.196-2.217l2.462-2.142.304-.265.22.337a8.775 8.775 0 00.986 1.198c.728.735 1.445 1.163 2.065 1.148.244-.006.59-.16 1.002-.446.273-.19.566-.432.869-.713a14.468 14.468 0 001.167-1.219l.228-.274.272.233 2.276 1.961c.762.656.824 1.812.149 2.552l-.164.191a24.653 24.653 0 01-1.952 2.001 14.098 14.098 0 01-1.807 1.424c-.52.336-1.008.577-1.462.71-.531.154-1.097.134-1.688-.041-1.042-.31-2.126-1.084-3.218-2.18a18.461 18.461 0 01-1.905-2.257zm3.12-3.839l-2.461 2.142c-.352.306-.401.885-.09 1.295l.13.182a17.777 17.777 0 001.703 1.991c1.019 1.022 2.017 1.735 2.923 2.004.467.138.896.153 1.288.04.38-.112.81-.323 1.278-.625.54-.35 1.118-.81 1.714-1.353a23.969 23.969 0 002.06-2.136 1.1 1.1 0 00-.078-1.578L15 12.073l.5-.042a15.151 15.151 0 01-1.228 1.285 8.884 8.884 0 01-.946.773c-.514.358-.973.562-1.386.572-.865.02-1.732-.496-2.583-1.356A9.46 9.46 0 018.284 12l.525.072zm6.636-4.211c0 2.272-2.013 4.514-3.71 4.514-1.699 0-3.712-2.242-3.712-4.514 0-2.554 1.523-4.514 3.711-4.514 2.188 0 3.711 1.96 3.711 4.514zm-6.722 0c0 1.906 1.72 3.821 3.011 3.821 1.291 0 3.011-1.915 3.011-3.821 0-2.206-1.256-3.822-3.01-3.822-1.756 0-3.012 1.616-3.012 3.822z",
      fillRule: "nonzero"
    })
  }));
};

SvgUserLinear.displayName = 'SvgUserLinear';

var UserLinearIcon = function UserLinearIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgUserLinear, _objectSpread$4(_objectSpread$4({}, props), {}, {
        className: createClass(getIconStyles$4(props, theme))
      }));
    }
  });
};

UserLinearIcon.displayName = 'UserLinearIcon';
var UserLinearIcon$1 = UserLinearIcon;

function ownKeys$3(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$3(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$3(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$3 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$3 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$3[size], "px"),
        height: "".concat(iconSizes$3[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$3.big, "px"),
        height: "".concat(iconSizes$3.big, "px")
      };
  }
};

var getSizeStyle$3 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$3(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$3 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$3(_objectSpread$3({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$3 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$3(props.color, theme), ";}&,image{", getSizeStyle$3(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgVerified = function SvgVerified(props) {
  return jsxs("svg", _objectSpread$3(_objectSpread$3({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [jsx("defs", {
      children: jsx("path", {
        d: "M4.71 15.682c.023-.212-.212-.527-.5-.776-.738-.643-1.21-1.627-1.21-2.73 0-1.135.503-2.143 1.28-2.785.292-.242.495-.612.45-.914a3.49 3.49 0 01-.041-.548c0-1.94 1.46-3.513 3.259-3.513.22 0 .439.024.648.07.353.077.77-.072 1.02-.362C10.21 3.432 11.059 3 12 3c.943 0 1.79.432 2.385 1.124.249.29.666.439 1.02.363a3 3 0 01.649-.071c1.8 0 3.257 1.573 3.257 3.513 0 .131-.007.261-.02.389-.023.212.213.527.499.776.738.643 1.21 1.627 1.21 2.73a3.626 3.626 0 01-1.036 2.563c-.269.27-.43.702-.37 1.05.037.205.055.418.055.634 0 1.94-1.46 3.513-3.257 3.513-.317 0-.622-.048-.91-.14a.926.926 0 00-.997.315C13.887 20.518 12.996 21 12 21c-.942 0-1.79-.432-2.383-1.124-.25-.29-.668-.439-1.021-.363-.21.047-.427.071-.648.071-1.8 0-3.26-1.573-3.26-3.513 0-.131.01-.261.022-.389zm10.978-6.574a.372.372 0 00-.524 0l-4.656 4.656a.372.372 0 01-.525 0l-1.147-1.146a.372.372 0 00-.525 0l-.703.703a.372.372 0 000 .525l2.375 2.374c.144.145.38.145.525 0l5.884-5.884a.372.372 0 000-.525l-.704-.703z",
        id: "verified_react_svg__a"
      })
    }), jsx("use", {
      xlinkHref: "#verified_react_svg__a",
      fillRule: "evenodd"
    })]
  }));
};

SvgVerified.displayName = 'SvgVerified';

var VerifiedIcon = function VerifiedIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgVerified, _objectSpread$3(_objectSpread$3({}, props), {}, {
        className: createClass(getIconStyles$3(props, theme))
      }));
    }
  });
};

VerifiedIcon.displayName = 'VerifiedIcon';
var VerifiedIcon$1 = VerifiedIcon;

function ownKeys$2(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$2(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$2(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$2 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$2 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$2[size], "px"),
        height: "".concat(iconSizes$2[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$2.big, "px"),
        height: "".concat(iconSizes$2.big, "px")
      };
  }
};

var getSizeStyle$2 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$2(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$2 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$2(_objectSpread$2({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$2 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$2(props.color, theme), ";}&,image{", getSizeStyle$2(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgViewGridPlus = function SvgViewGridPlus(props) {
  return jsx("svg", _objectSpread$2(_objectSpread$2({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("g", {
      fill: "#1A1A1A",
      fillRule: "nonzero",
      children: jsx("path", {
        d: "M11.5 13.9v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6a1 1 0 011 1zm0-9.9v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1zm10 0v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1zM18.5 14v1.999h2a1.001 1.001 0 010 2.001h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 012 0z"
      })
    })
  }));
};

SvgViewGridPlus.displayName = 'SvgViewGridPlus';

var ViewGridPlusIcon = function ViewGridPlusIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgViewGridPlus, _objectSpread$2(_objectSpread$2({}, props), {}, {
        className: createClass(getIconStyles$2(props, theme))
      }));
    }
  });
};

ViewGridPlusIcon.displayName = 'ViewGridPlusIcon';
var ViewGridPlusIcon$1 = ViewGridPlusIcon;

function ownKeys$1(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys$1(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys$1(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes$1 = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions$1 = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes$1[size], "px"),
        height: "".concat(iconSizes$1[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes$1.big, "px"),
        height: "".concat(iconSizes$1.big, "px")
      };
  }
};

var getSizeStyle$1 = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions$1(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor$1 = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread$1(_objectSpread$1({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles$1 = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor$1(props.color, theme), ";}&,image{", getSizeStyle$1(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIldhcm5pbmdSZWFjdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0hnRSIsImZpbGUiOiJXYXJuaW5nUmVhY3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLy8gVEhJUyBJUyBBTiBBVVRPR0VORVJBVEVEIEZJTEUuIERPIE5PVCBFRElUIFRISVMgRklMRSBESVJFQ1RMWS5cbi8vIFRoaXMgZmlsZSBpcyBjcmVhdGVkIHdpdGggJ3lhcm4gZ2VuZXJhdGUtaWNvbnMnLlxuLy8gT3JpZ2luYWwgU1ZHIGZpbGU6IHNyYy9zdmcvd2FybmluZy5yZWFjdC5zdmdcblxuLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgd2FybmluZyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcbmltcG9ydCB7IGNzcywgQ2xhc3NOYW1lcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmV4cG9ydCB0eXBlIFByb3BzID0ge1xuICBjb2xvcj86XG4gICAgfCAnc29saWQnXG4gICAgfCAnbmV1dHJhbDYwJ1xuICAgIHwgJ3N1cmZhY2UnXG4gICAgfCAnaW5mbydcbiAgICB8ICdwcmltYXJ5J1xuICAgIHwgJ3ByaW1hcnk0MCdcbiAgICB8ICd3YXJuaW5nJ1xuICAgIHwgJ2Vycm9yJztcbiAgc2l6ZT86ICdzbWFsbCcgfCAnbWVkaXVtJyB8ICdiaWcnIHwgJ3NjYWxlJztcbn07XG5leHBvcnQgdHlwZSBTVkdQcm9wcyA9IFByb3BzICYge1xuICBjbGFzc05hbWU6IHN0cmluZztcbn07XG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbn0gYXMgY29uc3Q7XG5cbmNvbnN0IGdldFNpemVEaW1lbnNpb25zID0gKHNpemU6IFByb3BzWydzaXplJ10pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc2NhbGUnOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgaGVpZ2h0OiAnYXV0bycsXG4gICAgICB9O1xuXG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgLFxuICAgICAgICBoZWlnaHQ6IGAke2ljb25TaXplc1tzaXplXX1weGAsXG4gICAgICB9O1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHdpZHRoOiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgICAgaGVpZ2h0OiBgJHtpY29uU2l6ZXMuYmlnfXB4YCxcbiAgICAgIH07XG4gIH1cbn07XG5cbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBQcm9wc1snc2l6ZSddKSA9PiB7XG4gIGNvbnN0IGRpbWVuc2lvbnMgPSBnZXRTaXplRGltZW5zaW9ucyhzaXplKTtcblxuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGBcbiAgICAgICAgd2lkdGg6ICR7ZGltZW5zaW9ucy53aWR0aH07XG4gICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICBgO1xuICB9XG59O1xuXG5jb25zdCBnZXRDb2xvciA9IChjb2xvcjogUHJvcHNbJ2NvbG9yJ10sIHRoZW1lOiBUaGVtZSkgPT4ge1xuICBpZiAoIWNvbG9yKSByZXR1cm4gJ2luaGVyaXQnO1xuICBjb25zdCBvdmVyd3JpdHRlblZhcnMgPSB7IC4uLnZhcnMsIC4uLnRoZW1lIH07XG4gIGxldCBpY29uQ29sb3I7XG5cbiAgc3dpdGNoIChjb2xvcikge1xuICAgIGNhc2UgJ3NvbGlkJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclNvbGlkO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdzdXJmYWNlJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvclN1cmZhY2U7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2luZm8nOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9ySW5mbztcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBvdmVyd3JpdHRlblZhcnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdwcmltYXJ5NDAnOlxuICAgICAgaWNvbkNvbG9yID0gb3ZlcndyaXR0ZW5WYXJzLmNvbG9yUHJpbWFyeTQwO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICd3YXJuaW5nJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvcldhcm5pbmc7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IG92ZXJ3cml0dGVuVmFycy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICBpZiAoIWljb25Db2xvcikge1xuICAgIHdhcm5pbmcoXG4gICAgICBjb2xvcixcbiAgICAgIGB1aS1raXQvSWNvbjogdGhlIHNwZWNpZmllZCBjb2xvciAnJHtjb2xvcn0nIGlzIG5vdCBzdXBwb3J0ZWQuYFxuICAgICk7XG4gICAgcmV0dXJuICdpbmhlcml0JztcbiAgfVxuXG4gIHJldHVybiBpY29uQ29sb3I7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0SWNvblN0eWxlcyA9IChwcm9wczogUHJvcHMsIHRoZW1lOiBUaGVtZSkgPT4gY3NzYFxuICAqOm5vdChbZmlsbD0nbm9uZSddKSB7XG4gICAgZmlsbDogJHtnZXRDb2xvcihwcm9wcy5jb2xvciwgdGhlbWUpfTtcbiAgfVxuICAmLFxuICBpbWFnZSB7XG4gICAgJHtnZXRTaXplU3R5bGUocHJvcHMuc2l6ZSl9O1xuICB9XG4gIGZsZXgtc2hyaW5rOiAwO1xuYDtcblxuY29uc3QgU3ZnV2FybmluZyA9IChwcm9wczogU1ZHUHJvcHMpID0+IChcbiAgPHN2Z1xuICAgIHdpZHRoPXsyNH1cbiAgICBoZWlnaHQ9ezI0fVxuICAgIHZpZXdCb3g9XCIwIDAgMjQgMjRcIlxuICAgIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIlxuICAgIHsuLi5wcm9wc31cbiAgPlxuICAgIDxwYXRoXG4gICAgICBkPVwiTTIwLjY3OCAxNy44ODdMMTMuMzcgNS4yMjljLS43NTItMS4zMDUtMS45ODctMS4zMDUtMi43NCAwTDMuMzIyIDE3Ljg4N2MtLjc1NCAxLjMwNS0uMTM3IDIuMzczIDEuMzcgMi4zNzNoMTQuNjE2YzEuNTA4IDAgMi4xMjQtMS4wNjggMS4zNy0yLjM3M3ptLTcuOTYuMDQ5YS45NzYuOTc2IDAgMDEtLjcxMi4yOTcuOTguOTggMCAwMS0uNzIxLS4yOTcuOTk0Ljk5NCAwIDAxLS4zLS43MmMwLS4yNzYuMTA0LS41MTMuMy0uNzEyLjE5Ny0uMi40MzktLjMuNzItLjMuMjc4IDAgLjUxLjEuNzEyLjNhLjk4Ljk4IDAgMDEuMjk1LjcxMWMwIC4yODEtLjA5OS41MjItLjI5NS43MnptLS4zNi0yLjI4NmgtLjcxN2MtLjk2Mi0zLjc3NC0xLjQ0MS01LjgxNC0xLjQ0MS02LjExMiAwLS4zNjQuMTg0LS42NTcuNTU3LS44OGEyLjM0NCAyLjM0NCAwIDAxMS4yNS0uMzM1Yy40OTggMCAuOTIuMTE2IDEuMjcyLjM1Ni4zNDUuMjM3LjUyLjUyLjUyLjg0NSAwIC4zMDctLjQ3NyAyLjM1Mi0xLjQ0IDYuMTI2elwiXG4gICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuU3ZnV2FybmluZy5kaXNwbGF5TmFtZSA9ICdTdmdXYXJuaW5nJztcblxuY29uc3QgV2FybmluZ0ljb24gPSAocHJvcHM6IFByb3BzKSA9PiB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcbiAgcmV0dXJuIChcbiAgICA8Q2xhc3NOYW1lcz5cbiAgICAgIHsoeyBjc3M6IGNyZWF0ZUNsYXNzIH0pID0+IChcbiAgICAgICAgPFN2Z1dhcm5pbmdcbiAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgICAgY2xhc3NOYW1lPXtjcmVhdGVDbGFzcyhnZXRJY29uU3R5bGVzKHByb3BzLCB0aGVtZSkpfVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICA8L0NsYXNzTmFtZXM+XG4gICk7XG59O1xuXG5XYXJuaW5nSWNvbi5kaXNwbGF5TmFtZSA9ICdXYXJuaW5nSWNvbic7XG5leHBvcnQgZGVmYXVsdCBXYXJuaW5nSWNvbjtcbiJdfQ== */");
};

var SvgWarning = function SvgWarning(props) {
  return jsx("svg", _objectSpread$1(_objectSpread$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M20.678 17.887L13.37 5.229c-.752-1.305-1.987-1.305-2.74 0L3.322 17.887c-.754 1.305-.137 2.373 1.37 2.373h14.616c1.508 0 2.124-1.068 1.37-2.373zm-7.96.049a.976.976 0 01-.712.297.98.98 0 01-.721-.297.994.994 0 01-.3-.72c0-.276.104-.513.3-.712.197-.2.439-.3.72-.3.278 0 .51.1.712.3a.98.98 0 01.295.711c0 .281-.099.522-.295.72zm-.36-2.286h-.717c-.962-3.774-1.441-5.814-1.441-6.112 0-.364.184-.657.557-.88a2.344 2.344 0 011.25-.335c.498 0 .92.116 1.272.356.345.237.52.52.52.845 0 .307-.477 2.352-1.44 6.126z",
      fillRule: "evenodd"
    })
  }));
};

SvgWarning.displayName = 'SvgWarning';

var WarningIcon = function WarningIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgWarning, _objectSpread$1(_objectSpread$1({}, props), {}, {
        className: createClass(getIconStyles$1(props, theme))
      }));
    }
  });
};

WarningIcon.displayName = 'WarningIcon';
var WarningIcon$1 = WarningIcon;

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context3;

      _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconSizes = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeDimensions = function getSizeDimensions(size) {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };

    case 'small':
    case 'medium':
    case 'big':
      return {
        width: "".concat(iconSizes[size], "px"),
        height: "".concat(iconSizes[size], "px")
      };

    default:
      return {
        width: "".concat(iconSizes.big, "px"),
        height: "".concat(iconSizes.big, "px")
      };
  }
};

var getSizeStyle = function getSizeStyle(size) {
  var _context, _context2;

  var dimensions = getSizeDimensions(size);

  switch (size) {
    case 'scale':
      return _concatInstanceProperty(_context = "\n        &:not(:root) {\n          width: ".concat(dimensions.width, ";\n          height: ")).call(_context, dimensions.height, ";\n        }\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(dimensions.width, ";\n        height: ")).call(_context2, dimensions.height, ";\n      ");
  }
};

var getColor = function getColor(color, theme) {
  if (!color) return 'inherit';

  var overwrittenVars = _objectSpread(_objectSpread({}, customProperties), theme);

  var iconColor;

  switch (color) {
    case 'solid':
      iconColor = overwrittenVars.colorSolid;
      break;

    case 'neutral60':
      iconColor = overwrittenVars.colorNeutral60;
      break;

    case 'surface':
      iconColor = overwrittenVars.colorSurface;
      break;

    case 'info':
      iconColor = overwrittenVars.colorInfo;
      break;

    case 'primary':
      iconColor = overwrittenVars.colorPrimary;
      break;

    case 'primary40':
      iconColor = overwrittenVars.colorPrimary40;
      break;

    case 'warning':
      iconColor = overwrittenVars.colorWarning;
      break;

    case 'error':
      iconColor = overwrittenVars.colorError;
      break;
  }

  if (!iconColor) {
    process.env.NODE_ENV !== "production" ? warning(color, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : void 0;
    return 'inherit';
  }

  return iconColor;
};

var getIconStyles = function getIconStyles(props, theme) {
  return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor(props.color, theme), ";}&,image{", getSizeStyle(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
};

var SvgWorld = function SvgWorld(props) {
  return jsx("svg", _objectSpread(_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsx("path", {
      d: "M19.708 7.36V7.35h-.005A9.003 9.003 0 0012 3c-4.963 0-9 4.037-9 9 0 1.694.471 3.28 1.288 4.635v.014h.009A9.003 9.003 0 0012 21c4.963 0 9-4.037 9-9a8.947 8.947 0 00-1.292-4.64zm-6.192 12.905a8.378 8.378 0 01-1.219.132V16.65h3.828c-.592 1.664-1.5 2.962-2.609 3.616zM7.875 16.65h3.827v3.748a8.403 8.403 0 01-1.218-.131c-1.11-.655-2.017-1.953-2.61-3.617zm2.608-12.914a8.384 8.384 0 011.22-.132V7.35H7.874c.592-1.663 1.499-2.961 2.608-3.616zm5.642 3.616h-3.828V3.603c.415.014.822.06 1.22.132 1.109.655 2.016 1.953 2.608 3.616zm.193.595c.337 1.137.534 2.414.56 3.756h-4.58V7.946h4.02zm-4.616 0v3.756h-4.58c.026-1.342.223-2.62.56-3.756h4.02zm-5.174 3.756H3.603A8.347 8.347 0 014.64 7.946h2.428a14.859 14.859 0 00-.54 3.756zm0 .596c.024 1.331.214 2.606.54 3.756H4.64a8.346 8.346 0 01-1.037-3.756h2.925zm.595 0h4.58v3.756H7.68a14.271 14.271 0 01-.558-3.756zm5.174 3.756v-3.756h4.58a14.289 14.289 0 01-.558 3.756h-4.022zm5.175-3.756h2.925a8.347 8.347 0 01-1.038 3.756h-2.427c.326-1.15.515-2.425.54-3.756zm0-.596a14.859 14.859 0 00-.54-3.756h2.427a8.347 8.347 0 011.038 3.756h-2.925zm1.525-4.35h-2.25c-.44-1.306-1.065-2.421-1.826-3.232a8.447 8.447 0 014.076 3.231zM9.08 4.12c-.761.81-1.385 1.926-1.827 3.231h-2.25A8.449 8.449 0 019.08 4.12zM5.002 16.649h2.25c.442 1.306 1.066 2.42 1.827 3.232a8.45 8.45 0 01-4.077-3.232zm9.92 3.231c.76-.81 1.384-1.925 1.825-3.231h2.25a8.45 8.45 0 01-4.076 3.231z",
      fillRule: "evenodd"
    })
  }));
};

SvgWorld.displayName = 'SvgWorld';

var WorldIcon = function WorldIcon(props) {
  var theme = useTheme();
  return jsx(ClassNames, {
    children: function children(_ref) {
      var createClass = _ref.css;
      return jsx(SvgWorld, _objectSpread(_objectSpread({}, props), {}, {
        className: createClass(getIconStyles(props, theme))
      }));
    }
  });
};

WorldIcon.displayName = 'WorldIcon';
var WorldIcon$1 = WorldIcon;
export { AngleDownIcon$1 as AngleDownIcon, AngleLeftIcon$1 as AngleLeftIcon, AngleRightIcon$1 as AngleRightIcon, AngleThinLeftIcon$1 as AngleThinLeftIcon, AngleThinRightIcon$1 as AngleThinRightIcon, AngleUpDownIcon$1 as AngleUpDownIcon, AngleUpIcon$1 as AngleUpIcon, ArrowDownIcon$1 as ArrowDownIcon, ArrowLeftIcon$1 as ArrowLeftIcon, ArrowLongDownIcon$1 as ArrowLongDownIcon, ArrowRightIcon$1 as ArrowRightIcon, ArrowTriangleDownIcon$1 as ArrowTriangleDownIcon, ArrowTriangleUpIcon$1 as ArrowTriangleUpIcon, ArrowUpIcon$1 as ArrowUpIcon, ArrowsIcon$1 as ArrowsIcon, BackIcon$1 as BackIcon, BidirectionalArrowIcon$1 as BidirectionalArrowIcon, BinFilledIcon$1 as BinFilledIcon, BinLinearIcon$1 as BinLinearIcon, BoxIcon$1 as BoxIcon, BrainIcon$1 as BrainIcon, CalendarIcon$1 as CalendarIcon, CameraIcon$1 as CameraIcon, CaretDownIcon$1 as CaretDownIcon, CaretUpIcon$1 as CaretUpIcon, CartIcon$1 as CartIcon, ChainBrokenIcon$1 as ChainBrokenIcon, ChainIcon$1 as ChainIcon, CheckActiveIcon$1 as CheckActiveIcon, CheckBoldIcon$1 as CheckBoldIcon, CheckInactiveIcon$1 as CheckInactiveIcon, CheckThinIcon$1 as CheckThinIcon, CircleIcon$1 as CircleIcon, ClipboardIcon$1 as ClipboardIcon, ClockIcon$1 as ClockIcon, ClockWithArrowIcon$1 as ClockWithArrowIcon, CloseBoldIcon$1 as CloseBoldIcon, CloseIcon$1 as CloseIcon, CodeViewIcon$1 as CodeViewIcon, CoinsIcon$1 as CoinsIcon, ColumnsIcon$1 as ColumnsIcon, ConnectedSquareIcon$1 as ConnectedSquareIcon, ConnectedTriangleIcon$1 as ConnectedTriangleIcon, CopyIcon$1 as CopyIcon, CubeIcon$1 as CubeIcon, CubesIcon$1 as CubesIcon, DotIcon$1 as DotIcon, DownloadIcon$1 as DownloadIcon, DragDropIcon$1 as DragDropIcon, DragIcon$1 as DragIcon, EditIcon$1 as EditIcon, ErrorIcon$1 as ErrorIcon, ExpandIcon$1 as ExpandIcon, ExportIcon$1 as ExportIcon, ExternalLinkIcon$1 as ExternalLinkIcon, EyeCrossedIcon$1 as EyeCrossedIcon, EyeIcon$1 as EyeIcon, FilterAndListIcon$1 as FilterAndListIcon, FilterIcon$1 as FilterIcon, FlagFilledIcon$1 as FlagFilledIcon, FlagLinearIcon$1 as FlagLinearIcon, FlameIcon$1 as FlameIcon, FractionDigitsIcon$1 as FractionDigitsIcon, GearIcon$1 as GearIcon, GraduationCapIcon$1 as GraduationCapIcon, GraphIcon$1 as GraphIcon, GridIcon$1 as GridIcon, HeartIcon$1 as HeartIcon, ImportIcon$1 as ImportIcon, InfoIcon$1 as InfoIcon, InformationIcon$1 as InformationIcon, ListIcon$1 as ListIcon, ListWithSearchIcon$1 as ListWithSearchIcon, LockIcon$1 as LockIcon, LogoutIcon$1 as LogoutIcon, MailIcon$1 as MailIcon, MinimizeIcon$1 as MinimizeIcon, NestedViewIcon$1 as NestedViewIcon, OperationsIcon$1 as OperationsIcon, PageGearIcon$1 as PageGearIcon, PagesIcon$1 as PagesIcon, PaperBillInvertedIcon$1 as PaperBillInvertedIcon, PaperclipIcon$1 as PaperclipIcon, PinFilledIcon$1 as PinFilledIcon, PinGearIcon$1 as PinGearIcon, PinLinearIcon$1 as PinLinearIcon, PluginIcon$1 as PluginIcon, PlusBoldIcon$1 as PlusBoldIcon, PlusThinIcon$1 as PlusThinIcon, RefreshIcon$1 as RefreshIcon, RestoreIcon$1 as RestoreIcon, RevertIcon$1 as RevertIcon, ReviewIcon$1 as ReviewIcon, RightTriangleFilledIcon$1 as RightTriangleFilledIcon, RightTriangleLinearIcon$1 as RightTriangleLinearIcon, RocketIcon$1 as RocketIcon, ScreenGearIcon$1 as ScreenGearIcon, ScreenUserIcon$1 as ScreenUserIcon, SearchIcon$1 as SearchIcon, SortingIcon$1 as SortingIcon, SpeechBubbleIcon$1 as SpeechBubbleIcon, SpeedometerIcon$1 as SpeedometerIcon, SplitIcon$1 as SplitIcon, StackIcon$1 as StackIcon, StarIcon$1 as StarIcon, SubdirectoryArrowIcon$1 as SubdirectoryArrowIcon, SupportIcon$1 as SupportIcon, SwitcherIcon$1 as SwitcherIcon, TableIcon$1 as TableIcon, TagIcon$1 as TagIcon, TagMultiIcon$1 as TagMultiIcon, TagStackedIcon$1 as TagStackedIcon, TerminalIcon$1 as TerminalIcon, TreeStructureIcon$1 as TreeStructureIcon, TruckIcon$1 as TruckIcon, UserFilledIcon$1 as UserFilledIcon, UserLinearIcon$1 as UserLinearIcon, VerifiedIcon$1 as VerifiedIcon, ViewGridPlusIcon$1 as ViewGridPlusIcon, WarningIcon$1 as WarningIcon, WorldIcon$1 as WorldIcon };